export const es = {
    addDatabase: {
        addDatabase: "Agregar base de datos",
        addFromFile: "Agregar desde archivo",
        analyse: "Analisis",
        analysingYourData: "Analizando tus datos",
        createFromExcel: "Creado desde Excel",
        databaseImport: "ImportaciÃ³n de Base de Datos",
        databaseNotImported: "La importaciÃ³n ha finalizado con errores",
        databasePrepared: "Base de Datos lista sin errores",
        excelFile: "Archivo Excel",
        fileInformation: "InformaciÃ³n del archivo",
        fixErrors: "Para continuar, corrija por favor los siguientes errores y vuelva a intentarlo",
        importingYourData: "Importando tus datos",
        productFilesPath: "Ruta de los archivos del producto",
        productImagesPath: "Ruta de las imÃ¡genes del producto"
    },
    availablePrice: {
        allPackage: "Todos los envases",
        onePackage: "Un envase",
        priceType: "Tipo de precio",
        setPriceVatVisibility: "Visibilidad del IVA",
        setVisibilityAndOrder: "Establecer la visibilidad y el orden de los tipos de precios",
        withAndWithoutVat: "Tanto con IVA como sin IVA",
        withVat: "Solo con IVA",
        withoutVat: "Solo sin IVA"
    },
    barvis: {
        base: "Nombre de base",
        bigCanSize: "Envases grandes",
        coating: "Revestimiento",
        identifier: "Identificador",
        laboratory: "Laboratorio",
        orderOverview: "Resumen de pedidos",
        rank: "ClasificaciÃ³n",
        smallCanSize: "Envases pequeÃ±os"
    },
    basicSetup: {
        alreadyLoggedIn: "Ya ha iniciado sesiÃ³n como %{login}.",
        askSupplier: "PÃ­dale a su proveedor de software que le asigne mÃ¡s licencias.",
        asterisk: "Los artÃ­culos marcados con un asterisco deben rellenarse.",
        identificationKeys: "Claves de identificaciÃ³n",
        importCustomData: "Si procede, importe los datos personalizados desde el software de dosificaciÃ³n anterior.",
        learnIdentification: "Obtenga informaciÃ³n sobre las claves de identificaciÃ³n de su proveedor de software.",
        login: "Los siguientes pasos de la configuraciÃ³n inicial requieren derechos de administrador.",
        noDatabase: "AÃºn no se ha agregado ninguna base de datos, se debe insertar al menos una.",
        offlineLicensing: "Licencias sin conexiÃ³n",
        productSelection: "SelecciÃ³n de productos",
        registrationForm: "Formulario de inscripciÃ³n",
        seeQuestionMark:
            "Consulte los pequeÃ±os signos de interrogaciÃ³n para obtener mÃ¡s informaciÃ³n sobre la configuraciÃ³n.",
        selectDefaultPrinter: "Seleccione la impresora predeterminada y establezca una configuraciÃ³n adicional.  ",
        selectDefaultTemplate:
            "Seleccione las plantillas predeterminadas de las ya existentes, cree una nueva plantilla o cargue las suyas propias.",
        selectDispenser: "Seleccione el tipo de dispensador que estÃ¡ utilizando.",
        selectLanguage: "Seleccione su idioma.",
        selectProducts: "Seleccione uno de los productos disponibles que desea activar.",
        selectSpectroType: "Seleccione el tipo de espectrofotÃ³metro que estÃ¡ utilizando.",
        setAdditionalPrinterOptions: "Establecer opciones de impresora adicionales.",
        setAutomaticUpdates: "Establecer las opciones de actualizaciones automÃ¡ticas.",
        setCustomItems:
            "Establecer los elementos personalizados y la visibilidad de los datos. DesplÃ¡cese hacia abajo para ver mÃ¡s opciones.",
        setEnvironment: "Establecer el entorno general del software. DesplÃ¡cese hacia abajo para ver mÃ¡s opciones.",
        setFormulaRepresentation:
            "Establecer la representaciÃ³n de fÃ³rmula. DesplÃ¡cese hacia abajo para ver mÃ¡s opciones.",
        summary:
            "Puede cambiar esta configuraciÃ³n en cualquier momento y encontrar aÃºn mÃ¡s opciones de configuraciÃ³n. Â¡Disfruta usando %{name}!",
        summarySuccess: "Â¡Ya estÃ¡ listo!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "NÃºmero de lote: %{batchNumber}",
        colorantIsDefective: "El depÃ³sito se llenÃ³ con un lote de colorante no conforme. No utilizar este lote.",
        defectiveInfoLine1: "Por favor, no utilice colorante",
        defectiveInfoLine2: "con este nÃºmero de lote",
        emptyQuickTint: "Vaciar el depÃ³sito usando Tintado RÃ¡pido.",
        warningInfoLine1: "Colorante",
        warningInfoLine2: "con este nÃºmero de lote puede resultar daÃ±ado."
    },
    canisterLevel: {
        canisterLevel: "Establecer niveles de depÃ³sitos",
        criticalLevelCanister: "Niveles crÃ­ticos de depÃ³sitos",
        fillToMax: "Llenar al mÃ¡ximo",
        maxDispenseLevel: "Dispensar mÃ¡ximo",
        otherCanisters: "Otros depÃ³sitos",
        warningLevelCanister: "Nivel crÃ­tico de depÃ³sitos"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "NÃºmero de lote de relleno",
        ufiCodeStatus: "Estado del cÃ³digo UFI"
    },
    canistersTab: {
        availableServiceActions: "Acciones de servicio disponibles",
        canisterInformation: "InformaciÃ³n de depÃ³sito",
        canisterPreview: "Vista previa del depÃ³sito",
        currentLevel: "Nivel actual",
        errors: "Errores",
        fillState: "Estado de relleno",
        fillToMax: "Llenar al mÃ¡ximo",
        fillingAmount: "Cantidad de llenado",
        finalLevel: "Nivel final",
        minimumAmount: "Cantidad mÃ­nima",
        minimumLevel: "Nivel mÃ­nimo",
        moveTableToRefill: "Mover mesa para el relleno",
        refillNoAmount: "No se ha introducido ninguna cantidad",
        refillOverLimit: "El importe ingresado supera la capacidad mÃ¡xima del depÃ³sito",
        refillSummary: "%{amount} %{unit} del colorante %{colorant} se agregarÃ¡ al contenedor %{canisterId}.",
        systemWarningAmount: "Cantidad de advertencia del sistema",
        warningAmount: "Cantidad de advertencia"
    },
    changeDatabase: {
        changeDatabase: "Cambiar base de datos",
        databaseWarning: "Database %{databaseName} no puede utilizarse debido a"
    },
    changelog: {
        allVersion: "Todas las versiones",
        changelog: "Registro de cambios",
        link: "Enlace",
        links: "Enlaces",
        version: "VersiÃ³n",
        versionFilter: "VersiÃ³n del filtro"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "No hay suficiente colorante en los depÃ²sitos para %{numOfPackages} envases.",
        fillAdditionally: "Rellenar adicionalmente",
        refillToMax: "Rellenar al mÃ¡ximo"
    },
    cleanChannels: {
        cleanAllChannels: "Limpiar todos los circuitos",
        cleanChannels: "Circuitos limpios",
        cleaningTime: "DuraciÃ³n de limpieza",
        selectChannels: "Seleccionar circuitos",
        startCleaning: "Iniciar la limpieza"
    },
    clientServerSettings: {
        activeServer: "Activar el servidor",
        addNewServer: "Agregar nuevo servidor",
        availableServers: "Otros servidores disponibles",
        clientIdentifier: "Identificador del cliente",
        clientServerSettings: "ConfiguraciÃ³n del cliente/servidor",
        disabledStatus: "desactivado",
        editServer: "Editar servidor",
        fillRequiredFields: "Los campos obligatorios deben rellenarse",
        noOtherServers: "No hay otros servidores disponibles",
        offlineStatus: "Desconectado",
        onlineStatus: "conectado",
        port: "Puerto",
        serverName: "Nombre del servidor",
        serverNameMissing: "El nombre del servidor debe rellenarse",
        stabileConnection: "Para garantizar una conexiÃ³n estable, utilice la direcciÃ³n IP estÃ¡tica.",
        wrongFormatIp: "Formato incorrecto de la direcciÃ³n IP"
    },
    colorSearchTab: {
        notEveryItemSelected: "Uno o mÃ¡s elementos no seleccionados"
    },
    colorTab: {
        colorTone: "Tono de color",
        fandeckPosition: "PosiciÃ³n de la carta de colores",
        moreInfoIcons: "MÃ¡s iconos de informaciÃ³n",
        notExistingFormula: "FÃ³rmula inexistente",
        orderBy: "Ordenar por",
        selectYourGrid: "Seleccione su cuadrÃ­cula",
        showInPanel: "Mostrar en panel",
        warningIcon: "Icono de advertencia de fÃ³rmula inexistente"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Utilizar los nÃºmeros de lote por porcentaje",
        batchNumberFromLastFilling: "Utilizar los nÃºmeros de lote del Ãºltimo llenado",
        defectiveBatchOfColorant: "Lote de colorantes defectuoso",
        enableBatchNumber: "ActivaciÃ³n de nÃºmeros de lote de colorantes",
        possibleDamagedBatchOfColorant: "Lote de colorante posiblemente daÃ±ado",
        scanOrTypeBatchNumber: "Escanear o teclear NÃºmero de lote"
    },
    colorantPanel: {
        manualMachine: "mÃ¡quina"
    },
    colorantsTable: {
        numberOfColorants: "Cantidad de colorantes:",
        preview: "Vista previa",
        prices: "Precios"
    },
    currencySettings: {
        addNewCurrency: "Agregar una nueva moneda",
        codePlaceholder: "CÃ³digo",
        currencySettings: "Ajustes de moneda",
        namePlaceholder: "Nombre",
        ratePlaceholder: "Cambio",
        setDecimalPlaces: "Establecer el nÃºmero de decimales",
        setMainCurrency: "Establecer moneda principal",
        setRounding: "Redondeo",
        symbolPlaceholder: "SÃ­mbolo"
    },
    customFandecks: {
        customFandecks: "Colecciones personales",
        deleteButtonWarning: "TambiÃ©n se eliminarÃ¡n todas las fÃ³rmulas de la carta de colores",
        deleteCustomFandeck:
            "Â¿Realmente quiere eliminar esta carpeta de colores personalizados? Todas las fÃ³rmulas de Ã©sta tambiÃ©n se eliminarÃ¡n.",
        disableStandardFandecks: "Mostrar sÃ³lo las Cartas de colores personales",
        enableStandardFandecks: "Mostrar sÃ³lo las Cartas de colores estÃ¡ndar",
        fandeckName: "Nombre de la carta de colores"
    },
    customRedlike: {
        addColorantFromBrand: "AÃ±adir colorante desde la marca %{brandName}",
        addNewCustomer: "AÃ±adir un cliente nuevo",
        addNewNote: "AÃ±adir una nota",
        addedDate: "Fecha aÃ±adida",
        addedQuantity: "Cantidad aÃ±adida",
        availableMachine: "MÃ¡quina disponible",
        brand: "Marca",
        brandPlease: "Por favor, seleccione una marca",
        cancelCustomer: "Cancelar cliente",
        colorPlease: "Por favor, selecciona el color",
        confirmCustomerData: "Confirmar los datos del cliente",
        confirmNoteData: "Confirmar los datos de la nota",
        confirmSelectedUser: "Â¿Desea utilizar el cliente %{customerName} para este pedido?",
        confirmed: "Confirmado",
        controlData: "Control de datos final",
        customerCellNumber: "NÃºmero de tel. del cliente",
        customerFilter: "Filtro de clientes",
        customerName: "Nombre del cliente",
        customerPhone: "TelÃ©fono del cliente",
        customerPlease: "Por favor, seleccione un cliente",
        dateFilter: "Filtro de fecha",
        enterPin: "Introduzca su cÃ³digo pin",
        enterTheNumberOfPackages: "Introduzca la cantidad de envases",
        existingCustomer: "El usuario ya existe",
        fandeckPlease: "Seleccione una carta de colores",
        fillCanisterHistory: "Historial de llenado del depÃ³sito",
        findCustomer:
            "Para asignar tarjeta de fidelizaciÃ³n a este pedido, escanee cÃ³digo de barras o busque la direcciÃ³n de correo electrÃ³nico",
        findCustomerByEmail: "Filtrar al cliente por correo electrÃ³nico o cÃ³digo de barras",
        finishPreviousStep: "(Finalice el paso anterior)",
        formulaUnit: "Unidad de fÃ³rmula",
        getBackToList: "Vuelve a la lista de clientes",
        historyOfOrders: "Historial de pedidos",
        insertNote: "Ir a agregar una nota",
        loadHistoryOrder: "Â¿Quiere cargar el pedido seleccionado?",
        loyaltyCards: "Tarjetas de fidelizaciÃ³n",
        machineIsAvailable: "LA MÃQUINA ESTÃ DISPONIBLE",
        machineIsUnavailable: "LA MÃQUINA NO ESTÃ DISPONIBLE",
        newLoyaltyCard: "Nueva tarjeta de fidelizaciÃ³n",
        noAvailableMachine: "La mÃ¡quina no estÃ¡ disponible",
        noCustomerSelected: "No se ha seleccionado ningÃºn cliente. Â¿Quiere continuar?",
        notePlease: "Por favor, agregue una nota",
        openHistory: "Abra el historial",
        orAdd: "o agregue un cliente",
        orSelect: "o seleccione un cliente",
        orderModification: "El pedido original se modificarÃ¡. Â¿Quiere continuar?",
        orderOverview: "Resumen de pedidos",
        orderToMachine: "ENVIAR MI PEDIDO A LA MÃQUINA",
        ordersHistory: "Historial de pedidos",
        packagePlease: "Por favor, seleccione el envase",
        pleaseSelectBrand: "Por favor, selecciona la marca",
        previewImage: "Vista previa de IMG",
        previewPackage: "Vista previa del envase",
        productPlease: "Por favor, seleccione el producto",
        resetFilters: "Restablecer todos los filtros",
        searchForHistoricalOrders: "O buscar en el historial de pedidos",
        selectBrand: "Por favor, selecciona la marca",
        selectColor: "Ir a seleccionar el color",
        selectCustomer: "Ir a seleccionar un cliente",
        selectExistingCustomer: "Seleccionar un cliente existente",
        selectFandeck: "Ir a seleccionar la carta de colores",
        selectManually: "Si desea utilizar este color en la marca %{brandNames}, selecciÃ³nelo manualmente.",
        selectPackage: "Ir a seleccionar el envase",
        selectProduct: "Ir a seleccionar el producto",
        shotsCoefficient: "Coeficiente de los shots",
        showDetail: "Mostrar detalle",
        showHideEshopName: "Mostrar/Ocultar el nombre de la tienda electrÃ³nica del color en una columna separada",
        showKeyboard: "Mostrar teclado",
        skipCustomerButton: "Omitir la selecciÃ³n del cliente",
        skipCustomerText: "Omitir si no desea introducir un cliente",
        skipNote: "Omitir nota y ver resumen",
        spectroBrand: "BÃºsqueda en la marca %{brandName}",
        statusAccepted: "aceptado",
        statusCanceled: "cancelado",
        statusCreated: "creado",
        statusDone: "hecho",
        statusPartlyDone: "parcialmente hecho",
        statusPreparing: "preparando",
        summaryChosenBase: "base",
        summaryChosenBrand: "marca",
        summaryChosenCanSize: "tamaÃ±o de envase",
        summaryChosenColor: "color",
        summaryChosenColorCard: "carta de color",
        summaryChosenProduct: "producto",
        summaryChosenQuantity: "cantidad",
        summaryColorPreview: "Vista previa del color",
        summaryCustomNote: "Nota personalizada",
        summaryCustomerNumber: "nÃºmero de cliente",
        summaryFormula: "fÃ³rmula",
        summaryFormulaNote: "Nota de fÃ³rmula",
        summaryNote: "nota",
        sureAboutSend: "Â¿EstÃ¡ seguro que desea enviar el pedido?",
        useCustomerInOrder: "Â¿Desea utilizar %{customerName} en el siguiente pedido?",
        uuid: "UUID",
        viewSummary: "Ver resumen",
        volume: "Volumen"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "ConfirmaciÃ³n de pedido de PIN",
        pinScreenSaverConfirmation: "Pin de confirmaciÃ³n del salvapantallas",
        pinSettingsConfirmation: "ConfirmaciÃ³n de configuraciÃ³n de PIN",
        printAuto: "Permitir la impresiÃ³n automÃ¡tica",
        printerSettings: "ConfiguraciÃ³n de la impresora",
        selectColorWithFandeck: "SelecciÃ³n comÃºn de color y carta de colores",
        setKeyboard: "Establecer teclado",
        setKioskMode: "Establecer el modo quiosco",
        setLanguage: "Establecer el idioma",
        setModule: "Establecer el mÃ³dulo",
        setQuickSelect: "Establecer la selecciÃ³n rÃ¡pida",
        setScreensaverTimeout: "Establecer el tiempo de espera del protector de pantalla",
        setUnit: "Establecer unidad"
    },
    customRedlikeMachine: {
        action: "AcciÃ³n",
        additionalPrint: "ImpresiÃ³n adicional",
        brand: "Marca",
        brandAccess: "El usuario '%{userName}' no puede acceder a los datos de la marca '%{brandName}'",
        can: "Envase en posiciÃ³n",
        canistersLevel: "Estado de niveles de los depÃ³sitos",
        closeDetailInformation: "Cerrar detalle",
        colorantsAmount: "Cantidad de colorantes",
        confirmRefill: "Confirmar el relleno del colorante",
        deleteOrder: "Eliminar el pedido",
        dialogNoMachine: "La mÃ¡quina no estÃ¡ conectada",
        dialogNoRcc: "No hay ningÃºn RCC conectado",
        dispense: "Dispensar",
        dispenserInErrorState: "El dispensador estÃ¡ en estado de error",
        dispensingIsOk: "El dispensador funciona correctamente",
        emergencyButtonPressed: "Interruptor de parada de emergencia pulsado",
        errorCode: "CÃ³digo de error",
        errorEvents: "Errores del dispensador",
        errorReset: "Restablecer el error",
        explanation: "ExplicaciÃ³n",
        imageNotAvailable: "La imagen no estÃ¡ disponible",
        incorrectCanister: "DepÃ³sito incorrecto escaneado",
        incorrectColorant: "Escaneado el envase de colorante incorrecto",
        lastEvents: "Ãltimos eventos",
        machineActions: "Sensores de dispensador",
        machineConfiguration: "ConfiguraciÃ³n del dispensador",
        machineError: "Error de mÃ¡quina",
        machineIsBusy: "La mÃ¡quina estÃ¡ ocupada",
        machineNotAvailable: "La mÃ¡quina no estÃ¡ disponible",
        machineTinting: "Espere, la mÃ¡quina estÃ¡ dispensando...",
        manualScan: "Escaneo manual",
        notEnoughSpace: "ERROR: No hay suficiente espacio para este envase de colorante.",
        numberOfCanistersUnderCriticalLevel: "El nÃºmero de depÃ³sitos por debajo del nivel crÃ­tico es %{0}",
        numberOfCanistersUnderWarningLevel: "La cantidad de depÃ³sitos por debajo del nivel de advertencia es %{0}",
        offlinePressed: "BotÃ³n de modo offline activado",
        orderSettings: "Ajustes de pedidos",
        otherOrderInformation: "Detalle del pedido",
        packageCount: "Recuento de envases",
        packageWithSeparator: "Envases",
        received: "Recibidos",
        receivedOrders: "Pedidos recibidos",
        receivedTime: "Tiempo recibido ",
        recirculation: "RecirculaciÃ³n",
        refillInformation: "Colorante: %{0}, Relleno: %{1}, DepÃ³sito: %{2}",
        resetErrors: "Restablecer errores",
        scanCanister: "Escanee este depÃ³sito",
        scanColorantPackage: "Escanee el envase de colorante compatible",
        selectedOrder: "Pedido seleccionado",
        shelfMovingDown: "Estante moviÃ©ndose hacia abajo",
        shelfMovingUp: "Estante subiendo",
        solution: "SoluciÃ³n",
        startDispensing: "Empiece a dispensar",
        stirring: "Removiendo",
        touchToStartFilling: "Toque para iniciar el llenado de colorante",
        unknownBrand: "Marca desconocida"
    },
    customRedlikeSettings: {
        addPos: "InformaciÃ³n Punto de venta",
        addServer: "Agregar servidor",
        adminOperations: "Operaciones administrativas",
        adminSettings: "Ajustes de administraciÃ³n",
        another: "Otro",
        aslOrService: "ASL o servicio",
        availableMachines: "MÃ¡quinas disponibles",
        barcode: "CÃ³digo de barras",
        basicOperations: "Operaciones bÃ¡sicas",
        canisterBarcodes: "CÃ³digos de barras del depÃ³sito",
        canisterLevels: "Niveles del depÃ³sito",
        closeConnection: "Cerrar conexiÃ³n",
        closeRedlike: "Cerrar %{name}",
        databaseList: "Bases de datos",
        disabledStatus: "desactivado",
        dispenseLogicType: "dosificaciÃ³n de tipo lÃ³gico",
        dropServers: "Servidores caÃ­dos",
        editServer: "Editar servidor",
        lastEvent: "Ãltimo evento",
        logOut: "Cerrar sesiÃ³n",
        machineConfiguration: "ConfiguraciÃ³n",
        maxDispenseAmount: "Cantidad mÃ¡xima dispensada",
        offlineStatus: "desconectado",
        onlineStatus: "conectado",
        openFrondesk: "Solicitud abierta",
        print: "Ajustes de impresiÃ³n",
        rebootPC: "Reiniciar PC",
        restartRedlike: "Reiniciar %{name}",
        restoreConnection: "Restaurar la conexiÃ³n",
        scanCanisterBarcode: "Escanear el cÃ³digo de barras del depÃ³sito",
        scanOrDeleteCanisterBarcode: "Escanear o eliminar cÃ³digo de barras",
        setCanisterBarcode: "Establecer el cÃ³digo de barras del depÃ³sito",
        swVersion: "VersiÃ³n del software",
        systemFunctions: "Funciones del sistema",
        userSettings: "Ajustes de usuario"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Editar color",
        editColorant: "Editar colorante",
        emptyColorant: "Hay un colorante con cantidad vacÃ­a.",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "FÃ³rmula para el producto maestro",
        formulaForMasterProductWithParam: "FÃ³rmula para el producto principal %{productName}",
        isNotAvailable: "no estÃ¡ disponible",
        noBaseSelected: "Se requiere una base",
        noColorantsSelected: "No se han seleccionado colorantes",
        noFandeckSelected: "Se requiere la ColecciÃ³n",
        noNameOrCode: "Nombre y cÃ³digo de la fÃ³rmula requeridos",
        noProductSelected: "Se requiere producto",
        productPreview: "Vista previa del producto",
        saveCustomRecipe: "Guardar fÃ³rmula personal",
        saveIsNotAvailable: "Guardar no estÃ¡ disponible",
        showSiblingProducts: "Mostrar productos hermanos",
        siblingProducts: "Productos hermanos por producto principal"
    },
    customersTab: {
        addCustomer: "Agregar cliente",
        additionalSettings: "ConfiguraciÃ³n adicional",
        adress: "DirecciÃ³n",
        createAndSelect: "Agregar y seleccionar",
        createNewCustomer: "Crear nuevo cliente",
        editCustomer: "Editar cliente",
        expiration: "el Cliente %{name} caducarÃ¡ en %{dayCount} dÃ­as",
        identificationNumber: "NÃºmero de identificaciÃ³n",
        information: "InformaciÃ³n de contacto",
        listOfCustomers: "Lista de clientes",
        rabat: "Descuento",
        selectCustomer: "Seleccionar cliente",
        spentLastMonth: "Gastado el mes pasado",
        spentMoney: "Dinero gastado",
        typeOfMargin: "Tipo de margen",
        zipCode: "CÃ³digo postal"
    },
    dialog: {
        cheaperColorSearch: "La bÃºsqueda del color mÃ¡s barato estÃ¡ en marcha",
        competitiveColorSearch: "BÃºsqueda de color competitivo estÃ¡ en curso",
        reallyChangeModule: "Â¿Realmente quiere cambiar el mÃ³dulo?",
        reallyCloseRedlike:
            "Â¿De verdad desea cerrar %{name}? Todos los paneles %{name} se cerrarÃ¡n, se perderÃ¡n los cambios no guardados.",
        reallyDeleteOrder:
            "Â¿Realmente desea eliminar este pedido? Se perderÃ¡n todos los datos relacionados con este pedido.",
        reallyRebootPC:
            "Â¿Realmente quiere reiniciar este PC? Se cerrarÃ¡n todos los paneles, los cambios no guardados se perderÃ¡n.",
        reallyRestartRedlike:
            "Â¿Realmente quiere reiniciar %{name}? Se cerrarÃ¡n todos los paneles, los cambios no guardados se perderÃ¡n.",
        reallyShutdownPc:
            "Â¿De verdad quiere apagar este ordenador? Todos los paneles %{name} se cerrarÃ¡n, se perderÃ¡n los cambios no guardados.",
        unlockComputer: "El ordenador se desbloquearÃ¡."
    },
    dispenseLogicTypes: {
        1: "Dispense solo la cantidad mÃ¡xima que se puede dispensar",
        2: "Permita la dosificaciÃ³n manual usando una escala para cantidades superiores a la cantidad mÃ¡xima que se puede dispensar",
        3: "Rellenar durante la dosificaciÃ³n (dividir la cantidad en pedazos mÃ¡s pequeÃ±os)",
        4: "Fuerce la dosificaciÃ³n manual usando la bÃ¡scula solo en el caso de un envase personalizado"
    },
    editCustomFandeck: {
        fandeckName: "Nombre de la carta de colores"
    },
    editFormulaRgbModal: {
        apply: "Aplicar",
        blue: "Azul",
        green: "Verde",
        modalLabel: "Editar color",
        red: "Rojo",
        tryGenerateRgb: "Intentar generar RGB por cantidades de los colorantes"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Cerrar la pestaÃ±a de fÃ³rmula automÃ¡ticamente",
        allowBarcodes: "Permitir cÃ³digos de barras",
        allowBuildingSitePanel: "Permitir la especificaciÃ³n de obra",
        allowCustomers: "Permitir clientes",
        allowDeleteConfirmation: "Permitir la confirmaciÃ³n de eliminaciÃ³n",
        allowDiskSpaceNotification: "Permitir notificaciÃ³n de espacio en disco",
        allowDispensing: "Permitir dispensar",
        allowFileTransfer: "Permitir la transferencia automÃ¡tica de archivos",
        allowFormulaModificationPanel: "Habilitar el panel de ediciÃ³n de fÃ³rmulas",
        allowFormulaStatusPanel: "Permitir panel de estado de fÃ³rmula",
        allowInternalNotes: "Permitir notas internas",
        allowLight: "Permitir %{name}",
        allowOrderNotificationModal: "Mostrar notificaciones de pedidos nuevos",
        allowOrdering: "Permitir pedidos",
        allowPricing: "Permitir precios",
        allowPrint: "Permitir la impresiÃ³n",
        allowProductPreviewImage: "Mostrar vista previa de la imagen del producto",
        allowQualityControl: "Permitir control de calidad",
        allowSearchCheaperColors: "Permitir la bÃºsqueda de colores mÃ¡s baratos",
        allowSound: "Permitir notificaciÃ³n sonora sobre nuevos pedidos ",
        allowSpectro: "Permitir espectrofotÃ³metro",
        allowTabs: "Permitir pestaÃ±as",
        applyZoom: "Aplicar zoom",
        automaticLogout: "Cierre automÃ¡tico de sesiÃ³n",
        barcodeScan: "Escaneo de cÃ³digo de barras",
        canisterBarcode: "CÃ³digos de barras de los depÃ³sitos",
        canisterLevel: "Niveles de los depÃ³sitos",
        changelog: "Registro de cambios",
        closeTab: "Cerrar pestaÃ±a",
        colorDifference: "Diferencia de color",
        colorPanelNavItem: "Paleta de colores",
        competitiveColorSearch: "BÃºsqueda competitiva de color",
        customBanner: "Banner personalizado",
        customCurrencyFormat: "Formato de moneda",
        customDateFormat: "Formato de fecha",
        customNumberFormat: "Formato de nÃºmero",
        customTimeFormat: "Formato de hora",
        deltaA: "Delta a",
        deltaB: "Delta b",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerismo",
        discount: "Mostrar descuento",
        dispensingHistory: "Historial de dosificaciÃ³n",
        dispensingNotes: "Permitir las notas de dosificaciÃ³n",
        enableCustomers: "Habilitar clientes",
        enableDeleteConfirmation: "Habilitar la confirmaciÃ³n de eliminaciÃ³n",
        enableDispensing: "Habilitar la dosificaciÃ³n",
        enableLight: "Habilitar %{name}",
        enableMarginMarkup: "Habilitar margen o recargo",
        enableNotes: "Habilitar notas",
        enableOrdering: "Habilitar pedidos",
        enableProductPreviewImage: "Habilitar imagen de vista previa del producto",
        enableSpectro: "Habilitar espectrÃ³metro",
        enableVirtualKeyboard: "Permitir teclado virtual",
        environmentsSettings: "ConfiguraciÃ³n del entorno",
        exportTranslationKeys: "Exportar claves de traducciÃ³n",
        formulaNotes: "Permitir notas de fÃ³rmula",
        hintTooltips: "Sugerencias de herramientas",
        image: "Color + imagen/mÃ¡s info",
        keyboardShortcuts: "Teclas de abreviaciÃ³n",
        languageBased: "Basado en el lenguaje",
        lockYourComputer: "Bloquear el ordenador",
        machineReset: "Reinicio de la mÃ¡quina",
        manageTranslations: "Gestionar traducciones",
        margin: "Mostrar margen",
        markup: "Mostrar recargo",
        matchingRowCount: "Determina el nÃºmero de resultados encontrados",
        maxNumberTabs: "NÃºmero mÃ¡ximo de pestaÃ±as de fÃ³rmulas",
        memoryTabs: "Guardar las pestaÃ±as abiertas recientemente",
        moreInfo: "Color + imagen + mÃ¡s informaciÃ³n",
        navigationItems: "ConfiguraciÃ³n de elementos de navegaciÃ³n",
        newTab: "Nueva pestaÃ±a",
        numberOfPriceGroups: "NÃºmero de grupos de precios",
        order: "Pedido",
        orderId: "Solicitar ID",
        ordersHistory: "Historial de pedidos",
        overwriteLastTab: "Sobrescribir la Ãºltima pestaÃ±a de fÃ³rmula",
        priceCalculation: "CÃ¡lculo de precios",
        priceDefBothPurchasePrimary: "Ambos, compra principal",
        priceDefBothSellPrimary: "Ambos, venta principal",
        priceDefPurchaseOnly: "Solo precio de compra",
        priceDefSellOnly: "Solo precio de venta",
        priceDefinition: "DefiniciÃ³n de precio",
        priceGroupsEnabled: "Habilitar grupos de precios",
        runLightAtStartUp: "Ejecuta %{light} al inicio",
        screenSaverTimeout: "Tiempo de espera del salvapantallas",
        selectedSpectro: "espectrofotÃ³metro seleccionado %{spectro} .",
        selectedSpectroNone: "No hay espectrofotÃ³metro seleccionado.",
        setAutomaticClientStart: "Ejecute %{name} al iniciar el ordenador",
        setCustomHomeButton: "AcciÃ³n del botÃ³n de inicio",
        setDecimalPlaces: "Establecer el nÃºmero de decimales",
        setFormulaPreview: "Vista previa de la fÃ³rmula",
        setFormulaUnit: "Establecer unidad de fÃ³rmula",
        setFts: "Usar bÃºsqueda de texto completo",
        setInfoItemInRgb: "Vista previa de datos en color",
        setKeyboardShortcuts: "Establecer teclas de abreviaciÃ³n",
        setKioskMode: "Establecer el modo quiosco",
        setKioskModeOff: "Desactivar el modo quiosco",
        setKioskModeOn: "Activar el modo quiosco",
        setNavigationItems: "Establecer elementos de navegaciÃ³n",
        setNavigationItemsList: "Establecer la visibilidad y el orden de los elementos de navegaciÃ³n",
        setOrderSearchItems: "Establecer parÃ¡metros de bÃºsqueda de pedidos",
        setRounding: "Establecer redondeo",
        setSearchParameters: "Establecer parÃ¡metros de bÃºsqueda de fÃ³rmulas",
        setTabLimit: "Establecer lÃ­mite de pestaÃ±as",
        setYourLanguage: "Configure su idioma",
        setZoom: "Establecer zoom",
        showLocalPrices: "Mostrar precios sugeridos",
        skipPlaceCanDialogEnabled:
            "Esta configuraciÃ³n no se puede cambiar porque el cuadro de diÃ¡logo Â«colocar envaseÂ» se ha desactivado en ConfiguraciÃ³n de la mÃ¡quina",
        sortItems: "Ordenar elementos de navegaciÃ³n",
        startDispensing: "Empiece a dispensar",
        stir: "Agitar colorantes"
    },
    error: {
        errorDetail: "Detalle del error",
        errorOccurred:
            "OcurriÃ³ un error inesperado. PÃ³ngase en contacto con nuestro soporte en el %{0}, en breve nos pondremos en contacto con Usted.",
        hideDetail: "Ocultar detalle"
    },
    favoritesTab: {
        addFolder: "Agregar carpeta",
        closeTabToLoadFormula:
            "Cierre una de las fÃ³rmulas para abrir una nueva pestaÃ±a. Ha alcanzado el nÃºmero mÃ¡ximo de pestaÃ±as.",
        deleteFolder: "Eliminar carpeta",
        editFolder: "Editar carpeta",
        favoriteFormulas: "FÃ³rmulas favoritas",
        formulaNotes: "Notas de fÃ³rmula",
        message: {
            formulasFromFolder: "FÃ³rmulas de la carpeta",
            moveAllFormulas: "Mover todas las fÃ³rmulas de esta carpeta a su carpeta principal",
            removeAllFormulas: "Eliminar todas las fÃ³rmulas de esta carpeta",
            wantToDeleteFolder: "Â¿Realmente desea eliminar esta carpeta?"
        },
        newFolder: "Nueva carpeta",
        packages: "Envases",
        pricePerPackage: "Precio por envase",
        regularPrice: "Precio habitual",
        removeFromFavorites: "Quitar de favoritos",
        specialPriceOff: "Precio especial %{number}% de descuento",
        specialPriceVIP: "Precio especial VIP"
    },
    fileTransfer: {
        afterImport: "DespuÃ©s de la importaciÃ³n",
        alreadyExists: "La tarea para determinado tipo y formato ya existe",
        customFormulaSimple: "FÃ³rmula personal sencilla",
        direction: "DirecciÃ³n",
        exportTask: "Tarea de exportaciÃ³n de archivos",
        fileTransferNotification: "NotificaciÃ³n de transferencia de archivos",
        flashMessage: "Mensaje flash",
        importTask: "Tarea de importaciÃ³n de archivos",
        noInformation: "Sin informaciÃ³n",
        protocol: {
            folder: "Carpeta",
            ftp: "Protocolo FTP",
            ftps: "Protocolo FTPS",
            redlikeStorage: "%{softwareName} Protocolo de almacenamiento FTP",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocolo de comprobaciÃ³n de archivos en la carpeta local definida.",
            ftp: "Protocolo de comprobaciÃ³n de archivos en carpeta FTP remota mediante conexiÃ³n FTP estÃ¡ndar.",
            ftps: "Protocolo de comprobaciÃ³n de archivos en servidor FTPS remoto (FTP-SSL / FTP Secure) utilizando la conexiÃ³n FTP estÃ¡ndar.",
            redlikeStorage: "Archivos de comprobaciÃ³n de protocolo en almacenamiento %{softwareName}."
        },
        remoteFolder: "Carpeta remota",
        startType: "Tipo de puesta en marcha",
        statusbar: "InformaciÃ³n de la barra de estado",
        testConnection: "Prueba de conexiÃ³n",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "El archivo XML estÃ¡ siendo importado"
    },
    filtering: {
        consumptionType: "Tipo de consumo",
        filter: "Filtrar",
        from: "De",
        to: "A"
    },
    findText: {
        findTextTitle: "Buscar texto",
        removeMarks: "Eliminar marcas",
        search: "Buscar palabra"
    },
    flashMessage: {
        VMNotAllowed: "La mÃ¡quina virtual no estÃ¡ permitida.",
        addedToStock: "ArtÃ­culos aÃ±adidos correctamente al stock",
        allRecordsDeleted: "Todos los registros importados han sido borrados sin errores",
        autologinFailed: "Error en el autologin de la base de datos.",
        autotaskDuplicateName:
            "Error de integridad de la base de datos: el elemento %{0} con %{1} %{2} ya existe, utilice %{3} diferente.",
        barcodeIsUsed: "El cÃ³digo de barras ya estÃ¡ utilizado.",
        barcodeNotFound: "No se encontrÃ³ el cÃ³digo de barras.",
        bugReportSent: "Su informe de error se ha enviado correctamente.",
        cannoctConnectToServer: "No se puede conectar al servidor.",
        cannotWriteLicense: "No es posible introducir licencia.",
        clientConnectionRejected: "La conexiÃ³n ha sido rechazada.",
        clientNotLoggedIn: "El cliente no ha iniciado sesiÃ³n.",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Envase de colorante retirado con Ã©xito del almacÃ©n.",
        competitiveSearchEmpty:
            "No se pueden encontrar colores competitivos. Cambie los parÃ¡metros de bÃºsqueda o seleccione un color diferente.",
        competitiveSearchSelectProduct: "Seleccione el producto para iniciar la bÃºsqueda de colores competitivos.",
        computerBackdated: "El ordenador tiene una fecha anterior.",
        connectionFailed: "Error en la prueba de conexiÃ³n: %{0}",
        connectionSuccess: "La prueba de conexiÃ³n fue exitosa",
        corruptedLicenseFile: "El archivo de licencia estÃ¡ daÃ±ado.",
        customFormulaCreated: "FÃ³rmula personalizada creada correctamente.",
        customFormulaCreationError: "Error al crear una fÃ³rmula personalizada.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "No se encontrÃ³ al cliente.",
        dataNotAvailable: "El servidor no se puede conectar a la base de datos.",
        datacolorMatching: {
            couldNotConnect:
                "No se pudo conectar a Datacolor Matching, el servidor no funciona o el PC estÃ¡ desconectado.",
            disabled: "Datacolor Matching desactivado.",
            internalError: "Datacolor Matching error interno: '%{0}'",
            invalidCredentials:
                "No se han proporcionado credenciales para Datacolor Matching o no son vÃ¡lidas, pÃ³ngase en contacto con el proveedor de la base de datos.",
            noCansAvailable:
                "No hay envases disponibles para el archivo de color seleccionado (lÃ­nea de productos), pÃ³ngase en contacto con el proveedor de la base de datos."
        },
        defaultMessage: "Se produjo un error inesperado durante la Ãºltima acciÃ³n del servidor.",
        deleteAll: "Eliminar todo",
        deletingImportedData: "Borrando registros importados",
        disableWinterPlugin:
            "Puede deshabilitar el plugin de invierno utilizando la lista desplegable en el lado derecho de la navegaciÃ³n de pestaÃ±as.",
        duplicateBarcode: "El cÃ³digo de barras duplicado ya existe.",
        duplicateName: "Ya existe un nombre duplicado.",
        emptyFandeck: "La colecciÃ³n seleccionada estÃ¡ vacÃ­a.",
        emptyStock: "No hay registros en stock del artÃ­culo que ha utilizado.",
        expiredLicense: "La licencia ha expirado.",
        exportSuccess: "Los datos se han exportado correctamente.",
        fandeckExist: "El nombre de la carta de colores personalizada ya existe.",
        featureNotAutorized: "La funciÃ³n no ha sido autorizada.",
        fileExportComplete: "El archivo se exportÃ³ correctamente.",
        fileExportError: "Se ha producido un error al exportar el archivo.",
        fileSaveComplete: "El archivo se ha guardado correctamente.",
        fileSaveError: "Se ha producido un error al guardar el archivo.",
        fileTransferCustomFormulaRecordsAdded:
            "Se han aÃ±adido nuevos registros de fÃ³rmulas personales a partir del archivo recibido.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "No se han podido procesar completamente los datos de la fÃ³rmula personalizada en el archivo: '%{0}', consulte los archivos de registro de errores para obtener mÃ¡s informaciÃ³n.",
        fileTransferCustomFormulaRecordsProcessed:
            "Los nuevos registros de la fÃ³rmula personalizada (%{0} del %{1}) se han aÃ±adido correctamente desde el archivo recibido.",
        fileTransferCustomerRecordsAdded: "Se han aÃ±adido nuevos registros de clientes a partir del fichero recibido.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "No se han podido procesar completamente los datos del cliente en el archivo '%{0}', consulte los archivos de registro de errores para obtener mÃ¡s informaciÃ³n.",
        fileTransferCustomerRecordsProcessed:
            "Los nuevos registros de clientes (%{0} del %{1}) se han aÃ±adido correctamente desde el archivo recibido.",
        fileTransferFileNotProvided: "Fichero no proporcionado o vacÃ­o.",
        fileTransferHistoryRecordsAdded:
            "Se han aÃ±adido nuevos registros del historial de dosificaciÃ³n a partir del archivo recibido.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "No se han podido procesar completamente los datos del historial de dosificaciÃ³n en el archivo: '%{0}', consulte los archivos de registro de errores para obtener mÃ¡s informaciÃ³n.",
        fileTransferHistoryRecordsProcessed:
            "Los nuevos registros histÃ³ricos (%{0} del %{1}) se han aÃ±adido correctamente desde el archivo recibido.",
        fileTransferInvalidFile: "No se han podido procesar los datos del archivo, el archivo no es vÃ¡lido.",
        fileTransferOrderRecordsAdded: "Se han aÃ±adido nuevos registros de pedidos a partir del archivo recibido.",
        fileTransferOrderRecordsNotFullyProcessed:
            "No se han podido procesar completamente los datos del pedido en el archivo '%{0}', consulte los archivos de registro de errores para obtener mÃ¡s informaciÃ³n.",
        fileTransferOrderRecordsProcessed:
            "Los nuevos registros de pedidos (%{0} del %{1}) se han aÃ±adido correctamente desde el archivo recibido.",
        fileTransferUnknownVersion: "No se ha podido detectar la versiÃ³n del archivo.",
        filetransferNoData: "No hay conexiÃ³n a la base de datos, compruebe la configuraciÃ³n",
        formulaDataUnavailable: "Los datos de la fÃ³rmula no estÃ¡n disponibles.",
        helperDefaultMessage: "Se produjo un error inesperado durante la Ãºltima acciÃ³n del servidor auxiliar.",
        helperServerError: "Error del servidor auxiliar.",
        importAborted: "El proceso de importaciÃ³n se ha cancelado.",
        importSuccess: "Los datos se han importado correctamente.",
        incompatibleBaseCan: "La base no es compatible con este producto, compruebe la base y el envase.",
        incorrectPassword: "Su contraseÃ±a anterior es incorrecta. Por favor, introduzca la correcta.",
        invalidCurrency: "El cÃ³digo de moneda no es vÃ¡lido. El euro se establece como moneda predeterminada.",
        invalidDatabaseName: "El nombre de la base de datos no es vÃ¡lido.",
        invalidEmail: "Su Correo ElectrÃ³nico es invÃ¡lido.",
        invalidFormulaColorants:
            "Â¡Â¡Â¡ADVERTENCIA!!! Existe el problema de software en la fÃ³rmula. Â¡La fÃ³rmula podrÃ­a estar mal! PÃ³ngase en contacto con su soporte!",
        invalidLicenseCompanyUserKey: "Clave de usuario de empresa no vÃ¡lida.",
        invalidLicenseFile: "Archivo de licencia no vÃ¡lido.",
        invalidLicenseIdentificationKeys: "Sus claves de identificaciÃ³n de licencia no son vÃ¡lidas.",
        invalidLicenseKey: "Su licencia no es vÃ¡lida",
        invalidLicenseProduct: "El archivo de licencia no coincide con el producto.",
        invalidRccResponse: "OcurriÃ³ un error inesperado durante el procesamiento de la Ãºltima respuesta de RCC.",
        invalidServerResponse:
            "Se produjo un error inesperado durante el procesamiento de la Ãºltima respuesta del servidor.",
        invalidUrl: "La URL no es vÃ¡lida.",
        itemNotFound: "No se encontrÃ³ el artÃ­culo.",
        keyboardShortcutUsedInModal:
            "Esta tecla de abreviaciÃ³n no se puede utilizar en la ventana emergente. Primero cierre la ventana emergente.",
        keyboardShortcutValidation: "Una tecla de abreviaciÃ³n no se puede asignar a dos acciones diferentes.",
        licenseHasBeenRevoked:
            "Su licencia ha sido revocada. Para renovarla, pÃ³ngase en contacto con su proveedor de software.",
        licenseProlongationNeeded:
            "ProlongaciÃ³n de licencias necesaria (conectar PC a Internet para obtener nueva licencia)",
        licenseUpToDate: "Su licencia estÃ¡ actualizada. No es necesario actualizarla.",
        licenseUpdateUnsuccessful: "No se ha podido actualizar la licencia.",
        licenseUpdated: "La licencia se ha actualizado correctamente.",
        licensedOnDifferentComputer: "Producto con licencia original en un ordenador diferente.",
        logFileArchiveDownloadComplete: "La descarga del archivo de registro se ha completado con Ã©xito.",
        loginError: "Se produjo un error inesperado durante el inicio de sesiÃ³n.",
        logoutError: "Se produjo un error inesperado durante el cierre de sesiÃ³n.",
        machineIsConnecting: "La mÃ¡quina se estÃ¡ conectando, espere, por favor.",
        machineIsNotConnected: "Su mÃ¡quina NO ESTÃ CONECTADA a RCC. Verifique la configuraciÃ³n de RCC.",
        malformedFormula: "Formula mal formada",
        matching: {
            correctionNotPossible: "No se puede corregir, utilice la reformulaciÃ³n.",
            forbidden: "Pedido '%{0}' fallido: prohibido.",
            internalServerError: "Error interno del servidor.",
            invalidBase: "Base no vÃ¡lida en el producto.",
            invalidBipp: "IBase no vÃ¡lida en el envase del producto.",
            invalidColorantId: "Colorante no vÃ¡lido con ID: %{0}.",
            invalidColorantName: "Colorante no vÃ¡lido con nombre: %{0}.",
            invalidColorfile: "Archivo de color no vÃ¡lido con ID: %{0} para producto con ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Producto invÃ¡lido con ID: %{0}.",
            invalidSpectralCurve: "Curva espectral no vÃ¡lida.",
            noColorfiles: "No hay archivos de color definidos para el producto con ID: %{0}.",
            notAuthorized: "Pedido '%{0}' fallido: no autorizado.",
            notFound: "Pedido '%{0}' fallido: no encontrado.",
            reformulationNotPossible: "No se puede reformular.",
            unknownError: "Error desconocido.",
            validationError: "Pedido '%{0}' fallido debido a validciÃ³n de errores: %{0}."
        },
        maxFileSizeExceeded: "Se ha superado el tamaÃ±o mÃ¡ximo de archivo de %{0} MB",
        maxTabs: "Se alcanzÃ³ la cantidad mÃ¡xima de pestaÃ±as, cierre una.",
        noTemplate: "La impresiÃ³n no se puede llevar a cabo, ya que no hay plantillas disponibles.",
        openNewTab: "Abra una nueva pestaÃ±a de fÃ³rmula para cargar fÃ³rmulas con cÃ³digo de barras",
        orderAlreadyAcquired: "El pedido ya se ha adquirido, primero es necesario sacarlo.",
        orderCreated: "El pedido se ha enviado con Ã©xito.",
        passwordIsNotUnique: "La nueva contraseÃ±a debe ser diferente a la anterior.",
        printCannotBeCarriedOut:
            "La impresiÃ³n no se puede llevar a cabo ya que el nombre de la impresora no es vÃ¡lido.",
        problemWithFileExport: "Se ha producido un error al guardar el archivo en el disco.",
        productFileWarning: "La ficha del producto sÃ³lo estÃ¡ disponible en lÃ­nea.",
        productNotLicensed: "El producto no tiene licencia.",
        rccDefaultMessage: "Se produjo un error inesperado durante la Ãºltima acciÃ³n de RCC.",
        rccError: "Error de RCC",
        rccNeedRestart: "Reinicie su RCC.",
        restoredSettings: "Se han restaurado los ajustes.",
        revokedLicense: "La licencia ha sido revocada.",
        runningOutOfSpace: "El ordenador se queda sin espacio libre.",
        savedFormulaToHistory: "La fÃ³rmula se ha guardado correctamente en el historial de dosificaciÃ³n.",
        savedLogArchive: "El archivo de registro se ha guardado correctamente en su directorio.",
        scanning: "Escaneo en curso",
        serverError: "Error del Servidor",
        setClientIdentifier: "Primero configure su identificador de cliente.",
        showLess: "Mostrar menos",
        showMore: "Mostrar mÃ¡s",
        spectroIsDisconnecting: "El espectrofotÃ³metro se estÃ¡ desconectando, espere.",
        spectroIsNotConnected:
            "El espectrofotÃ³metro NO ESTÃ CONECTADO en este momento. Verifique la configuraciÃ³n de RCC.",
        spectroIsNotSelected:
            "El espectrofotÃ³metro NO ESTÃ SELECCIONADO en este momento. Verifique la configuraciÃ³n de RCC.",
        tmcNotAvailable: "%{tmc} no estÃ¡ disponible. Compruebe su %{collector}.",
        tmcNotConnected: "%{tmc} no estÃ¡ conectado. Por favor, inicie su %{collector} y reinicie el servidor.",
        unknownError: "Error desconocido: %{0}",
        userAlreadyLoggedIn: "Ya se ha autentificado.",
        versionNotAllowedByLicense: "La versiÃ³n del software es demasiado nueva y no estÃ¡ permitida para su licencia.",
        webApiConnectionError: "No se pudo conectar al servidor Web Api.",
        webApiInternalError: "Servidor de API web: error interno",
        webApiInvalidUser: "Servidor de API web: usuario no vÃ¡lido",
        webApiNoLicenseAvailable: "Servidor Web Api: no hay licencia disponible",
        wrongDataSaved: "Se han guardado datos incorrectos en el archivo XML de la carpeta %{0}.",
        wrongHelpInput: "Formato incorrecto de entrada %{0}.",
        wrongRccVersion: "Compruebe la versiÃ³n de su RCC. Su cliente solo es compatible con RCC %{0}."
    },
    footer: {
        aboutApplication: "Acerca de la aplicaciÃ³n",
        activeUser: "Usuario activo",
        logOut: "Cerrar sesiÃ³n",
        machineErrors: "Errores de la mÃ¡quina"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalido",
        solvent: "Base disolvente",
        universal: "Universal",
        water: "Base agua"
    },
    formulaSettings: {
        allUnits: "Todas las unidades disponibles en la base de datos",
        allowCustomFormulas: "Permitir fÃ³rmulas personalizadas",
        allowCustomPackageSize: "Permitir tamaÃ±o de envase personalizado",
        allowFormulaAutomaticNaming: "Permitir la denominaciÃ³n automÃ¡tica",
        automaticNaming: "DenominaciÃ³n automÃ¡tica de fÃ³rmula",
        basePanelSize: "Ajustar el tamaÃ±o del panel base",
        bippPanelSize: "Establezca el tamaÃ±o base en el panel de envasado del producto",
        blendColorNameAndCode: "Combinar nombre y cÃ³digo de color",
        buttonBellowMoreInfo: "Mostrar botÃ³n debajo de las notas de la fÃ³rmula",
        buttonInColorantPanel: "BotÃ³n Mostrar en el panel Colorantes",
        colorCodePrimary: "CÃ³digo de color como primario",
        colorPanel: "Paleta de colores",
        colorPreviewAsImage: "Vista previa del color como imagen",
        colorPreviewResizable: "Vista previa del color redimensionable",
        competitiveColorSearch: "BÃºsqueda competitiva de color",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "FÃ³rmulas personalizadas",
        customPackageSettingsUnitGrav: "ConfiguraciÃ³n de envases personalizada en unidad gravimÃ©trica",
        customPackageSettingsUnitVol: "ConfiguraciÃ³n de envases personalizada en unidad volumÃ©trica",
        customPackageSize: "TamaÃ±o de envase personalizado",
        customUnits: "Elija unidades personalizadas",
        dropDownCalculate: "Ampliar el menÃº desplegable a la altura de la ventana",
        editColorants: "Editar colorantes",
        editColorantsAllowed: "Permitir editar colorantes",
        fandeckPanelSize: "Ajuste el tamaÃ±o del panel de carta de colores",
        favoriteFormulas: "FÃ³rmulas favoritas",
        formulaColorPreview: "Vista previa del color de la fÃ³rmula",
        formulaDataSettings: "ConfiguraciÃ³n de datos de fÃ³rmula",
        formulaPanel: "Panel de fÃ³rmulas",
        formulaPanelSize: "Ajustar el tamaÃ±o del panel de color",
        formulaSettings: "ConfiguraciÃ³n de fÃ³rmulas",
        generateColorPreview: "Generar vista previa de color",
        gravimetricOnly: "Solo unidades gravimÃ©tricas",
        hideAlternativeFormulas: "Ocultar fÃ³rmulas alternativas",
        hideFormulaProperties: "Ocultar propiedades de la fÃ³rmula",
        hideHistoricalFormulas: "Ocultar fÃ³rmulas histÃ³ricas",
        imagesLocal: "Utilizar sÃ³lo la imagen de la base de datos local",
        imagesOnline: "En primer lugar, intente abrir la imagen en lÃ­nea",
        infoPanelResizable: "Panel de informaciÃ³n redimensionable",
        numberOfColorants: "NÃºmero de colorantes mostrados",
        orderByDistance: "Orden de los resultados de la bÃºsqueda por distancia",
        productDependent: "La unidad depende del producto seleccionado",
        productFilesDialog: "Mostrar diÃ¡logo para abrir archivo local o archivo en lÃ­nea",
        productFilesLocal: "Utilizar sÃ³lo archivos de productos de la base de datos local",
        productFilesOnline: "En primer lugar, intente abrir el archivo de producto en lÃ­nea",
        productPanelSize: "Establecer el tamaÃ±o del panel de productos",
        searchPanelQuickSelect: "SelecciÃ³n rÃ¡pida",
        setAdditionalFormulaPanel: "Establecer panel de fÃ³rmulas adicional",
        setCompetitiveColorSearch: "Permitir una bÃºsqueda de colores competitiva",
        setInitialFormulaPanel: "Establecer panel de fÃ³rmula inicial",
        setMaxToleranceForCompetitiveColors: "Establecer tolerancia mÃ¡xima para la bÃºsqueda de color competitivo",
        setNumberOfCompetitiveColors: "Establecer el nÃºmero de colores master competitivos",
        setSearchPanel: "Establecer panel de bÃºsqueda",
        setVisibilityAndOrder: "Establecer la visibilidad y el orden de varios datos de fÃ³rmulas",
        setVisibleUnit: "Establecer unidades visibles",
        showColorPreview: "Mostrar vista previa de color",
        showInFormulaStatusPanel: "Mostrar en el panel de estado de la fÃ³rmula",
        showInMoreInfoPanel: "Mostrar en las notas de la fÃ³rmula",
        sorting: "Panel de clasificaciÃ³n de colorantes",
        useBase: "Usar el elemento de selecciÃ³n para la base",
        useBaseInProductPackage: "Usar artÃ­culo de selecciÃ³n para la base en el envase de productos",
        useColorCode: "Usar cÃ³digo color",
        useColorName: "Utilizar el nombre del color",
        useFandeckGroups: "Usar marcas Cartas de colores",
        useProduct: "Usar artÃ­culo de selecciÃ³n para el producto",
        useProductCode: "Usar cÃ³digo de producto",
        useProductGroups: "Utilizar grupos de productos",
        volumetricOnly: "Solo unidades volumÃ©tricas"
    },
    general: {
        accepted: "Aceptado",
        active: "Ãltima actividad",
        actual: "Real",
        actualLevel: "Nivel actual",
        add: "AÃ±adir",
        addColorant: "Agregar colorante",
        addColorantForPackage: "AÃ±adir colorante para un envase",
        addFile: "AÃ±adir archivo",
        all: "Todos",
        amount: "Cantidad",
        applyNow: "Aplicar ahora",
        attachments: "Adjunto",
        automaticCorrection: "CorrecciÃ³n automÃ¡tica",
        automatically: "AutomÃ¡ticamente",
        available: "Disponible",
        back: "AtrÃ¡s",
        base: "Base",
        baseInProductPackage: "Base en el producto y envase",
        batchNumber: "NÃºmero de lote",
        bottom: "Fondo",
        buildingSite: "Obra",
        calculate: "Calcule",
        can: "Envase",
        canSize: "TamaÃ±o de envase",
        cancel: "Cancelar",
        canister: "DepÃ³sito",
        canisterId: "ID del depÃ³sito",
        canisterIndex: "Ãndice del depÃ³sito",
        canisters: "DepÃ³sitos",
        cap: "Tapa",
        capacity: "Capacidad",
        channels: "Canales",
        choose: "Elegir",
        city: "Ciudad",
        clean: "Limpiar",
        clear: "Claro",
        client: "Cliente",
        close: "Cerrar",
        closeAll: "Cerrar todo",
        collapseAll: "Comprimir todo",
        color: "Color",
        colorCode: "CÃ³digo del color",
        colorFile: "Archivo de color",
        colorName: "Nombre del color",
        colorPreview: "Vista previa del color",
        colorant: "Colorante",
        colorantBatchNumber: "Colorante NÃºmero de lote",
        colorantPackage: "Envase de colorante",
        colorants: "Colorantes",
        colors: "Colores",
        company: "CompaÃ±Ã­a",
        competitiveColor: "Color competitivo",
        confirm: "Confirmar",
        confirmDeletion: "Â¿Realmente desea eliminar este elemento permanentemente?",
        confirmHelpSettings: "Â¿De verdad desea guardar el formulario y dejar los campos vacÃ­os?",
        connect: "Conectar",
        continue: "Continuar",
        correction: "CorrecciÃ³n",
        country: "PaÃ­s",
        created: "Creado",
        creationDateOf: "Fecha de creaciÃ³n de",
        criticalLevel: "Nivel crÃ­tico",
        currency: "Divisa",
        currentBatchNumber: "NÃºmero de lote actual",
        currentUfiCode: "CÃ³digo UFI actual",
        custom: "Personalizado",
        customData: "Datos personalizados",
        customFandeck: "carta de colores personalizado",
        customFormula: "FÃ³rmula personalizada",
        customPackage: "Personalizado",
        customPackageSettings: "ConfiguraciÃ³n de envases personalizados",
        customer: "Cliente",
        customerVersion: "VersiÃ³n del cliente",
        customers: "Clientes",
        database: "Base de datos",
        date: "Fecha",
        default: "Predeterminado",
        delete: "Borrar",
        deleteImportedData: "Borrar registros importados",
        delta: "Delta",
        description: "DescripciÃ³n",
        disconnect: "Desconectar",
        discount: "Descuento",
        discover: "Descubrir",
        dispense: "Dispensar",
        dispensing: "dosificaciÃ³n",
        doNotShowAgain: "No vuelva a mostrar este mensaje.",
        downloadingFile: "Descarga de archivos",
        edit: "Editar",
        email: "Correo electrÃ³nico",
        enabled: "Habilitado",
        error: "Error",
        expandAll: "Ampliar todo",
        exportData: "Exportar datos",
        exportPdf: "Exportar PDF",
        fan: "Carta de colores",
        fandeck: "Carta de colores",
        fandeckCode: "CÃ³digo carta de colores",
        fandeckName: "Nombre carta de colores",
        fandecks: "Carta de colores",
        favorite: "Favorito",
        fileTransfer: "Transferencia de archivos",
        filling: "Relleno",
        fillingDate: "Fecha de llenado",
        find: "Encontrar",
        finish: "Terminar",
        finishedCorrection: "CorrecciÃ³n finalizada",
        formula: "FÃ³rmula",
        formulas: "Formulas",
        frontdesk: "RecepciÃ³n",
        getQrCode: "Obtener cÃ³digo QR",
        gravimetric: "GravimÃ©trico",
        historical: "HistÃ³rico",
        history: "Historia",
        hours: "Horas",
        id: "ID",
        images: "Imagenes",
        in: "En",
        index: "Ãndice",
        insertBarcode: "Por favor, inserte el cÃ³digo de barras",
        install: "Instalar",
        installed: "Instalado",
        instructions: "Instrucciones",
        internalNote: "Nota interna",
        interval: "Intervalo",
        ip: "DirecciÃ³n IP",
        itemNumber: "NÃºmero de artÃ­culo.",
        itemXOfY: "ArtÃ­culo %{x}/%{y}",
        itemsCount: "Recuento de artÃ­culos",
        later: "MÃ¡s tarde",
        limit: "LÃ­mite",
        load: "Descargar",
        loadFormula: "Cargar fÃ³rmula",
        localVersion: "VersiÃ³n local",
        machine: "MÃ¡quina",
        manualCorrection: "CorrecciÃ³n manual",
        manually: "Manualmente",
        margin: "Margen",
        markup: "Recargo",
        matching: "FormulaciÃ³n",
        matchingFormula: "FormulaciÃ³n",
        maxLevel: "Nivel mÃ¡ximo",
        maxValue: "Valor mÃ¡ximo",
        maximum: "MÃ¡ximo",
        mayTakeAWhile: "Puede tardar un poco",
        measured: "Medido",
        metamarism: "Metamarismo",
        minimum: "MÃ­nimo",
        minutes: "Min.",
        missingItem: "Falta un artÃ­culo",
        missingRequiredItems: "Todos los artÃ­culos necesarios (marcados con un asterisco) deben rellenarse",
        modified: "Modificado",
        modifiedAutomaticCorrection: "CorrecciÃ³n de muestra patrÃ³n",
        modifiedCustomFormula: "FÃ³rmula personal modificada",
        modifiedStandardFormula: "FÃ³rmula estÃ¡ndar modificada",
        moduleChange: "Cambio de mÃ³dulo",
        more: "MÃ¡s",
        moreInfo: "MÃ¡s informaciÃ³n",
        moveDown: "Mover hacia abajo",
        moveUp: "Ascender hacia arriba",
        myOrders: "Mis pedidos",
        name: "Nombre",
        nameTitle: "Nombre",
        new: "Nuevo",
        next: "PrÃ³ximo",
        no: "No",
        noColorantsAvailable: "Sin colorantes disponibles",
        noFormulas: "AÃºn no hay fÃ³rmulas",
        noPricesAvailable: "Sin precios disponibles",
        nominalAmount: "Cantidad nominal",
        notAvailable: "No disponible",
        note: "Nota",
        numberOfCanisters: "NÃºmero de depÃ³sitos",
        numberOfItemCount: "Numero de '%{item}': %{count}",
        numberOfLabels: "NÃºmero de etiquetas",
        numberOfPackages: "NÃºmero de envases",
        off: "Apagado",
        ok: "OK",
        on: "Encendido",
        onFocus: "En el enfoque",
        open: "Abierto",
        operator: "Operador",
        options: "Opciones",
        order: "Pedido",
        other: "Otro",
        otherError: "Otro error",
        out: "Fuera de servicio",
        overwrite: "Overwrite",
        package: "Envases",
        packagePreview: "Vista previa del envase",
        partialUpdates: "Actualizaciones parciales",
        phone: "TelÃ©fono",
        pleaseWait: "Espere, por favor",
        previous: "Anterior",
        price: "Precio",
        priceGroup: "Grupo de precios",
        print: "Imprimir",
        printTask: "Tarea de impresiÃ³n",
        processingStep: "Procesando %{step}",
        product: "Producto",
        productCode: "CÃ³digo del producto",
        productName: "Nombre del producto",
        products: "Productos",
        pump1: "Bomba 1",
        pump2: "Bomba 2",
        purchasePrice: "Precio de compra",
        purge: "Purga",
        qualityControl: "Control de calidad",
        quantity: "Cantidad",
        quantityQty: "Cantidad",
        quickTint: "DosificaciÃ³n rÃ¡pida",
        rccIsNotAvailable: "RCC no estÃ¡ disponible",
        rccIsNotConnected: "RCC no estÃ¡ conectado",
        rccNotLicensed: "RCC no tiene licencia",
        reconnect: "Reconectar",
        refill: "Rellenar",
        refillManualLevelCorrection: "CorrecciÃ³n manual",
        reformulation: "ReformulaciÃ³n",
        reloadTab: "Reload Tab",
        reset: "Reiniciar",
        restart: "Reanudar",
        restore: "Restaurar",
        retint: "Dosificar nuevamente",
        revision: "RevisiÃ³n",
        safetySheet: "Ficha de seguridad",
        save: "Guardar",
        saveAs: "Guardar como",
        saveToDispensingHistory: "Guardar en el histÃ³rico",
        searchResult: "Resultado de la bÃºsqueda",
        searching: "Buscando en",
        seconds: "Sec.",
        select: "Selecciona",
        selectAll: "Seleccionar todo",
        selectChannels: "Seleccionar canales",
        selectColumns: "Selecciona las columnas para trabajar",
        selectXFirst: "Seleccione %{item} primero",
        sellPrice: "Precio de venta",
        settings: "Ajustes",
        shelf: "Plataforma",
        showItem: "Show %{item}",
        showOptions: "Muestra otras opciones",
        size: "TamaÃ±o",
        skip: "Saltar",
        smartPurge: "Purga inteligente",
        softwareRestartInSeconds: "%{software} se reiniciara en %{seconds} segundos",
        sortResults: "Ordenar resultados",
        spectro: "BÃºsqueda por EspectrofotÃ³metro",
        standardFormula: "FÃ³rmula estÃ¡ndar",
        status: "Estado",
        street: "Calle",
        sum: "Suma",
        summary: "Resumen",
        sync: "Sincronizar",
        technicalSheet: "Ficha tÃ©cnica",
        templates: "Plantillas",
        threshold: "Umbral",
        ticketing: "Ticketing",
        tintometricSystem: "Sistema TintomÃ©trico",
        toDispenseOrders: "Dispensar",
        top: "Arriba",
        total: "Total",
        totalAmount: "Cantidad total",
        totalBaseAmount: "Cantidad de base total",
        totalColorantAmount: "Cantidad total de colorantes",
        type: "Tipo",
        ufiCode: "CÃ³digo UFI",
        ufiThreshold: "Umbral de UFI",
        unableToSynchronize: "Unable to synchronize",
        undefined: "No definido",
        unit: "Unidad",
        units: "Unidades",
        unknown: "Unknown",
        update: "Actualizar",
        updated: "Actualizado",
        user: "Usuario",
        value: "Valor",
        vat: "IVA",
        verified: "Verificado",
        version: "VersiÃ³n",
        versionId: "ID de versiÃ³n",
        versionStructure: "Estructura de la versiÃ³n",
        volumetric: "VolumÃ©trico",
        warning: "Advertencia",
        warningLevel: "Nivel de advertencia",
        withoutName: "(sin nombre)",
        workingProperly: "Working properly",
        yes: "SÃ­",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Establezca esta tarea automÃ¡tica para que %{name} solicite la acciÃ³n para limpiar el contenedor de pinceles automÃ¡ticamente en el momento definido. El operador del dispensador debe quitar, limpiar y, a continuaciÃ³n, devolver el recipiente del cepillo manualmente.",
            capMaintenance:
                "Establezca esta tarea automÃ¡tica para que %{name} solicite la acciÃ³n para limpiar la tapa automÃ¡ticamente en el momento definido. El operador dispensador debe limpiar el escape automÃ¡tico manualmente despuÃ©s de que se abra.",
            cleanAll:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la acciÃ³n para limpiar todos los canales automÃ¡ticamente en el momento definido.",
            cleanChannels:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la acciÃ³n para limpiar canales especÃ­ficos automÃ¡ticamente en el momento definido.",
            computerReboot:
                "Establezca esta tarea automÃ¡tica para que el equipo se reinicie automÃ¡ticamente en el momento de la definiciÃ³n.",
            computerShutdown:
                "Establezca esta tarea automÃ¡tica para que el equipo se apague automÃ¡ticamente en el momento de la definiciÃ³n.",
            dispenserCleaning:
                "Establezca esta tarea automÃ¡tica para que %{name} solicite la acciÃ³n para limpiar el dispensador automÃ¡ticamente en el momento definido. El operador dispensador necesita limpiar la mÃ¡quina con un paÃ±o manualmente.",
            humidifierWaterLevelMaintenance:
                "Establezca esta tare automÃ¡tica para que %{name} solicite la acciÃ³n para rellenar el humidificador automÃ¡ticamente en el momento definido. El operador del dispensador debe comprobar y rellenar manualmente el agua del humidificador.",
            purgeAll:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la acciÃ³n para purgar todos los canales automÃ¡ticamente en el momento definido.",
            purgeChannels:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la acciÃ³n para purgar canales especÃ­ficos automÃ¡ticamente en el momento definido.",
            recirculateAll:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la acciÃ³n para recircular todos los canales automÃ¡ticamente en el momento definido.",
            recirculateChannels:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la acciÃ³n para recircular canales especÃ­ficos automÃ¡ticamente en el momento definido.",
            refillAll:
                "Configure esta tarea automÃ¡tica para que %{name} solicite la acciÃ³n para rellenar todos los canales automÃ¡ticamente a la hora definida. El operador del dispensador debe rellenar manualmente todos los recipientes con colorantes.",
            refillCanisters:
                "Configure esta tarea automÃ¡tica para que %{name} solicite la acciÃ³n para rellenar canales especÃ­ficos automÃ¡ticamente a la hora definida. El operador del dispensador debe rellenar manualmente los colorantes en los depÃ³sitos que no cumplen con el criterio de recarga.",
            smartPurgeAll:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la acciÃ³n para purgar todos los canales automÃ¡ticamente en el momento definido. La purga se llevarÃ¡ a cabo a menos que se cumplan las reglas de purga inteligente.",
            smartPurgeChannels:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la acciÃ³n para purgar canales especÃ­ficos automÃ¡ticamente en el momento definido. La purga se llevarÃ¡ a cabo a menos que se cumplan las reglas de purga inteligente.",
            stirAll:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la solicitud de la acciÃ³n para agitar todos los canales automÃ¡ticamente en el momento definido.",
            stirCanisters:
                "Establezca esta tarea automÃ¡tica para que el dispensador realice la solicitud de la acciÃ³n para agitar canales especÃ­ficos automÃ¡ticamente en el momento definido.",
            switchPlateMaintenance:
                "Establezca esta tarea automÃ¡tica para que %{name} solicite la acciÃ³n para limpiar la placa de conmutaciÃ³n automÃ¡ticamente en el momento definido. El operador dispensador debe quitar, limpiar y, a continuaciÃ³n, devolver la placa de conmutaciÃ³n manualmente."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "El nÃºmero de lote que prevalece se utiliza para la impresiÃ³n teniendo en cuenta su cantidad real en el depÃ³sito. Vaya a ConfiguraciÃ³n del depÃ³sito para definir el umbral de cada depÃ³sito.",
            batchNumberFromLastFilling:
                "El lote de la Ãºltima rellenado dado por el operador se utiliza para imprimir independientemente de la cantidad rellenada.",
            enableBatchNumber:
                "Con esta opciÃ³n activada, se realiza un seguimiento de los lotes de colorante rellenados."
        },
        connection: {
            add: "Permite agregar un nuevo servidor manualmente si no se pudo detectar a travÃ©s de la funciÃ³n Discover.",
            clientIdentifier:
                "La configuraciÃ³n permite identificar este cliente si hay mÃ¡s clientes conectados a un servidor.",
            disconnect:
                "InformaciÃ³n sobre el servidor utilizado actualmente. El botÃ³n de desconexiÃ³n permite salir de este servidor y cambiar a otro si estÃ¡ disponible.",
            discover: "Descubre si hay otros servidores disponibles en la red.",
            dropServers: "Elimina todos los servidores detectados previamente de la lista.",
            dropServersNotAvailable: "No hay servidor disponible",
            edit: "Permite editar manualmente un servidor ya encontrado.",
            editDisabled: "No hay servidor seleccionado."
        },
        continue: "Â¿De verdad quiere continuar?",
        driverSettings: {
            alfaRestApi: {
                host: "Escriba el nombre de host del equipo o la direcciÃ³n IP del equipo.",
                machineType: "VÃ¡lido para todas las mÃ¡quinas Alfa. Windows y Linux."
            },
            corobDsProxy: {
                machineType:
                    "VÃ¡lido para generaciones Slave (D200, D600..), 4G (First One) y 5G (EvoFlx). DspProxy debe estar instalado. Solo Windows."
            },
            corobEvoDriver: {
                machineType: "VÃ¡lido para la generaciÃ³n 5G (EvoFlx). EVOservice debe estar instalado. Windows y Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile:
                    "Seleccione el archivo de configuraciÃ³n del dispensador. ConfiguraciÃ³n predeterminada.",
                hldRootDir: "Seleccione la carpeta principal de HLD. ConfiguraciÃ³n predeterminada.",
                machineType:
                    "VÃ¡lido para Corob Flex (500, 520, 540) = antiguo Lenteq. HLD debe estar instalado. Solo Windows."
            },
            corobNextDriver: {
                machineType:
                    "VÃ¡lido para generaciones Slave (D200, D600 ..), 4G (First One) y 5G (EvoFlx). NextDriver debe estar instalado y tener licencia. Solo Linux."
            },
            dromontDDrv: {
                databasePath:
                    "Ruta de acceso al archivo de base de datos con datos de calibraciÃ³n. ConfiguraciÃ³n predeterminada.",
                driverPath: "Ruta de acceso al driver (D_DRV.exe). ConfiguraciÃ³n predeterminada.",
                machineType:
                    "ComunicaciÃ³n indirecta del dispensador a travÃ©s de trazados establecidos. VÃ¡lido para las generaciones V1 y V2. D_SET debe estar instalado. Windows y Linux.",
                resultPath:
                    "Ruta de acceso al archivo de resultados creado una vez finalizado la operaciÃ³n. ConfiguraciÃ³n predeterminada.",
                serviceSoftwarePath:
                    "Ruta de acceso al software de servicio Dromont (D_SET.exe). ConfiguraciÃ³n predeterminada."
            },
            dromontDirect: {
                machineType:
                    "ComunicaciÃ³n directa del dispensador. VÃ¡lido para las generaciones V1 y V2. D_SET debe estar instalado. Windows y Linux.",
                rootDir: "Seleccione la carpeta principal de Dromont, preestablecida por defecto."
            },
            dromontMisura: {
                driverPath:
                    "La ruta de acceso al controlador (MisuraRetail.exe) podrÃ­a cambiar en funciÃ³n de la versiÃ³n de Misura Retail. ConfiguraciÃ³n predeterminada.",
                extensionPath: "Ruta de acceso al archivo de comunicaciÃ³n para acciones de servicio.",
                formulaPath: "Ruta de acceso al archivo de comunicaciÃ³n para su dosificaciÃ³n.",
                machineType: "VÃ¡lido para la generaciÃ³n V3. Dromont Misura debe estar instalado. Solo Windows."
            },
            fastAndFluidIDD: {
                machineType: "VÃ¡lido para todas las mÃ¡quinas F&F. Solo Windows.",
                path: "Compatibles con IDD2 (HA 450, HA 650, X-smart, etc.) - debe tener licencia, IDD3 (HP 500, etc.), IDD4 (HA 180, HA 480, HA 680, Xprotint, etc.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "VÃ¡lido para todas las mÃ¡quinas F&F. Windows y Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "VÃ¡lido para todas las mÃ¡quinas Hero. Solo Windows."
            },
            italtinto: {
                machineType:
                    "VÃ¡lido para todas las mÃ¡quinas Italtinto. Wcal o ItaltintoCal deben estar instalados. Solo Windows.",
                path: "Ruta de acceso al archivo de configuraciÃ³n de Italtinto ajustado."
            },
            manualAdvanced: {
                machineType: "VÃ¡lido para todas las mÃ¡quinas manuales, soporte de depÃ³sito incluido. Windows y Linux.",
                path: "Ruta de acceso al archivo de configuraciÃ³n con datos sobre el dispensador y los contenedores."
            },
            manualSimple: {
                machineType: "VÃ¡lido para todas las mÃ¡quinas manuales. Windows y Linux.",
                path: "Ruta de acceso al archivo de configuraciÃ³n con datos sobre el dispensador."
            },
            none: {
                machineType: "No se ha seleccionado ningÃºn driver del dispensador."
            },
            santintColorLink3: {
                machineType: "VÃ¡lido para todas las mÃ¡quinas Santint. Solo Windows."
            },
            simulation: {
                machineType:
                    "VÃ¡lido para dispensador de simulaciÃ³n si no hay ningÃºn dispensador real conectado al ordenador.",
                path: "Ruta de acceso al archivo de configuraciÃ³n de simulaciÃ³n que debe estar de acuerdo con la base de datos insertada."
            },
            udcp: {
                machineType: "Dosificador UDCP"
            }
        },
        environment: {
            activeServerPlugins: "La visiÃ³n general de plugins de software adicionales.",
            allowAutoCloseTab:
                "Con la configuraciÃ³n activada, cada pestaÃ±a de fÃ³rmula se cerrarÃ¡ automÃ¡ticamente una vez finalizado el proceso de dosificaciÃ³n.",
            allowAutomaticClientStart:
                "Con esta configuraciÃ³n activada, %{name} se iniciarÃ¡ automÃ¡ticamente despuÃ©s del inicio del equipo.",
            allowAutomaticPrint:
                "La etiqueta se imprimirÃ¡ automÃ¡ticamente. Requiere una configuraciÃ³n adicional sobre la impresiÃ³n antes de dispensar, despuÃ©s de dispensar o ambas cosas.",
            allowBuildingSitePanel: "En el Panel FÃ³rmula, el panel de la obra estarÃ¡ disponible.",
            allowCustomers: "En el panel FÃ³rmula, se podrÃ¡ acceder a la secciÃ³n de clientes.",
            allowDispensing:
                "En el Panel de fÃ³rmulas, el botÃ³n dosificaciÃ³n se activarÃ¡ junto con las opciones de dosificaciÃ³n en ConfiguraciÃ³n de la mÃ¡quina.",
            allowFileTransfer:
                " Con esta opciÃ³n activada, la importaciÃ³n y exportaciÃ³n automÃ¡tica de datos por transferencia de archivos estÃ¡ disponible.",
            allowFormulaModificationPanel: "En el panel FÃ³rmula, se activarÃ¡ el panel ModificaciÃ³n.",
            allowFormulaStatusPanel: "En el Panel de fÃ³rmulas, se activarÃ¡ el panel Estado.",
            allowLight: "%{name} serÃ¡ accesible.",
            allowOrdering: "En el panel FÃ³rmula, se activarÃ¡ el botÃ³n Pedido.",
            allowPricing:
                "En el panel FÃ³rmula, se pueden utilizar los precios. La visibilidad de los precios se establece en Precios disponibles. Los precios se establecen en ConfiguraciÃ³n de precios.",
            allowProductPreviewImage: "La imagen del producto se mostrarÃ¡ durante la dosificaciÃ³n.",
            allowQualityControl: "Se activarÃ¡ el control de calidad.",
            allowSearchCheaperColors:
                "En el Panel de fÃ³rmulas, la funciÃ³n de bÃºsqueda de colores mÃ¡s baratos estarÃ¡ disponible.",
            allowSoundNotification:
                "La notificaciÃ³n sonora de pedido reproduce melodÃ­a musical cuando se recibe un pedido.",
            allowSpectro: "Se podrÃ¡ acceder a la secciÃ³n espectrofotÃ³metro.",
            allowTabs:
                "Con esta configuraciÃ³n encendida, el trabajo con varias pestaÃ±as simultÃ¡neamente estÃ¡ disponible.",
            applyZoom:
                "El zoom amplÃ­a o reduce la resoluciÃ³n. Las teclas de abreviaciÃ³n CTRL + y CTRL - tambiÃ©n son aplicables.",
            automaticLogout: "Establezca despuÃ©s de cuÃ¡ntos minutos debe activarse el cierre de sesiÃ³n automÃ¡tico.",
            availableDatabases: "La configuraciÃ³n permite cambiar entre bases de datos si hay mÃ¡s de una disponible.",
            backupLocalDB:
                "Exporta la base de datos local. El archivo exportado puede utilizarse como copia de seguridad de la base de datos.",
            barcodeTesting:
                "El entorno de prueba de cÃ³digos de barras sirve para comprobar la correcciÃ³n del cÃ³digo de barras escaneado comparÃ¡ndolo con los cÃ³digos de barras insertados en la base de datos.",
            customBanner: "Establece tu propio logotipo o banner y su posiciÃ³n.",
            customCurrencyFormat:
                "El formato de moneda personalizado puede invalidar el formato de moneda predeterminado en funciÃ³n del idioma seleccionado. ",
            customDateFormat:
                "El formato de fecha personalizado puede invalidar el formato de fecha predeterminado en funciÃ³n del idioma seleccionado.",
            customNumberFormat:
                "El formato numÃ©rico personalizado puede invalidar el formato numÃ©rico predeterminado en funciÃ³n del idioma seleccionado.",
            customTimeFormat:
                "El formato de tiempo personalizado puede invalidar el formato de tiempo predeterminado en funciÃ³n del idioma seleccionado.",
            defaultPrinter:
                "La impresora seleccionada se utilizarÃ¡ al imprimir etiquetas a menos que se cambie en la ventana Opciones de impresora.",
            defaultTemplate:
                "La plantilla seleccionada se utilizarÃ¡ al imprimir etiquetas a menos que se cambie en la ventana Opciones de impresora.",
            deleteImportedData:
                "Elimina los datos personalizados importados anteriormente. Los datos se pueden volver a importar despuÃ©s de la eliminaciÃ³n.",
            diskSpaceNotification:
                "Comprueba el espacio disponible en el disco y notifica en caso de espacio insuficiente.",
            dispensingNotes: "En el panel FÃ³rmula, se podrÃ¡ acceder a la secciÃ³n de notas dispensadoras.",
            downloadListEmpty: "No hay descargas en curso",
            enableVirtualKeyboard: "En %{name}, el teclado virtual estarÃ¡ disponible.",
            exportLocalSettings:
                "Exporta la configuraciÃ³n local de este ordenador. El archivo se puede importar a otro ordenador para aplicar configuraciones locales idÃ©nticas.",
            exportStaticSql:
                "Exporta la configuraciÃ³n local de este equipo. El archivo exportado se puede utilizar para crear una base de datos con esta configuraciÃ³n.",
            exportTranslationKeys:
                "Exporte las traducciones mÃ¡s recientes y despuÃ©s de traducirlas, envÃ­elas por correo electrÃ³nico a su proveedor de software para importarlas.",
            favoriteButton: "Haga clic para agregar la fÃ³rmula como favorita",
            formulaNotes: "En el panel FÃ³rmula, se podrÃ¡ acceder a la secciÃ³n de notas de fÃ³rmula.",
            helpSettings: "La informaciÃ³n es visible en la secciÃ³n Ayuda del panel de acceso rÃ¡pido.",
            importCustomData: "Importa los datos personalizados locales en funciÃ³n del formato seleccionado.",
            importExcelFile: "Importa los datos del archivo excel para aÃ±adir a la base de datos",
            importsLocalSettings: "Importa la configuraciÃ³n local exportada desde otro ordenador.",
            internalNote: "En el panel FÃ³rmula, se podrÃ¡ acceder a la secciÃ³n de notas internas.",
            lockComputer:
                "La configuraciÃ³n garantiza que no se puede salir del entorno de %{name}, lo que permite la experiencia definitiva en modo quiosco. Solo aplicable en Windows.",
            maxNumberTabs: "Tabulador establece cuÃ¡ntas pestaÃ±as de fÃ³rmula se pueden abrir simuladamente.",
            memoryTabs: "Permitir la reapertura de las pestaÃ±as abiertas recientemente tras el inicio del software.",
            printAfterDispensing:
                "La configuraciÃ³n requiere informaciÃ³n sobre cuÃ¡ntas copias de etiquetas se deben imprimir despuÃ©s del proceso de dosificaciÃ³n.",
            printAsImage:
                "Imprimir como imagen ayuda a resolver los problemas cuando falla la forma de impresiÃ³n estÃ¡ndar. No lo utilice cuando la impresiÃ³n estÃ¡ndar funcione correctamente. Compatible solo con Linux.",
            printBeforeDispensing:
                "La configuraciÃ³n requiere informaciÃ³n sobre cuÃ¡ntas copias de etiquetas se deben imprimir antes del proceso de dosificaciÃ³n.",
            printEnabled:
                "Esta configuraciÃ³n permite utilizar la impresora con el software. La configuraciÃ³n adicional se encuentran en ConfiguraciÃ³n de impresiÃ³n.",
            printOnRequest: "En el panel FÃ³rmula, se activarÃ¡ el botÃ³n Imprimir.",
            printTaskVariable:
                "La tarea de impresiÃ³n solo se procesa si se dispone de una variable de impresiÃ³n en los datos de impresiÃ³n",
            quickTintTemplate: "La plantilla seleccionada se utilizarÃ¡ al imprimir etiquetas de dosificaciÃ³n rÃ¡pidÃ¡.",
            restoreLocalSettings:
                "Restaura la configuraciÃ³n local de este ordenador. DespuÃ©s de eliminar todas las configuraciones, se puede crear una nueva configuraciÃ³n.",
            runLightAtStartUp: "%{light} se iniciarÃ¡ en lugar de %{name}.",
            screenSaverTimeout: "Ajustar despuÃ©s de cuÃ¡ntos minutos se debe activar el salvapantallas.",
            selectCustomDataFormat:
                "Seleccione el formato de los datos originales que desea importar. Cada formato puede requerir diferentes archivos y configuraciones adicionales.",
            setCustomHomeButton: "El botÃ³n de inicio en %{name} se redirigirÃ¡ al panel seleccionado.",
            setFts: "La bÃºsqueda de texto completo permite la bÃºsqueda de fÃ³rmulas de texto completo (tambiÃ©n desde la mitad de la palabra, etc.).",
            setKeyboardShortcuts:
                "No es posible establecer las mismas teclas de abreviaciÃ³n para dos acciones diferentes.",
            setNumberOfDecimalPlaces:
                "El redondeo establece cuÃ¡ntos decimales de colorantes utilizados en la fÃ³rmula se mostrarÃ¡n.",
            setOrderSearchParameters:
                "La bÃºsqueda de pedidos define quÃ© parÃ¡metros se utilizan al buscar entre pedidos. Solo se puede acceder a Ã©l en %{name}.",
            setOverwriteLastTab:
                "Al elegir una nueva fÃ³rmula a travÃ©s de la bÃºsqueda global, mientras que se alcanza el lÃ­mite de la ficha de fÃ³rmula, la nueva selecciÃ³n de fÃ³rmulas sobrescribirÃ¡ la Ãºltima pestaÃ±a de fÃ³rmula cargada.",
            setSearchPanel:
                "Establezca su propia visibilidad y orden de los elementos utilizados al buscar una nueva fÃ³rmula.",
            setVisibilityAndOrder:
                "Los elementos de navegaciÃ³n seleccionados estarÃ¡n visibles en el panel de acceso rÃ¡pido. La posiciÃ³n mÃ¡s alta aquÃ­ define la posiciÃ³n mÃ¡s a la izquierda en el panel. La cantidad mÃ¡xima permitida de elementos de navegaciÃ³n es de 6.",
            setYourLanguage: "El cambio de idioma requiere el reinicio del software.",
            settingsSearch: "Busque varios ajustes si no estÃ¡ seguro de dÃ³nde encontrarlos.",
            showNewOrderNotifications:
                "La notificaciÃ³n de pedido es una ventana emergente que anuncia que se ha recibido un nuevo pedido.",
            sorting:
                "El tintado rÃ¡pido puede tener los depÃ³sitos ordenados de acuerdo con los nombres de los colorantes o por los IDs de los depÃ³sitos.",
            turnOnKioskMode: "El modo quiosco activo oculta la barra de tareas.",
            windowClosingRules:
                "La configuraciÃ³n decide si la ventana de tintado rÃ¡pido se cierra antes o despuÃ©s del comienzo del proceso de dosificaciÃ³n."
        },
        formulaSettings: {
            additionalFormulaTab:
                "La configuraciÃ³n decide quÃ© panel se mostrarÃ¡ al abrir una nueva pestaÃ±a de fÃ³rmula.",
            allowCustomFormulas: "Se activarÃ¡ la creaciÃ³n y bÃºsqueda de fÃ³rmulas personalizadas.",
            allowCustomPackageSize: "En el panel FÃ³rmula, se activarÃ¡ la opciÃ³n de tamaÃ±o de envase personalizado.",
            allowEditingColorants:
                "En el panel FÃ³rmula, se activarÃ¡ el botÃ³n Editar colorante (visible despuÃ©s de seleccionar un color).",
            alternativeFormulasPosition: "Define cÃ³mo acceder a fÃ³rmulas alternativas.",
            basePanelSize: "Fijar el tamaÃ±o de la base en el panel FÃ³rmula",
            bippPanelSize: "Ajuste el tamaÃ±o de la base en el envase del producto en el panel FÃ³rmula",
            blendColorNameAndCode:
                "El ajuste une los campos de bÃºsqueda de Nombre del color y CÃ³digo para crear un Ãºnico campo de bÃºsqueda.",
            color: "En el panel FÃ³rmula, la vista previa de color serÃ¡ la Ãºnica informaciÃ³n visible.",
            colorCodePrimary: "El cÃ³digo de color aparecerÃ¡ primero en el campo de bÃºsqueda.",
            colorPreviewAsImage: "En el panel FÃ³rmula, la vista previa del color estarÃ¡ representada por la imagen.",
            colorPreviewResizable: "Permite cambiar el tamaÃ±o del panel de vista previa de color.",
            colorantPanelLimit:
                "Este parÃ¡metro fija el nÃºmero de colorantes que serÃ¡n siempre visibles antes de esconderse bajo la barra de desplazamiento",
            colorantPanelOrderBy:
                "El panel fÃ³rmula puede tener los colorantes ordenados de acuerdo con los nombres o por cantidades.",
            customCanOption:
                "Elija quÃ© unidades de medida se pueden utilizar para el tamaÃ±o de envase personalizado en el panel FÃ³rmula.",
            customCanSettingsUnit:
                "Elija quÃ© unidad de medida se puede utilizar como predeterminada para la configuraciÃ³n de envases personalizados en el panel FÃ³rmula.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Al habilitar esta configuraciÃ³n, las ventanas emergentes confirmarÃ¡n la eliminaciÃ³n de un elemento.",
            dropDownCalculate:
                "El menÃº desplegable para seleccionar la fÃ³rmula que busca se extenderÃ¡ hasta la parte inferior de la ventana.",
            fandeckGroups:
                "El ajuste permite la jerarquÃ­a con grupos cartas de colores si estÃ¡n disponibles en la base de datos.",
            fandeckPanelSize: "TamaÃ±o de la carta de colores en el panel FÃ³rmula",
            favoriteFormulasInitial: "Al iniciar %{name}, aparecerÃ¡ el panel Favoritos.",
            formulaAutomaticNaming:
                "Una fÃ³rmula modificada se nombrarÃ¡ automÃ¡ticamente en funciÃ³n de las modificaciones colorantes realizadas.",
            formulaPanel: "Al abrir una nueva pestaÃ±a, aparecerÃ¡ el panel FÃ³rmula.",
            formulaPanelInitial: "Al iniciar %{name}, aparecerÃ¡ el panel FÃ³rmula.",
            formulaPanelSize: "Definir el tamaÃ±o del color en el panel FÃ³rmula",
            formulaPropertiesPosition: "Define cÃ³mo acceder a las propiedades de las fÃ³rmulas.",
            generateColorPreview:
                "Con esta configuraciÃ³n activada, la vista previa de color se generarÃ¡ automÃ¡ticamente. La vista previa resultante no es precisa.",
            historicalFormulasPosition: "Define cÃ³mo acceder a las fÃ³rmulas histÃ³ricas.",
            image: "En el panel FÃ³rmula, la imagen del producto serÃ¡ visible junto a la vista previa de color con la posibilidad de abrir el panel con mÃ¡s informaciÃ³n.",
            images: "La configuraciÃ³n define la fuente de los archivos de imagen.",
            infoPanelResizable: "Permite cambiar el tamaÃ±o de mÃ¡s paneles de informaciÃ³n.",
            initialFormulaTab: "La configuraciÃ³n decide quÃ© panel se mostrarÃ¡ despuÃ©s de que se inicie %{0}.",
            moreInfo:
                "En el panel FÃ³rmula, el panel de informaciÃ³n estarÃ¡ visible junto a la vista previa del color y la vista previa de la imagen del producto.",
            orderByDistance:
                "Con esta opciÃ³n activada, el resultado de la bÃºsqueda de color se ordena por una mÃ©trica de distancia especial.",
            productCode:
                "La configuraciÃ³n permite utilizar cÃ³digos de producto junto con nombres de productos si estÃ¡n disponibles en la base de datos.",
            productFiles:
                "El ajuste define la fuente de los archivos de producto que estÃ¡n disponibles en el panel FÃ³rmula.",
            productGroups:
                "El ajuste permite la jerarquÃ­a con grupos de productos si estÃ¡ disponible en la base de datos.",
            productPanelSize: "Establecer el tamaÃ±o del producto en el panel FÃ³rmula",
            searchNewFormula:
                "Al abrir una nueva pestaÃ±a, aparecerÃ¡ buscar nueva fÃ³rmula (contiene informaciÃ³n sobre las Ãºltimas fÃ³rmulas dispensadas y fÃ³rmulas favoritas).",
            searchNewFormulaInitial:
                "Al iniciar %{name}, aparecerÃ¡ la nueva fÃ³rmula de bÃºsqueda (contiene informaciÃ³n sobre las Ãºltimas fÃ³rmulas dispensadas y fÃ³rmulas favoritas).",
            searchPanelFormulaItems: "Se debe seleccionar al menos uno de los elementos de fÃ³rmula.",
            searchPanelProductItems: "Solo se puede seleccionar uno de los artÃ­culos del producto.",
            searchPanelQuickSelect:
                "No es necesario pulsar el botÃ³n de cargar fÃ³rmula. Se le redirigirÃ¡ directamente a la pestaÃ±a principal de fÃ³rmulas justo despuÃ©s de seleccionar la fÃ³rmula.",
            setCompetitiveColorSearch:
                "Con esta configuraciÃ³n puesta, la funciÃ³n de bÃºsqueda competitiva de color en La paleta de colores estÃ¡ disponible.",
            setFormulaInfoInPreview:
                "En el panel FÃ³rmula, el tipo de datos seleccionado siempre estarÃ¡ visible en la vista previa de color.",
            setFormulaPreview:
                "La configuraciÃ³n cambia la posiciÃ³n y la visualizaciÃ³n de la vista previa del color, la imagen del envase y los datos de informaciÃ³n sobre el color.",
            setFormulaRGBPreviewVisibleInformation:
                "En el panel FÃ³rmula, el tipo de datos seleccionado siempre estarÃ¡ visible en la vista previa de color.",
            setFormulaUnit:
                "En el panel FÃ³rmula, esta configuraciÃ³n decide quÃ© unidad de colorante se abre como primero despuÃ©s de seleccionar un color. TambiÃ©n aplicable en tintado rÃ¡pido.",
            setFormulaVisibilityAndOrder:
                "En el panel FÃ³rmula, los datos seleccionados serÃ¡n visibles en la secciÃ³n MÃ¡s informaciÃ³n (solo se aplica si la vista previa de fÃ³rmula establecida en la configuraciÃ³n de FÃ³rmula es Imagen o MÃ¡s informaciÃ³n).",
            setMaxToleranceForCompetitiveColors:
                "Establezca la tolerancia Delta E mÃ¡xima (CIE 2000) para una bÃºsqueda de color competitiva.",
            setNumberOfCompetitiveColors:
                "Defina cuÃ¡ntos colores master competitivos deben ofrecerse tras la bÃºsqueda. El nÃºmero definido no corresponde al nÃºmero de resultados.",
            setVisibleUnit:
                "En el panel FÃ³rmula, esta configuraciÃ³n decide quÃ© unidades de colorantes son visibles despuÃ©s de seleccionar un color. TambiÃ©n aplicable en tintado rÃ¡pido.",
            showColorPreview:
                "En el panel FÃ³rmula, muestra una pequeÃ±a vista previa de color junto al nombre de color al buscar una nueva fÃ³rmula.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "En el panel FÃ³rmula, muestra la informaciÃ³n sobre el cÃ³digo de color."
        },
        formulaValidation: {
            batchNumberInvalid: "El depÃ³sito (%{colorants}) se llena con un lote defectuoso de colorante.",
            batchNumberWarning: "El colorante (%{colorants}) con este nÃºmero de lote puede estar daÃ±ado.",
            bellowBaseLimit: "La suma de las cantidades de colorantes estÃ¡ por debajo del lÃ­mite base.",
            checkColorantBaseRules:
                "El ajuste comprueba si los colorantes y la base utilizados pueden utilizarse en esta combinaciÃ³n.",
            checkMinDosableAmount:
                "La cantidad mÃ­nima es la cantidad colorante mÃ¡s pequeÃ±a que se puede dispensar segÃºn lo recomendado por el laboratorio.",
            checkOverfill:
                "La configuraciÃ³n comprueba si hay suficiente espacio en el envase para los colorantes inmediatamente despuÃ©s de establecer las cantidades.",
            checkTotalCntAmounts:
                "La configuraciÃ³n comprueba si se han agotado los lÃ­mites de las cantidades colorantes mÃ­nimas y mÃ¡ximas del envase base del producto. Estos lÃ­mites se definen en la base de datos.",
            colorantBaseRules: "El colorante no es vÃ¡lido para la base seleccionada.",
            colorantMinAmount: "La cantidad de colorante estÃ¡ por debajo de la cantidad mÃ­nima dispensable.",
            dispensingWithErrorsEnabled:
                "Si se permite, aparecerÃ¡ un mensaje de advertencia en caso de infracciones de validaciÃ³n, pero serÃ¡ posible proceder a la dosificaciÃ³n.",
            invalidBatchNumber: "El colorante tiene un nÃºmero de lote no vÃ¡lido o defectuoso",
            overBaseLimit: "La suma de las cantidades de colorantes supera la mÃ¡xima  cantidad dispensable.",
            overfill: "Se ha detectado sobrellenado.",
            unifyColorantBatchForMultipleCans:
                "Si se permite, aparecerÃ¡ un mensaje de informaciÃ³n cuando la cantidad de colorante sea mayor que el mÃ¡ximo del depÃ³sito y el depÃ³sito no estÃ© lleno al mÃ¡ximo.",
            warningConfirmBtn: "Conozco los riesgos, continÃºa"
        },
        help: "Ayuda",
        helpLink: "Centro de ayuda",
        helper: {
            automaticallyCheckForUpdates:
                "Se comprobarÃ¡ automÃ¡ticamente si hay alguna actualizaciÃ³n disponible para %{name} o base de datos en el intervalo de tiempo dado.",
            automaticallyDownloadUpdates:
                "Si hay una actualizaciÃ³n disponible, se descargarÃ¡ automÃ¡ticamente sin tener que confirmarla.",
            automaticallyInstallNewDatabases:
                "Si se envÃ­a una base de datos hasta ahora ausente, se instalarÃ¡ como una nueva base de datos. La base de datos se podrÃ¡ utilizar despuÃ©s.",
            automaticallyInstallUpdates:
                "Si se ha descargado una actualizaciÃ³n, se instalarÃ¡ automÃ¡ticamente sin tener que confirmarla.",
            canBrowseChangeLog:
                "Al actualizar el software, el registro de cambios oficial %{name} estarÃ¡ disponible para su consulta",
            forceInstall: "La actualizaciÃ³n se instalarÃ¡ a la fuerza.",
            installDuringNight: "La actualizaciÃ³n se instalarÃ¡ durante la noche si el ordenador estÃ¡ encendido."
        },
        licensing: {
            collect:
                "Los archivos de registro se descargarÃ¡n en la ubicaciÃ³n seleccionada. Los archivos de registro son requeridos por el software suministrado para el anÃ¡lisis de errores.",
            company: "La empresa que suministrÃ³ la licencia.",
            computerID:
                "IdentificaciÃ³n de licencia para ayudar al proveedor de software en caso de asistencia requerida.",
            email: "La direcciÃ³n de correo electrÃ³nico del titular de la licencia.",
            licenseUuid:
                "IdentificaciÃ³n de licencia para ayudar al proveedor de software en caso de asistencia requerida.",
            name: "El nombre del titular de la licencia.",
            openBugreport:
                "Por favor, hÃ¡ganos saber si hay un error en el software y envÃ­enos un informe con la descripciÃ³n del error.",
            posInfoContactperson: "InformaciÃ³n de POS sobre el propietario que se imprimirÃ¡ en la etiqueta.",
            posInfoMachineInformation:
                "InformaciÃ³n de POS sobre el dispensador que se imprimirÃ¡ en la etiqueta o se reconocerÃ¡ en la red.",
            posInfoPos: "InformaciÃ³n de POS sobre la ubicaciÃ³n que se va a imprimir en la etiqueta.",
            reactivation: "ReactivaciÃ³n o cambio de la licencia actual.",
            refresh: "Descargue la informaciÃ³n mÃ¡s reciente sobre licencias.",
            refreshUnavailable: "La actualizaciÃ³n de la licencia no estÃ¡ disponible porque usted estÃ¡ desconectado.",
            registrationContactperson: "InformaciÃ³n de registro para identificar al propietario de la licencia.",
            registrationMachineInformation: "InformaciÃ³n de registro para identificar el dispensador de la licencia.",
            registrationPos: "InformaciÃ³n de registro para identificar la ubicaciÃ³n de la licencia.",
            versionScope: "Los lÃ­mites de expiraciÃ³n del software.",
            versionType: "El tipo de producto de software."
        },
        machineIsBusy: "Los errores no se pueden restablecer ya que el equipo estÃ¡ ocupado.",
        machineSettings: {
            allowManualColorantAddition:
                "Si la cantidad de colorante requerida supera la cantidad mÃ¡xima de dosificaciÃ³n, el ajuste permite agregarla manualmente despuÃ©s de la dosificaciÃ³n.",
            autotasks:
                "Las tareas automÃ¡ticas son eventos automÃ¡ticos de mantenimiento de mÃ¡quinas y ordenadores que se pueden configurar para que se realicen en determinados momentos o intervalos de tiempo.",
            barcodeRefillValidation: "El ajuste activa la validaciÃ³n del cÃ³digo de barras en el relleno.",
            barcodeRefillValidationBaseAndColorant:
                "ComprobaciÃ³n del cÃ³digo de barras al rellenar el depÃ³sito y el envase de colorante.",
            barcodeRefillValidationColorant: "ComprobaciÃ³n del cÃ³digo de barras al rellenar el envase de colorante.",
            canisterBarcode:
                "El cÃ³digo de barras se asigna al contenedor en el que estÃ¡ disponible el colorante. El cÃ³digo de barras es necesario para garantizar un correcto relleno del colorante.",
            checkCanBeforeDispense: "El ajuste solo es vÃ¡lido para simulaciÃ³n rÃ¡pida y fluida.",
            checkOverfill:
                "El ajuste comprueba si hay suficiente lugar en el envase para los colorantes antes de dispensar.",
            currentlySelectedMachine: "Proporciona informaciÃ³n sobre el equipo seleccionado actualmente.",
            dispenseInvalidColorants:
                "El ajuste permite dispensar colorantes que no estÃ¡n definidos en la configuraciÃ³n de la mÃ¡quina solicitando la adiciÃ³n de colorante manual.",
            dispenserConfigurationBackup:
                "Descargue y guarde la configuraciÃ³n actual del equipo para mantener una copia de seguridad.",
            dispensingLogic:
                "Los tipos lÃ³gicos de dosificaciÃ³n pueden garantizar un comportamiento diferente para cada depÃ³sito cuando hay mÃ¡s colorante que dispensar de lo permitido o deseado. El comportamiento adicional se establece en ConfiguraciÃ³n de dosificaciÃ³n.",
            enableTmc: "La configuraciÃ³n permite enviar datos a TMC.",
            enableUserIdentification: "El usuario tiene que iniciar sesiÃ³n antes de que se permita la dosificaciÃ³n.",
            machineUnit: "La unidad de mÃ¡quina define la unidad de medida de colorantes en los depÃ³sitos.",
            minDispensedAmount:
                "La cantidad mÃ­nima dispensada establece cuÃ¡nto colorante se tiene que haber dispensado para considerar la purga realizada (para evitar purgas adicionales).",
            minimalDispenseAmount:
                "La cantidad mÃ­nima de dosificaciÃ³n es la cantidad colorante mÃ¡s pequeÃ±a que se puede dispensar segÃºn lo recomendado por el fabricante del dispensador. Si se infringe, aparecerÃ¡ un mensaje de advertencia (la dosificaciÃ³n sigue siendo posible).",
            missingAutotaskCanisters: "Debe seleccionarse al menos 1 depÃ³sito",
            missingAutotaskChannels: "Debe seleccionarse al menos 1 canal",
            missingAutotaskChannelsValue: "El volumen de todos los canales seleccionados debe rellenarse",
            missingAutotaskCleanTime: "El tiempo de limpieza debe rellenarse",
            missingAutotaskName: "El nombre de la tarea automÃ¡tica debe rellenarse",
            missingAutotaskRecirculation: "El tiempo y la velocidad de la recirculaciÃ³n deben rellenarse",
            missingAutotaskStirring: "El tiempo y la velocidad de agitaciÃ³n deben rellenarse",
            missingAutotaskVolume: "El volumen de purga debe rellenarse",
            placeCanSensor:
                "El ajuste activa el sensor para la colocaciÃ³n de el envase - la dosificaciÃ³n no se iniciarÃ¡ a menos que el envase se haya colocado correctamente.",
            placeCanSensorDelay:
                "El ajuste recomendado vinculado con el sensor de la colocaciÃ³n de envase. Se asegura de que la dosificaciÃ³n se inicia sÃ³lo despuÃ©s del perÃ­odo de tiempo definido durante el cual el envase se ha colocado correctamente.",
            purgeVolume:
                "Purgar el volumen establece cuÃ¡nto colorante se estÃ¡ purgando al realizar la purga inteligente.",
            rccUrl: "Redlike Control Center (RCC) es responsable de la comunicaciÃ³n con el dispensador.",
            refillThreshold:
                "Si la cantidad de colorante en el depÃ³sito con el nÃºmero de UFI o de lote dado desciende por debajo de este lÃ­mite, dicho nÃºmero de UFI o de lote se descartarÃ¡.",
            refillThresholdBatch:
                "Si la cantidad de colorante en el depÃ³sito con el nÃºmero de lote dado desciende por debajo de este lÃ­mite, dicho nÃºmero de lote se descartarÃ¡.",
            refillThresholdUfi:
                "Si la cantidad de colorante en el depÃ³sito con el UFI dado desciende por debajo de este lÃ­mite, dicho UFI serÃ¡ desechado.",
            removeCanSensor:
                "El ajuste activa el sensor para la eliminaciÃ³n de envases - la dosificaciÃ³n no se considera hecha a menos que se haya eliminado el envase.",
            removeCanSensorDelay:
                "El ajuste recomendado vinculado con el sensor de la colocaciÃ³n de envase. Garantiza que la dosificaciÃ³n se haya terminado solo despuÃ©s del perÃ­odo de tiempo definido durante el cual se ha eliminado el envase.",
            skipPlaceCanDialog:
                "Con esta configuraciÃ³n activada, el dispensador no esperarÃ¡ al colocar una envase hasta que se pulse el botÃ³n OK, sino que iniciarÃ¡ el proceso de dosificaciÃ³n automÃ¡ticamente.",
            skipRemoveCanDialog:
                "Con esta configuraciÃ³n activada, el dispensador no esperarÃ¡ al quitar una envase hasta que se pulse el botÃ³n OK, pero considerarÃ¡ el proceso de dosificaciÃ³n terminado automÃ¡ticamente.",
            smartPurgeType:
                "El tipo de purga puede considerar dispensar solo o dispensar mÃ¡s otros eventos de purga al validar si se necesita purga inteligente.",
            splitFormula:
                "Si la cantidad de colorante requerida supera la cantidad mÃ¡xima de dosificaciÃ³n, el ajuste permite dispensar un trozo de colorante, rellenar el recipiente y, a continuaciÃ³n, continuar dispensando el resto.",
            tintometricSystem:
                "El sistema tintomÃ©trico (conjunto de colorantes disponibles) define quÃ© colorantes y fÃ³rmulas estarÃ¡n disponibles en la aplicaciÃ³n y los ajustes de la aplicaciÃ³n.",
            validateBarcodeBaseCan:
                "La base debe validarse a travÃ©s de cÃ³digo de barras antes de que se permita la dosificaciÃ³n. La configuraciÃ³n garantiza que se utilice la base correcta.",
            validateColorantsDuringInit:
                "La configuraciÃ³n de la mÃ¡quina se compararÃ¡ con la base de datos cada vez que se reinicie RCC. En caso de discrepancias, se produce una notificaciÃ³n."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Define cuÃ¡ntos resultados deben ofrecerse despuÃ©s de la coincidencia."
        },
        navigation: {
            barcodeScan: "Abre una ventana con la posibilidad de introducir el cÃ³digo de barras manualmente.",
            canisterBarcodes:
                "Abre una ventana con visiÃ³n general del cÃ³digo de barras del contenedor y la posibilidad de establecer el cÃ³digo de barras del contenedor.",
            canisterLevel:
                "Abre una ventana con visiÃ³n general de los niveles de contenedor y la posibilidad de establecer el nivel de contenedor.",
            canisters:
                "Abre un panel con visiÃ³n general de los niveles de contenedor y la posibilidad de establecer el nivel de contenedor.",
            clean: "Abrir una ventana con la posibilidad de limpiar los canales de la mÃ¡quina",
            colorPanel:
                "Abre un panel con la posibilidad de buscar una nueva fÃ³rmula en un carta de colores electrÃ³nico.",
            colorSearchTab:
                "Abre un panel con la posibilidad de buscar todos los colores en todas las cartas de colores.",
            colorantRefillHistory: "Abre una ventana con el resumen de los llenados de depÃ³sitos realizados.",
            customFormula: "Abre un panel con la posibilidad de crear una nueva fÃ³rmula personalizada.",
            customers:
                "Abre un panel con la visiÃ³n general de los clientes y la posibilidad de aÃ±adirlos/editarlos/eliminarlos.",
            dispensingHistory: "Abre un panel con la descripciÃ³n general de las dispensaciones realizadas.",
            favorites: "Abre un panel con la posibilidad de seleccionar una fÃ³rmula favorita.",
            help: "Abre una ventana con informaciÃ³n de servicio al cliente si la proporciona el proveedor.",
            hideItems: "Abre una ventana con la posibilidad de marcar productos y cartas de colores como ocultos.",
            historyOfOrders: "VÃ¡lido para %{name} exclusivamente, abre un panel con el resumen de Ã³rdenes dispensadas.",
            machineReset: "Inicia el restablecimiento del dispensador.",
            matching: "Abre un panel con la posibilidad de igualar el nuevo color con un espectrofotÃ³metro.",
            myOrders: "Abre un panel con la descripciÃ³n general de los pedidos enviados.",
            purge: "Abre una ventana con la posibilidad de establecer la purga del contenedor.",
            quickTint: "Abre una ventana con la posibilidad de realizar la dosificaciÃ³n manual.",
            searchFormula: "Abre un panel con la posibilidad de buscar una nueva fÃ³rmula.",
            spectro: "Abre un panel con la posibilidad de medir con un espectrofotÃ³metro.",
            stir: "Abre una ventana con la posibilidad de ajustar la agitaciÃ³n del depÃ³sito.",
            ticketing: "Abre un panel del sistema de tickets.",
            toDispense: "Abre un panel con la descripciÃ³n general de los pedidos recibidos."
        },
        noHelpForLicense: "No hay ayuda disponible para su licencia, pÃ­dale a su proveedor que la agregue.",
        posInfo: {
            sync: "Sincroniza datos con la secciÃ³n Registro"
        },
        poweredByDeso: "Con la tecnologÃ­a de %{name}",
        priceSettings: {
            VatPrice: "El IVA del colorante genÃ©rico serÃ¡ el mismo para todos los colorantes. Establecido en %.",
            VatPriceProduct: "El IVA del producto genÃ©rico serÃ¡ el mismo para cada colorante. Establecer en %.",
            basePurchase: "Precio de compra de la base calculada por litro (incluida la base exclusivamente).",
            basePurchasePriceProduct:
                "Precio de compra para el envase de la base dada. Establezca en la moneda seleccionada.",
            baseSell: "El precio de venta solo por la base (incluido el margen de base/recargo/descuento).",
            baseSellFull: "Precio de compra de la base (incluida solamente la base) sin descuento.",
            cntName: "Define a quÃ© colorante estÃ¡ relacionado el precio.",
            cntPurchase: "Precio de compra para colorantes (incluidos los colorantes exclusivamente).",
            cntPurchaseByName:
                "Precio de compra para colorantes calculado individualmente para cada uno (incluidos los colorantes exclusivamente).",
            cntPurchasePricePerLiter:
                "El precio de compra del colorante por litro (incluido el colorante exclusivamente). Establecer en la moneda seleccionada.",
            cntSell: "El precio de venta solo para colorantes (incluido el margen de colorantes/recargo/descuento).",
            cntSellByName:
                "El precio de venta de todos los colorantes utilizados en el producto calculado individualmente para cada uno (incluido el margen de colorantes/recargo/descuento).",
            cntSellFull: "Precio de compra de los colorantes (incluidos los colorantes exclusivamente) sin descuento.",
            cntSellFullByName:
                "Precio de compra de los colorantes calculado individualmente para cada uno (incluidos los colorantes exclusivamente) sin descuento.",
            cntSellPricePerLiter:
                "El precio de venta del colorante por litro (incluido el colorante exclusivamente). Establezca en la moneda seleccionada.",
            cntVat: "Valor del IVA colorante establecido en %.",
            colorants:
                "Los precios de los colorantes genÃ©ricos serÃ¡n los mismos para todos los colorantes. Se recomienda modificar el precio de compra por margen o recargo. Establecer en la moneda seleccionada.",
            colorantsPosCoeficient: "El coeficiente genÃ©rico de colorante para POS.",
            colorantsSellPrice:
                "Los precios de los colorantes genÃ©ricos serÃ¡n los mismos para todos los colorantes. Se recomienda modificar el precio de venta por descuento. Establecer en la moneda seleccionada.",
            currencyCodeNew: "El cÃ³digo de moneda debe estar en el formato oficial de tres letras, por ejemplo, EUR.",
            currencyNameNew: "El nombre de la moneda, por ejemplo Euro.",
            currencyRateNew:
                "El tipo de cambio hacia la moneda principal, por ejemplo 25.855 CZK por 1 â¬. La tasa debe editarse continuamente para mantenerse actualizada.",
            currencyRoundingNew:
                "El redondeo establece el menor valor de pago posible de la moneda, por ejemplo, el euro ha redondeo 0,01 porque el valor mÃ¡s pequeÃ±o posible es de 1 cÃ©ntimo.",
            currencySymbolNew: "El sÃ­mbolo oficial de la moneda, por ejemplo â¬ para el Euro.",
            defaultPrice: "Precio de colorante establecido en la base de datos seleccionada (sin IVA).",
            defaultPriceGroup:
                "Precio de colorante para el grupo de precios establecido en la base de datos seleccionada (sin IVA).",
            defaultVatPrice: "IVA de colorante establecido en la base de datos seleccionada.",
            discountHeader:
                "El descuento se descuenta del valor definido del precio colorante de compra. Establecer en %.",
            discountHeaderProduct:
                "El descuento de descuenta del valor definido del precio colorante del producto. Establecer en %.",
            export: "Exporte un archivo con los precios insertados actualmente. Se puede importar de nuevo despuÃ©s de haber modificado los precios.",
            import: "Importe un archivo con el formato correcto (exportado) para insertar o modificar los precios.",
            localPrices:
                "Los precios sugeridos son proporcionados por el administrador de la base de datos. Si estÃ¡ habilitado, estos precios se pueden editar localmente en este ordenador.",
            margin: "Elija quÃ© cÃ¡lculo de precio se debe utilizar para la definiciÃ³n del precio final disponible. El margen y el marcado suman, mientras que los descuentos se descuentan del precio de venta dado.",
            marginAll: "El precio del margen/recargo por varios envases (incluido el margen/recargo).",
            marginHeader: "Margen agrega el valor definido hasta el precio colorante de compra. Establecer en %.",
            marginHeaderProduct: "Margen agrega el valor definido al precio de compra del producto. Establecer en %.",
            marginPerPkg: "El precio del margen/recargo por un envase (incluido el margen/recargo).",
            markupHeader:
                "El recargo agrega el valor definido hasta al precio de compra del colorante. Establecer en %.",
            markupHeaderProduct:
                "El recargo agrega el valor definido hasta el precio de compra del producto. Establecer en %.",
            packagePricing: "Se establecen recargos adicionales individualmente por cada tamaÃ±o de envase.",
            packageSurcharge:
                "Los precios de los envases genÃ©ricos serÃ¡n los mismos para cada recargo por envase. Establecer en la moneda seleccionada.",
            priceDefinition: "La configuraciÃ³n define quÃ© tipos de precio se utilizan al calcular los precios finales.",
            priceGroupNumber:
                "La configuraciÃ³n define cuÃ¡ntos grupos de precios se utilizarÃ¡n. El intervalo para grupos de precios individuales se puede establecer en Valores predeterminados.",
            priceGroupPricePerLiter: "El precio de colorante utilizado al calcular el precio del grupo de precios.",
            priceGroups:
                "Grupos de precios muestra el nÃºmero del grupo de precios relevante (los lÃ­mites se establecen en la base de datos o en los valores predeterminados).",
            priceGroupsEnabled:
                "La configuraciÃ³n le permite trabajar con grupos de precios. Defina el intervalo en Valores predeterminados y precios individuales en Precios colorantes.",
            priceGroupsGeneric:
                "Los grupos de precios son intervalos de precios de la pintura final en funciÃ³n de los precios colorantes en la fÃ³rmula.",
            productBasePackageSellPrice:
                "Precio de venta por el envase de la base dada. Establezca en la moneda seleccionada.",
            productBaseSellPrice:
                "Precio de venta de base calculado por litro (incluye la base exclusivamente). Establezca en la moneda seleccionada.",
            productBaseVat: "Valor del IVA base del producto por el envase dado establecido en %.",
            productName: "Define a quÃ© base de productos estÃ¡ relacionado el precio.",
            productPosCoeficient: "El coeficiente genÃ©rico de producto para POS.",
            productPricing: "El precio de compra de todos los envases se utiliza al dispensar envases personalizados.",
            productSize: "Define a quÃ© envase de la base de productos dada estÃ¡ relacionado el precio.",
            productVat: "Valor base del IVA del producto establecido en %.",
            products:
                "Los precios de los productos genÃ©ricos serÃ¡n los mismos para todos los colorantes. Se recomienda modificar el precio de compra con el margen o recargo. Establecido en la moneda seleccionada.",
            productsSellPrice:
                "Los precios de los productos genÃ©ricos serÃ¡n los mismos para todos los colorantes. Se recomienda modificar el precio de venta por descuento. Establecer en la moneda seleccionada.",
            sellPriceAll: "El precio de venta de varios envases (incluida base, colorantes, margen/recargo/descuento).",
            sellPricePerKg:
                "El precio de venta del producto por kilogramo (incl. Base, colorantes, margen/recargo/descuento).",
            sellPricePerL:
                "El precio de venta del producto por litro (incl. Base, colorantes, margen/recargo/descuento).",
            sellPricePerPkg: "El precio de venta de un envase (incl. Base, colorantes, margen/recargo/descuento).",
            setPriceTypesVisibilityAndOrder:
                "En el panel FÃ³rmula, los precios seleccionados estarÃ¡n visibles en la secciÃ³n de precios. La posiciÃ³n mÃ¡s alta aquÃ­ define la posiciÃ³n mÃ¡s a la izquierda en la secciÃ³n.",
            surchargeAll: "El precio de una tarifa adicional por varios envases (incluido el recargo).",
            surchargePerPkg: "El precio de un suplemento por envase (incluido el recargo).",
            tintPurchaseAll:
                "El precio de compra para todo el proceso de tintado de mÃºltiples envases (incluidos los colorantes y los recargos).",
            tintPurchasePerPkg:
                "El precio de compra por todo el proceso de tintado de un envase (incluidos los colorantes y los recargos).",
            tintSellFullAll:
                "El precio de compra de todo el proceso de tintado de un envase (incl. colorantes y recargo) sin descuento.",
            tintlSellFullAllPerPackage:
                "El precio de compra para todo el proceso de tintado de varios envases (incl. colorantes y recargo) sin descuento.",
            totalPurchaseAll:
                "El precio total de compra del producto por varios envases (incluidos la bases y los colorantes).",
            totalPurchasePerKg:
                "El precio total de compra del producto por kilogramo (incluidos los colorantes y base).",
            totalPurchasePerL: "El precio total de compra del producto por litro (incluidos los colorantes y base).",
            totalPurchasePerPkg: "El precio total de compra del producto por envase (incluidos los colorantes y base).",
            totalSellFullAll:
                "El precio total de compra del producto por varios envases (incl. base y colorantes) sin descuento.",
            totalSellFullPerKg:
                "El precio total de compra del producto por kilogramo (incl. Base y colorantes) sin descuento.",
            totalSellFullPerLiter:
                "El precio total de compra del producto por litro (incl. Base y colorantes) sin descuento.",
            totalSellFullPerPackage:
                "El precio total de compra del producto por envase (incl. Base y colorantes) sin descuento.",
            withAndWithoutVat:
                "En el panel FÃ³rmula, el precio serÃ¡ visible en ambas variaciones, con y sin IVA, simultÃ¡neamente.",
            withVat: "En el panel FÃ³rmula, todos los precios solo serÃ¡n visibles con IVA incluido.",
            withoutVat: "En el panel FÃ³rmula, todos los precios solo estarÃ¡n visibles con IVA excluido."
        },
        qualityControlSettings: {
            colorDifference: "Modelo de diferencia de color para el control de calidad.",
            deltaA: "Define el lÃ­mite de tolerancia para delta 'a' en el control de calidad.",
            deltaB: "Define el lÃ­mite de tolerancia para delta 'b' en el control de calidad.",
            deltaE: "Define el lÃ­mite de tolerancia para delta E en el control de calidad.",
            deltaL: "Define el lÃ­mite de tolerancia para delta L en el control de calidad.",
            deltaMetamerism: "Define el lÃ­mite de tolerancia para el delta de metamerismo en el control de calidad."
        },
        registration: {
            sync: "Sincroniza datos con la secciÃ³n InformaciÃ³n de POS"
        },
        searchingPleaseWait: "Por favor, esperen, se busca el mejor match",
        setupSteps: {
            customData: "Datos personalizados",
            machineType: "Tipo de mÃ¡quina",
            userPreferences: "Preferencias del usuario"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "Cuando se utilizan valores perfilados, los resultados medidos se vuelven a calcular para eliminar el efecto de filtro. Permita esta opciÃ³n para la mediciÃ³n universal del espectrofotÃ³metro.",
            XRiteModelRM400: "No se requieren drivers.",
            datacolorDiagnosticTile: "Datacolor usa tabla de diagnÃ³stico",
            datacolorSilent: "Datacolor silencioso",
            measureModes: "Seleccione los niveles de brillo admitidos.",
            model: "Modelo",
            simulationPath: "Ruta de acceso al archivo de simulaciÃ³n. Ajuste preestablecido predeterminado.",
            spectroType: "Se debe instalar el driver oficial del espectrofotÃ³metro. Solo Windows.",
            spectroTypeCom:
                "Se debe instalar el driver oficial del espectrofotÃ³metro. Tenga cuidado con el puerto COM utilizado. Windows y Linux.",
            spectroTypeDataColorReader:
                "El ordenador tiene que tener conexiÃ³n Bluetooth. El espectrofotÃ³metro tiene que ser vinculado con el ordenador. Se requiere Windows 10 con actualizaciÃ³n automÃ¡tica de 2018.",
            spectroTypeMinolta2XXXd:
                "Se debe instalar el driver oficial del espectrofotÃ³metro. Tenga cuidado con el puerto COM utilizado. Windows y Linux.",
            spectroTypeNotSelected: "Seleccione el modelo de espectrofotÃ³metro.",
            spectroTypeRM400: "No se requieren drivers.",
            spectroTypeSimulation:
                "Valores de laboratorio necesarios para obtener resultados de simulaciÃ³n. Windows y Linux.",
            spectroTypeXRite: "Solo Windows."
        },
        ufiCode: {
            baseUfiCodeValidation:
                "El cÃ³digo UFI de la base puede validarse a travÃ©s de cÃ³digo de barras antes de que se permita la dosificaciÃ³n.",
            enableUfiCodes:
                "Los cÃ³digos UFI se utilizan en la UE y proporcionan informaciÃ³n sobre quÃ© de peligroso es un producto para el medio ambiente.",
            invalidUfi: "CÃ³digo UFI no vÃ¡lido",
            printUfiCode:
                "Si un colorante de una fÃ³rmula supera el lÃ­mite dado, su cÃ³digo UFI se imprimirÃ¡ en la etiqueta de impresiÃ³n.",
            printUfiCodePercentage:
                "Si un colorante en una fÃ³rmula supera el lÃ­mite dado, su cÃ³digo UFI se imprimirÃ¡ en la etiqueta de impresiÃ³n junto con su representaciÃ³n porcentual.",
            ufiCodesByPercentage:
                "El cÃ³digo UFI que prevalece se utiliza para imprimir teniendo en cuenta su cantidad real en el contenedor. Vaya a ConfiguraciÃ³n de Contenedor para definir el umbral de cada contenedor.",
            ufiCodesFromDatabase:
                "El cÃ³digo UFI de la base de datos principal dada por el administrador de la base de datos se utiliza para la impresiÃ³n.",
            ufiCodesFromLastFilling:
                "El cÃ³digo UFI del Ãºltimo llenado realizado por el operador se utiliza para imprimir independientemente del importe rellenado."
        },
        userManagement: {
            add: "La configuraciÃ³n agrega un nuevo usuario que puede iniciar sesiÃ³n en el software. El usuario puede tener un cÃ³digo de barras asignado y se puede configurar para iniciar sesiÃ³n automÃ¡ticamente despuÃ©s de iniciar el software.",
            assignedGroups:
                "Esto define a quÃ© grupos de usuarios pertenece el usuario. Varios grupos de usuarios distribuyen varios privilegios.",
            availableGroups:
                "Esto define quÃ© grupos de usuarios hay disponibles para el usuario. Varios grupos de usuarios distribuyen varios privilegios.",
            loggedUserDelete: "Actualmente no se puede eliminar el usuario que ha iniciado sesiÃ³n."
        },
        visit: "O visitar",
        visitNoLicense: "Para obtener mÃ¡s informaciÃ³n, visite"
    },
    helpSettings: {
        customHelpLink: "Enlace personalizado del Centro de ayuda",
        helpSettings: "Configuraciones de ayuda",
        message: "Mensaje"
    },
    helper: {
        automaticallyCheckForUpdates: "Compruebe si hay actualizaciones automÃ¡ticamente",
        automaticallyDownloadUpdates: "Descargar actualizaciones automÃ¡ticamente",
        automaticallyInstallNewDatabases: "Instalar automÃ¡ticamente nuevas bases de datos",
        automaticallyInstallUpdates: "Instalar actualizaciones automÃ¡ticamente",
        bugReport: "Informe de fallo",
        canBrowseChangeLog: "Mostrar registro de cambios %{name} online",
        collect: "Recoger",
        collectLogFiles: "Recopilar archivos de registro",
        component: "Componente",
        content: "Contenido",
        contentSize: "TamaÃ±o del contenido",
        download: "Descargar",
        downloadLogFiles: "Descargar archivos de registro",
        downloadingData: "Descarga de datos",
        everyHours: "Cada %{interval} horas",
        forceInstall: "Forzar la actualizaciÃ³n",
        installDuringNight: "Durante la noche (%{start} - %{end}) cada %{interval} hora",
        newVersion: "Nueva versiÃ³n",
        notConnected: "Helper no estÃ¡ conectado",
        openBugReport: "Abrir informe de errores",
        packageSize: "TamaÃ±o de envase",
        pleaseWait: "Por favor, espere, esto puede llevar algÃºn tiempo.",
        send: "Enviar",
        sendBugReportToCustomerService: "Enviar un reporte de fallo",
        sendingReport: "Enviando",
        subject: "Asunto"
    },
    helperDialog: {
        1: "Puede buscar actualizaciones de software o base de datos.",
        2: "Â¿Continuar con la descarga de los paquetes de actualizaciÃ³n?",
        3: "Â¿Continuar con la instalaciÃ³n de paquetes de actualizaciÃ³n descargados?",
        10: "ComprobaciÃ³n de actualizaciones de software y bases de datos, espere...",
        11: "Hay una actualizaciÃ³n disponible para su ordenador. Â¿Quiere descargarla?",
        12: "No hay actualizaciones disponibles para su ordenador.",
        14: "Se ha producido un error durante la comprobaciÃ³n de actualizaciones. %{0}",
        15: "Sincronizar bases de datos de zona, espere...",
        20: "Descargando el paquete de actualizaciÃ³n, espere...",
        21: "El paquete de actualizaciÃ³n que se descargÃ³ ahora se estÃ¡ verificando, espere...",
        22: "Error al descargar el paquete de actualizaciÃ³n, Â¿desea volver a intentarlo?",
        23: "La descarga del paquete de actualizaciÃ³n ha fallado (el archivo estÃ¡ mal formado), Â¿desea volver a intentarlo?",
        24: "Â¿Continuar con la instalaciÃ³n de la actualizaciÃ³n?",
        25: "La instalaciÃ³n de la actualizaciÃ³n automÃ¡tica se iniciarÃ¡ en %{0}",
        26: "Hay una actualizaciÃ³n disponible para su ordenador. Â¿Quiere descargarla?",
        27: "Â¿Continuar con la instalaciÃ³n de la actualizaciÃ³n?",
        40: "Deteniendo aplicaciones y servicios, espere...",
        41: "Copiando nuevos archivos, por favor, espere...",
        42: "Iniciando aplicaciones y servicios, espere...",
        43: "FinalizaciÃ³n de la actualizaciÃ³n de software, por favor, espere...",
        44: "Su software se ha actualizado correctamente.",
        45: "Â¿Desea reintentar la instalaciÃ³n? Si decide reintentar, asegÃºrese de que los componentes de software no estÃ©n actualmente en uso.",
        46: "Se requiere reiniciar el PC para mostrar cambios, el reinicio se realizarÃ¡ en %{0}",
        999: "Error interno: %{0}",
        automaticInstallation: "InstalaciÃ³n automÃ¡tica de actualizaciones",
        btnAbort: "Anular",
        btnCancel: "Cancelar",
        btnCheckUpdate: "Buscar actualizaciones",
        btnContinue: "Continuar",
        btnDownloadUpdate: "Descargar actualizaciÃ³n",
        btnInstallUpdate: "Instalar actualizaciÃ³n",
        btnOk: "OK",
        btnRetry: "Reintentar",
        btnSkip: "Omitir",
        checkingForUpdates: "ComprobaciÃ³n de actualizaciones",
        downloadingFailed: "Error en la descarga",
        downloadingPackage: "Descargar el paquete de actualizaciÃ³n, por favor, espere",
        finishingUpdate: "ActualizaciÃ³n final",
        installingUpdate: "InstalaciÃ³n de la actualizaciÃ³n",
        internalError: "Error interno",
        rebootRequired: "Se requiere reiniciar",
        startingComponents: "Inicio de componentes de software",
        stoppingComponents: "Detener componentes de software",
        synchronizingDatabases: "Sincronizando las bases de datos de la zona",
        updateAvailable: "ActualizaciÃ³n disponible, seleccione componentes que se actualizarÃ¡n",
        updateDownloaded: "La actualizaciÃ³n se ha descargado",
        updateFailed: "El proceso de actualizaciÃ³n ha fallado",
        updateInstalled: "Se ha instalado la actualizaciÃ³n",
        verificationFailed: "Error en la verificaciÃ³n del paquete de actualizaciÃ³n",
        verifyingPackage: "VerificaciÃ³n del paquete descargado",
        yourSoftwareIsUpToDate: "Su software estÃ¡ actualizado",
        yourSoftwareVersion: "Su versiÃ³n de software: %{0}"
    },
    importData: {
        abortImportingData: "Anular la importaciÃ³n",
        aborted: "La importaciÃ³n fue anulada.",
        backupLocalDB: "Backup base de datos local",
        confirmRestore: "Â¿De verdad desea restaurar todos los ajustes locales?",
        dataMissing: "Error en la importaciÃ³n porque el archivo de origen no contenÃ­a ningÃºn dato.",
        deleteImportedData: "Eliminar datos importados",
        encodingFile: "CodificaciÃ³n de archivos",
        exportLocalSettings: "Exportar configuraciones locales",
        exportStaticSql: "Exportar SQL estÃ¡tico",
        fileDamaged: "Error al importar porque el archivo de origen parece estar daÃ±ado.",
        fileMissing: "Error en la importaciÃ³n porque el archivo de origen no existe.",
        format: "Formato",
        formatPath: "Ruta de formato",
        headerMissing: "Error en la importaciÃ³n porque falta el encabezado de los archivos.",
        import: "ImportaciÃ³n",
        importAborted: "ImportaciÃ³n anulada",
        importAborting: "AnulaciÃ³n de importaciones",
        importFailed: "Error en la importaciÃ³n debido a un error inesperado.",
        importLocalSettings: "Importar configuraciones locales",
        importPrices: "Importar precios",
        imported: "La importaciÃ³n se completÃ³ correctamente.",
        importedWithErrors: "La importaciÃ³n ha finalizado con errores. Se han omitido las lÃ­neas de error.",
        importing: "Importando",
        noFormatAvailable: "Sin formato disponible",
        processing: "Procesando",
        processingCustomFormulas: "Procesamiento de fÃ³rmulas personalizadas",
        processingCustomers: "Procesamiento de clientes",
        productsFile: "Archivo de productos",
        restoreLocalSettings: "Restaurar la configuraciÃ³n local",
        underProgress: "La importaciÃ³n estÃ¡ en curso.",
        unknownFormat: "Error al importar porque el archivo de origen es de formato desconocido.",
        userFormulasFile: "Archivo de fÃ³rmulas de usuario"
    },
    infoType: {
        baseDensity: "Densidad de base",
        baseMass: "Peso de la base",
        baseUfiCode: "CÃ³digo UFI base",
        baseVolume: "Volumen de la base",
        batchNumbersTable: "Cuadro de nÃºmeros de lote",
        bfsGrade: "Grado BFS",
        colorLab: "Color Lab",
        colorRgb: "Color RGB",
        colorRgbHex: "Color RGB Hex",
        colorXyz: "Color xyz",
        colorantBatchNumbers: "NÃºmeros de lote de los colorantes",
        colorantMass: "Peso del colorante",
        colorantUfiCodes: "CÃ³digos UFI de colorantes",
        colorantVolume: "Volumen del colorante",
        formulaDate: "Fecha de la fÃ³rmula",
        formulaDatetime: "Fecha y hora de la fÃ³rmula",
        formulaMoreInfo: "MÃ¡s informaciÃ³n sobre la fÃ³rmula",
        formulaMoreInfoInternal: "MÃ¡s informaciÃ³n interna sobre la fÃ³rmula",
        formulaMoreInfoPrint: "MÃ¡s informaciÃ³n sobre la impresiÃ³n de fÃ³rmula",
        hbw: "HBW",
        isPackageGravimetric: "Es un envase gravimÃ©trico",
        maxColorantMass: "MÃ¡ximo peso de colorante permitido",
        maxColorantVolume: "Volumen colorante mÃ¡ximo permitido",
        nominalMass: "Masa nominal del envase",
        nominalVolume: "Volumen nominal del envase",
        overfillDetected: "Sobrellenado detectado",
        totalPaintDensity: "Densidad total de la pintura",
        totalPaintMass: "Peso total de pintura",
        totalPaintVolume: "Volumen total de pintura",
        ufiCodesTable: "Tabla de cÃ³digos UFI",
        verifiedFormula: "FÃ³rmula verificada",
        yValue: "Valor Y"
    },
    initialTab: {
        favoriteFormulas: "FÃ³rmulas favoritas",
        lastDispensedFormulas: "Ãltimas fÃ³rmulas dispensadas",
        searchNewFormula: "Buscar nueva fÃ³rmula"
    },
    invalidBatchNumbersModal: {
        header: "Comprobar colorantes NÃºmero de lote",
        info: "Al menos un depÃ³sito estÃ¡ lleno de un lote (posiblemente) defectuoso de colorante. No utilice este lote. VacÃ­e el depÃ³sito con dosificaciÃ³n rÃ¡pida.",
        unknownStatus: "Estado del lote desconocido"
    },
    keyWords: {
        action: "acciÃ³n",
        add: "agregar",
        addition: "adiciÃ³n",
        additional: "adicional",
        address: "direcciÃ³n",
        admin: "admin",
        advanced: "Avanzado",
        after: "despuÃ©s",
        afterDispensing: "despuÃ©s de dispensar",
        alfa: "Alfa",
        all: "todo",
        allow: "permitir",
        alphabetically: "alfabÃ©ticamente",
        amount: "cantidad",
        api: "api",
        ask: "preguntar",
        autocap: "TapÃ³n de boquillas",
        autotask: "tarea automÃ¡tica",
        availablePrice: "precio disponible",
        backup: "copia de seguridad",
        banner: "banner",
        barcode: "cÃ³digo de barras",
        barcodes: "cÃ³digos de barras",
        base: "base",
        before: "antes",
        begin: "empezar",
        bfs: "bfs",
        bottom: "fondo",
        brand: "marca",
        brush: "cepillo",
        bug: "fallo",
        button: "botÃ³n",
        buy: "comprar",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibraciÃ³n",
        can: "envase",
        canHandling: "manejo de envase",
        canister: "depÃ³sito",
        canisterFilling: "llenado de depÃ³sito",
        canisterLevels: "niveles de depÃ³sitos",
        canisters: "depÃ³sitos",
        cap: "tapa",
        center: "Centro",
        centre: "Central",
        change: "cambio",
        changelog: "registro de cambios",
        channels: "canales",
        check: "comprobar",
        chunk: "trozo",
        chunks: "trozos",
        city: "ciudad",
        clean: "limpiar",
        cleaning: "limpieza",
        clientIdentifier: "identificador de cliente",
        close: "cerrar",
        closest: "mÃ¡s cercano",
        code: "cÃ³digo",
        collect: "recoger",
        color: "color",
        colorLink3: "ColorLink3",
        colorPanel: "paleta de colores",
        colorReader: "ColorReader",
        colorant: "colorante",
        colorantConsumption: "consumo de colorante",
        colorantPrice: "precio de colorante",
        colorants: "colorantes",
        colorix: "Colorix",
        colour: "color",
        communication: "comunicaciÃ³n",
        compare: "comparar",
        competitive: "competitivo",
        computer: "ordenador",
        config: "configuraciÃ³n",
        configuration: "configuraciÃ³n",
        confirm: "confirmar",
        confirmation: "confirmaciÃ³n",
        connection: "conexiÃ³n",
        contactPerson: "persona de contacto",
        control: "Control",
        copies: "copias",
        corob: "Corob",
        cost: "coste",
        country: "paÃ­s",
        create: "crear",
        currency: "divisa",
        current: "actual",
        custom: "costumbre",
        customers: "clientela",
        daily: "diario",
        dark: "Dark",
        data: "datos",
        database: "base de datos",
        datacolor: "Datacolor",
        date: "fecha",
        decimals: "decimales",
        default: "predeterminado",
        delay: "demora",
        delete: "eliminar",
        deletion: "elimiaciÃ³n",
        deltaE: "delta e",
        device: "dispositivo",
        devices: "dispositivos",
        diagnosticTile: "tabla de diagnÃ³stico",
        dialog: "diÃ¡logo",
        direct: "directo",
        disconnect: "desconectar",
        discount: "descuento",
        dispense: "dispensar",
        dispenser: "dispensador",
        dispensing: "dosificaciÃ³n",
        down: "abajo",
        download: "descargar",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "editar",
        editor: "editor",
        email: "email",
        error: "error",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiraciÃ³n",
        export: "exportar",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "carta de colores",
        fastFluid: "Fast & Fluid",
        file: "archivo",
        fill: "llenar",
        fillToMax: "llenar al mÃ¡ximo",
        find: "encontrar",
        first: "primero",
        flex: "Flex",
        folder: "carpeta",
        formula: "fÃ³rmula",
        formulas: "fÃ³rmulas",
        from: "de",
        fts5: "fts5",
        fullScreen: "pantalla completa",
        fullText: "texto completo",
        fulltext: "texto completo",
        g: "g",
        genericPricing: "precios genÃ©ricos",
        hLD: "HLD",
        hard: "duro",
        hbw: "hbw",
        help: "Ayuda",
        helpCenter: "centro de ayuda",
        hero: "Hero",
        history: "historia",
        home: "inicio",
        host: "host",
        humidifier: "humidificador",
        iDD: "IDD",
        identification: "identificaciÃ³n",
        image: "imagen",
        impGallon: "imp. galÃ³n",
        impQuart: "imp. cuarto",
        import: "importaciÃ³n",
        individually: "individualmente",
        info: "informaciÃ³n",
        information: "informaciÃ³n",
        initial: "inicial",
        initialization: "inicializaciÃ³n",
        initialize: "inicializar",
        insert: "insertar",
        install: "instalar",
        intellyPurge: "purga inteligente",
        invalid: "no vÃ¡lido",
        ipAddress: "direcciÃ³n IP",
        italtinto: "Italtinto",
        items: "artÃ­culos",
        keyboard: "teclado",
        kg: "kg",
        kiosk: "quiosco",
        kioskMode: "modo quiosco",
        l: "l",
        lLD: "LLD",
        lab: "laboratorio",
        label: "etiqueta",
        labels: "etiquetas",
        language: "Idioma",
        largo: "largo",
        last: "Ãºltimo",
        lenteq: "Lenteq",
        levels: "niveles",
        license: "licencia",
        light: "Light",
        limit: "lÃ­mite",
        link: "enlace",
        linux: "Linux",
        load: "cargar",
        lock: "bloquear",
        logFiles: "archivos de registro",
        logic: "lÃ³gica",
        logo: "logotipo",
        lower: "bajar",
        machine: "mÃ¡quina",
        machineConfiguration: "configuraciÃ³n de la mÃ¡quina",
        machineManagement: "gestiÃ³n de mÃ¡quinas",
        machineName: "nombre de la mÃ¡quina",
        main: "principal",
        maintenance: "mantenimiento",
        manual: "manual",
        manualAddition: "adiciÃ³n manual",
        manualDispensing: "dosificaciÃ³n manual",
        manualScan: "escaneo manual",
        margins: "mÃ¡rgenes",
        markups: "recargos",
        mass: "masa",
        match: "match",
        measure: "medir",
        measurement: "mediciÃ³n",
        measurementUnits: "unidades de mediciÃ³n",
        melody: "melodÃ­a",
        message: "mensaje",
        minimal: "mÃ­nimo",
        minolta: "Minolta",
        minus: "menos",
        minutes: "minutos",
        misura: "Misura",
        ml: "ml",
        mode: "modo",
        model: "modelo",
        modification: "modificaciÃ³n",
        modify: "modificar",
        monthly: "mensual",
        moreInfo: "mÃ¡s informaciÃ³n",
        movableTable: "mesa mÃ³vil",
        move: "mover",
        music: "mÃºsica",
        myOrders: "mis pedidos",
        name: "nombre",
        naming: "nombramiento",
        nano: "Nano",
        navigation: "navegaciÃ³n",
        new: "nuevo",
        nextDriver: "NextDriver",
        night: "noche",
        nixPro: "Nix Pro",
        notes: "notas",
        notification: "notificaciÃ³n",
        number: "nÃºmero",
        off: "apagado",
        open: "abrir",
        order: "pedido",
        ordering: "pidiendo",
        overfill: "sobrellenar",
        overview: "visiÃ³n general",
        overwrite: "sobrescribir",
        own: "propio",
        pCPDriver: "PCPDriver",
        package: "envase",
        packagePrice: "precio del envase",
        packages: "Envases",
        panels: "paneles",
        parameter: "parÃ¡metro",
        path: "ruta",
        pc: "pc",
        phone: "TelÃ©fono",
        phoneNumber: "nÃºmero de telÃ©fono",
        picture: "imagen",
        place: "colocar",
        placement: "colocaciÃ³n",
        plug: "enchufe",
        plugger: "tapÃ³n",
        plugging: "plugging",
        plugin: "plugin",
        plus: "mÃ¡s",
        pointOfSale: "punto de venta",
        popUp: "pop-up",
        pos: "pos",
        present: "presente",
        preview: "vista previa",
        price: "precio",
        priceExport: "exportaciÃ³n de precios",
        priceGroup: "grupo de precios",
        priceImport: "importaciÃ³n de precios",
        prices: "precios",
        pricing: "precios",
        primaryCurrency: "moneda primaria",
        print: "impresiÃ³n",
        printer: "impresora",
        printing: "imprimiendo",
        problem: "problema",
        product: "producto",
        productPrice: "precio del producto",
        profiledValues: "valores perfilados",
        punch: "perforar",
        puncher: "perforadora",
        punching: "perforando",
        purge: "purga",
        purgeType: "tipo de purga",
        purgeVolume: "volumen de purga",
        quality: "calidad",
        quick: "rÃ¡pido",
        quickTint: "tintado rÃ¡pido",
        rM: "RM",
        raise: "levantar",
        rcc: "rcc",
        reader: "lector",
        reboot: "reiniciar",
        receive: "recibir",
        recirculate: "recircular",
        recirculation: "recirculaciÃ³n",
        redlike: "Redlike",
        refill: "relleno",
        registration: "registro",
        regular: "regular",
        removal: "eliminaciÃ³n",
        remove: "eliminar",
        report: "informe",
        reset: "restablecimiento",
        resolution: "resoluciÃ³n",
        restart: "reanudar",
        rgb: "rgb",
        rights: "derechos",
        rounding: "redondeo",
        rules: "reglas",
        sanTint: "SanTint",
        save: "guardar",
        scale: "escama",
        scan: "escanear",
        scope: "extensiÃ³n",
        screen: "pantalla",
        screensaver: "salvapantallas",
        search: "buscar",
        secondaryCurrency: "moneda secundaria",
        select: "escoger",
        selectedFormula: "FÃ³rmula seleccionada",
        sell: "vender",
        sensor: "sensor",
        serialNumber: "nÃºmero de serie",
        server: "servidor",
        servers: "servidores",
        service: "servicio",
        serviceAction: "acciÃ³n de servicio",
        serviceActions: "acciones de servicio",
        serviceSoftware: "software de servicio",
        serviceWindow: "ventana de servicio",
        settings: "ajustes",
        shelf: "estante",
        shortcuts: "teclas de abreviaciÃ³n",
        shot: "shot",
        show: "mostrar",
        shutDown: "apagar",
        shutdown: "apagado",
        silent: "En silencio",
        simple: "sencillo",
        simulation: "simulaciÃ³n",
        size: "tamaÃ±o",
        skip: "omitir",
        smartPurge: "purga inteligente",
        software: "software",
        softwareSupplier: "proveedor de software",
        sort: "ordenar",
        sound: "sonido",
        spectro: "espectrofotÃ³metro",
        spectrophotometer: "espectrofotÃ³metro",
        speed: "velocidad",
        split: "dividir",
        start: "empezar",
        startup: "arrancar",
        statistics: "estadÃ­sticas",
        status: "estado",
        stir: "remover",
        stirring: "removiendo",
        street: "calle",
        support: "soporte",
        surcharge: "recargo",
        tab: "pestaÃ±a",
        tabs: "pestaÃ±as",
        task: "tarea",
        template: "plantilla",
        testing: "testeando",
        time: "duraciÃ³n",
        tintingManagementCenter: "centro de gestiÃ³n del tintomÃ©trico",
        to: "a",
        toDispense: "dispensar",
        tolerance: "tolerancia",
        top: "arriba",
        total: "total",
        translation: "traducciÃ³n",
        turnOff: "apagar",
        turntable: "mesa giratoria",
        type: "tipo",
        uIDD: "UIDD",
        uSGallon: "GalÃ³n de EE.UU.",
        uSQuart: "Cuarto de EE.UU.",
        unit: "unidad",
        up: "hacia arriba",
        update: "actualizar",
        url: "URL",
        user: "usuario",
        userGroups: "grupos de usuarios",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "IVA",
        validate: "validar",
        validation: "validaciÃ³n",
        version: "versiÃ³n",
        virtual: "virtual",
        volume: "volumen",
        weekly: "semanal",
        window: "ventana",
        windows: "Windows",
        with: "con",
        without: "sin",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "valor y",
        zipCode: "cÃ³digo postal",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "InglÃ©s",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lituano",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "Activar licencia",
        activateNewLicense: "Activar nueva licencia",
        checkLicenseKey: "Verificar la clave de licencia",
        companyId: "ID de la compaÃ±Ã­a",
        contactPerson: "Persona de contacto",
        copy: "Copiar",
        country: "PaÃ­s",
        emptyCity: "La ciudad es una informaciÃ³n requerida",
        emptyCountry: "PaÃ­s es una informaciÃ³n requerida",
        emptyName: "El nombre de la tienda es una informaciÃ³n necesaria",
        enterIdentificationKeys: "Ingrese sus claves de identificaciÃ³n",
        expirationDate: "Fecha de expiraciÃ³n %{dateTime}",
        fillRegistration: "Complete los datos de registro (desplÃ¡cese hacia abajo para ver mÃ¡s)",
        insertLicense: "Inserte la clave generada para la activaciÃ³n offline",
        invalidEmail: "La entrada de correo electrÃ³nico no es vÃ¡lida",
        invalidPhone: "La entrada del telÃ©fono no es vÃ¡lida",
        itemsMarkedasterisk: "(los artÃ­culos marcados con un asterisco deben rellenarse)",
        lastUpdate: "Ãltima modificaciÃ³n %{dateTime}",
        leasedLicense: "Licencia arrendada",
        licenseActivated: "Licencia activada",
        licenseStatus: "Estado de la licencia",
        licenseWillExpire: "La licencia caduca en %{dayCount} dÃ­as",
        licenseWillExpireOneDay: "La licencia caduca en dÃ­a %{dayCount} dÃ­a",
        machineInformation: "InformaciÃ³n de la mÃ¡quina",
        noLicenseAvailable: "no hay licencia disponible",
        noProductsForKey: "No hay productos disponibles para las claves de identificaciÃ³n indicadas.",
        pointOfSale: "Punto de venta",
        producer: "Fabricante",
        reactivate: "Reactivar",
        reactivateLicense: "Reactivar licencia",
        region: "RegiÃ³n",
        registerLicense: "Coja una copia de la solicitud de activaciÃ³n y navegue hasta:",
        registrationForm: "Registro",
        selectProduct: "Seleccionar producto",
        serialNumber: "NÃºmero de serie",
        skipNewLicense: "Si desea activar una nueva licencia mÃ¡s adelante, puede hacer clic en Omitir",
        unlimitedLicense: "Licencia ilimitada",
        userId: "ID de usuario",
        uuid: "UUID de licencia",
        versionDetails: "Detalles de la versiÃ³n",
        versionScope: "Alcance de la versiÃ³n",
        versionType: "Tipo de versiÃ³n",
        zip: "cÃ³digo postal"
    },
    login: {
        authenticate: "Autentificar",
        logIn: "Iniciar sesiÃ³n",
        loginAs: "Inicie sesiÃ³n como otro usuario",
        messages: {
            incorrectUsername: "Nombre de usuario o contraseÃ±a incorrecta"
        },
        password: "ContraseÃ±a",
        username: "Nombre de usuario"
    },
    machineActionHistory: {
        actionHistory: "Historial de acciones"
    },
    machineErrors: {
        channel: "Canal",
        code: "CÃ³digo",
        machineErrors: "Errores de la mÃ¡quina",
        noMachineErrors: "Actualmente no hay errores de la mÃ¡quina",
        resetErrors: "Restablecer errores"
    },
    machineSettings: {
        action: "AcciÃ³n",
        addAutotask: "Agregar tarea automÃ¡tica",
        autoCanisterIn: "DepÃ³sito automÃ¡tico en",
        autoCanisterOut: "DepÃ³sito automÃ¡tico fuera",
        automaticRefill: "Relleno automÃ¡tico",
        autotaskSettings: "Ajustes de la tarea automÃ¡tica",
        backupConfiguration: "Copia de seguridad de la configuraciÃ³n del dispensador",
        brushMaintenance: "Mantenimiento de cepillos",
        capMaintenance: "Mantenimiento de la tapa",
        checkCanisterBeforeDispense: "Compruebe el depÃ³sito antes de dispensar",
        checkColorantBaseRules: "Comprobar las reglas de la base colorante",
        checkMinDosableAmount: "Compruebe la mÃ­nima cantidad de colorantes",
        checkOverfill: "Compruebe el sobrellenado de envase",
        checkTotalCntAmounts: "Compruebe la cantidad total de colorantes por la base de pintura",
        cleanAll: "Limpiar todo",
        computerReboot: "Reinicio del ordenador",
        computerShutdown: "Apagado del ordenador",
        connectMachine: "Conectar la mÃ¡quina",
        days: "DÃ­as",
        daysOfMonth: "DÃ­as del mes",
        devices: "Dispositivos",
        disabled: "Desactivado",
        dispenseAndPurge: "Dispensar y purgar",
        dispenseOnly: "Solamente dispensar",
        dispenserCleaning: "Limpieza del dispensador",
        dispensingWithErrorsEnabled: "Permitir la dosificaciÃ³n a pesar de los errores de validaciÃ³n",
        editAutotask: "Editar automatizaciÃ³n",
        firstRun: "Primera ejecuciÃ³n",
        hours: "Horas",
        humidifier: "Humidificador",
        humidifierWaterLevelMaintenance: "Mantenimiento del nivel de agua del humidificador",
        machineConfigurationNoCanisters: "La configuraciÃ³n de la mÃ¡quina no contiene depÃ³sitos.",
        machineName: "Nombre de la mÃ¡quina",
        machineSettings: "Configuraciones de la mÃ¡quina",
        manualPuncher: "Perforadora manual",
        minDispensedAmount: "Cantidad mÃ­nima dispensada",
        minutes: "Minutos",
        nextRun: "Siguiente ejecuciÃ³n",
        noAutotasksSet: "No hay tareas automÃ¡ticas establecidas",
        noDataAvailable: "Sin datos disponibles",
        noMachine: "No hay ninguna mÃ¡quina conectada",
        onStart: "Al inicio",
        plugger: "Plugger",
        postpone: "Se puede posponer",
        puncher: "Perforadora",
        purgeAll: "Purgar todo",
        purgeOnly: "Purgar solo",
        recirculateAll: "Recircular todo",
        recirculateChannels: "Recircular canales",
        recirculationSpeed: "Velocidad de recirculaciÃ³n",
        recirculationTime: "Tiempo de recirculaciÃ³n",
        refillAll: "Rellenar todo",
        refillCanisters: "Llenado de depÃ³sitos",
        runAt: "Diariamente a las ",
        runDefinedDaysAt: "DÃ­as definidos en",
        runEvery: "Ejecutar cada",
        runInDays: "Ejecutar en dÃ­as",
        serialNum: "NÃºmero de serie",
        settingsMachine: "MÃ¡quina de configuraciÃ³n",
        smartPurgeAll: "Purga inteligente de todo",
        smartPurgeChannels: "Canales de purga inteligente",
        smartPurgeRules: "Reglas de purga inteligente",
        startType: "Tipo de inicio",
        stirAll: "Remover todo",
        stirCanisters: "Remover depÃ³sitos",
        stirringSpeed: "Velocidad de agitaciÃ³n",
        stirringTime: "Tiempo de remociÃ³n",
        switchPlateMaintenance: "Mantenimiento de la placa de interruptores",
        theCurrentlySelectedMachine: "MÃ¡quina actualmente seleccionada",
        threshold: "Umbral",
        turntable: "Mesa giratoria",
        unifyColorantBatchForMultipleCans: "Unificar el lote de colorante para dispensar varios envases",
        volume: "Volumen",
        weekdays: "DÃ­as laborables"
    },
    mainTab: {
        acceptedFormula: "FÃ³rmula aceptada",
        addBuildingSite: "AÃ±adir obra",
        addToFavorites: "Agregar a los favoritos",
        alternativeFormulas: "FÃ³rmulas alternativas",
        alternativeValidFormulas: "FÃ³rmulas vÃ¡lidas alternativas",
        buildingSiteSpecification: "Especificaciones de la obra",
        colorantsAreInvalid: "Uno o mÃ¡s colorantes no son vÃ¡lidos",
        dispensedPackages: "Envases dosificados",
        dispensingInProgress: "dosificaciÃ³n en curso",
        dispensingIsAborted: "Se cancela la dosificaciÃ³n",
        dispensingIsNotAvailable: "La dosificaciÃ³n no estÃ¡ disponible",
        dispensingProgress: "%{done} de %{all}",
        editColorant: "Editar colorante",
        editNote: "Editar nota",
        findCompetitiveColor: "Intenta encontrar el color competitivo",
        forceDispensing: "Forzar dosificaciÃ³n",
        formulaInvalidColorants: "La fÃ³rmula contiene colorantes no vÃ¡lidos: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Propiedades de la fÃ³rmula",
        hiddenFandecks: "Cartas de colores ocultas",
        hiddenProducts: "Productos ocultos",
        historicalFormulas: "FÃ³rmulas histÃ³ricas",
        lowerDeltaNumber: "Un nÃºmero delta mÃ¡s bajo permite una coincidencia mÃ¡s precisa",
        machineError: "Error de mÃ¡quina",
        machineIsBusy: "La mÃ¡quina estÃ¡ ocupada",
        machineNotConnected: "La mÃ¡quina no estÃ¡ conectada",
        manualColorantAddition: "AdiciÃ³n de colorante manual",
        modifiedFormula: "La fÃ³rmula se modifica",
        modifiedFormulaInLab: "FÃ³rmula modificada en laboratorio",
        newColorAfterScaling: "Nuevo color despuÃ©s de escalar",
        newRgbNotAccuratelyMeasured: "El nuevo RGB no se mide con precisiÃ³n, solo es indicativo",
        noBaseAvailable: "No hay base disponible",
        noBuildingSiteAvailable: "No se dispone de informaciÃ³n sobre la obra",
        noColorantForCorrection: "Sin colorantes adicionales para la correcciÃ³n seleccionada",
        noColorants: "Sin colorantes",
        noCustomer: "NingÃºn cliente",
        noCustomers: "No hay clientes disponibles",
        noDispenseNotesAvailable: "No hay notas de dosificaciÃ³n disponibles.",
        noFormulaAvailable: "Ha seleccionado una combinaciÃ³n sin fÃ³rmula!",
        noFormulaSelected: "No se ha seleccionado ninguna fÃ³rmula",
        noInternalNotesAvailable: "No hay notas internas disponibles",
        noNotesAvailable: "No hay notas disponibles",
        noPackageAvailable: "NingÃºn envase disponible",
        noPackageSelected: "No se ha seleccionado ningÃºn envase",
        noProductAvailable: "NingÃºn producto disponible",
        noResultsFound: "No se han encontrado resultados",
        openLocalFile: "Abrir desde base de datos local",
        openOnlineFile: "Abrir desde Internet",
        order: "Pedido",
        orderingIsNotAvailable: "Toma de pedidos no estÃ¡ disponible",
        originalColor: "Color original",
        overAvailableLevel: "Sobre el nivel disponible",
        package: "Envases",
        packageIsRequired: "Se requiere envase",
        packaging: "Embalaje",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "La impresiÃ³n no estÃ¡ disponible",
        productFiles: "Archivos de producto",
        productFilesViewer: "Visor de archivos de productos",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Propiedades",
        regularPrice: "Precio regular",
        resetFormulaData: "Nueva fÃ³rmula",
        rgbOnlyIndicative: "RGB solo indicativo!",
        saveAsCustom: "Guardar como",
        saveToStatsIsNotAvailable: "Guardar en el historial no estÃ¡ disponible",
        searchForCheaper: "FÃ³rmula mÃ¡s econÃ³mica",
        selectFromCompetitive: "Puede seleccionar el color entre los colores de la competencia.",
        specialPrice: "Precio especial",
        specialPriceVip: "Precio especial VIP",
        splitFormula: "FÃ³rmula dividida",
        withVAT: "con IVA",
        withoutVAT: "sin IVA"
    },
    marginSettings: {
        allBases: "Todas las bases",
        allProducts: "Todos los productos",
        editMargin: "Editar margen",
        marginAndDiscountWarning:
            "Debe configurar la opciÃ³n de cÃ¡lculo de precios para utilizar mÃ¡rgenes y descuentos.",
        marginSettings: "ConfiguraciÃ³n de margen",
        marginsFor: "MÃ¡rgenes para",
        markupColorants: "Recargo del colorante",
        sizeOfPackage: "TamaÃ±o del envase",
        valueBase: "Valor de base",
        valueColorant: "Valor de colorante"
    },
    matching: {
        actualColor: "Color actual",
        allCorrections: "Todas las correcciones",
        allTillItems: "Todos los artÃ­culos",
        auto: "Auto",
        autoSelectAll: "Todos Auto",
        canStartCorrection: "A continuaciÃ³n, puede iniciar la correcciÃ³n.",
        canStartMatching: "A continuaciÃ³n, puede empezar la formulaciÃ³n.",
        cannotBeUsed: "No se puede utilizar la formulaciÃ³n.",
        changeProductAndColorants: "Pruebe a cambiar de producto o de colorantes",
        checkConfig: "Por favor, compruebe la configuraciÃ³n.",
        colorCorrection: "CorrecciÃ³n del color",
        colorIsIndicative: "La vista previa de color es solo orientativa",
        colorNotAccurate: "El color puede no ser mostrado con precisiÃ³n, depende de los parÃ¡metros de su monitor",
        colorantInDispensedFormula: "Colorantes en la fÃ³rmula dosificada",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Problema de conexiÃ³n",
        correctionHistory: "Historial de correcciones",
        correctionRunning: "CorrecciÃ³n en curso",
        draftFormula: "Draft formula",
        exclude: "Excluir",
        excludeAll: "Excluir todos",
        include: "Incluir",
        includeAll: "Incluir todos",
        invalidProduct: "No es posible formular para el producto %{productName}",
        itemOnly: "SÃ³lo artÃ­culo",
        manualColorCorrection: "CorrecciÃ³n de color manual",
        matchFormula: "FormulaciÃ³n",
        matchingInformation: "InformaciÃ³n de la formulaciÃ³n",
        matchingResult: "Resultado de la formulaciÃ³n",
        matchingRunning: "FormulaciÃ³n en curso",
        matchingSearchOptions: "Opciones de bÃºsqueda de formulaciones",
        measurement: "MediciÃ³n",
        noCorrection: "No se ha encontrado ninguna correcciÃ³n",
        noSpectralCurveProvided:
            "El dispositivo conectado no se puede utilizar para la formulaciÃ³n porque no proporciona curva espectral",
        notAvailableForMatching: "No disponible para formulaciÃ³n",
        originalFormula: "FÃ³rmula original",
        reformulate: "Reformular",
        reformulationRunning: "ReformulaciÃ³n en curso",
        resultColor: "Resultado color",
        saveAsCustomFormula: "Guardar como fÃ³rmula personal",
        searchInProgress: "BÃºsqueda en curso, por favor espere",
        selectColorfile: "Seleccione el color.",
        selectRequiredItems: "Seleccione producto, base, colorantes y envase.",
        selectedResult: "Resultado de la selecciÃ³n",
        spectralDataNotAvailable: "Datos espectrales no disponibles",
        startCorrection: "Iniciar correcciÃ³n",
        startMatching: "Empezar formulaciÃ³n",
        targetColor: "Color patrÃ³n",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Se utiliza para formulaciÃ³n"
    },
    modal: {
        changeColorantUnit: "Cambiar la unidad de colorante",
        payAttention: "Â¡Prestar atenciÃ³n!"
    },
    module: {
        productGroups: "Grupos de productos"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filtro de carta de colores",
            formulasOverLimit: "Aproximadamente %{count} resultados. Intente escribir mÃ¡s caracteres.",
            foundFormulas: "%{count} fÃ³rmulas encontradas",
            help: "Ayuda:",
            helpText:
                "Escriba, por ejemplo, '%{filter}' para buscar fÃ³rmulas que comiencen con '%{formula}', producto que comience con '%{product}' y carta de colores '%{fandeck}'.",
            productFilter: "Filtro de producto",
            searchInFormulas: "Buscar en fÃ³rmulas",
            typeMore: "Escriba mÃ¡s caracteres"
        },
        menu: {
            actionHistory: "Historial de acciones",
            additionalFormulaTab: "PestaÃ±a de fÃ³rmula adicional",
            advancedSettings: "ConfiguraciÃ³n avanzada",
            autotaskSettings: "Automatizaciones",
            availableDatabases: "Bases de datos disponibles",
            availablePrices: "Precios disponibles",
            bugReport: "Informe de errores",
            canisterBarcodes: "CÃ³digos de barras del depÃ³sito",
            canisterDispensingLogic: "LÃ³gica de dosificaciÃ³n",
            canisterFilling: "Llenado del depÃ³sito",
            canisterSettings: "ConfiguraciÃ³n del depÃ³sito",
            clientServerSettings: "ConexiÃ³n del cliente/servidor",
            closing: "Cierre",
            color: "Color",
            colorModification: "ModificaciÃ³n de color",
            colorPanel: "ConfiguraciÃ³n de paleta de colores",
            colorRepresentation: "RepresentaciÃ³n de color y datos",
            colorSearch: "BÃºsqueda de color",
            colorant: "Colorante",
            colorantConsumption: "Consumo de colorante",
            colorantPricing: "Precios de colorantes",
            colorantRefillHistory: "Historial de relleno de colorantes",
            competitiveSearch: "BÃºsqueda competitiva de color",
            connections: "Conexiones",
            currency: "Divisa",
            customData: "Datos personalizados",
            database: "Base de datos",
            databaseCheck: "ComprobaciÃ³n de bases de datos",
            databaseConnection: "ConexiÃ³n de base de datos",
            defaultValues: "Valores predeterminados",
            devices: "Dispositivos",
            dispensingHistory: "Historial de dosificaciÃ³n",
            dispensingSettings: "Ajustes de dosificaciÃ³n",
            driverSettings: "ConfiguraciÃ³n del controlador",
            environment: "Entorno",
            environmentConfiguration: "ConfiguraciÃ³n del entorno",
            environmentalSettings: "Ajustes de entorno",
            favorites: "Favoritos",
            fileTransfer: "Transferencia de archivos DESO",
            formatting: "Formateo",
            formula: "Formula",
            formulaData: "Datos",
            formulaModification: "ModificaciÃ³n de la fÃ³rmula",
            formulaPanels: "Paneles de fÃ³rmula",
            formulaSettings: "ConfiguraciÃ³n de fÃ³rmulas",
            formulaUnit: "Unidad de fÃ³rmula",
            generalSearch: "BÃºsqueda general",
            globalSettingsSearch: "BÃºsqueda de configuraciÃ³n global",
            helpItems: "ConfiguraciÃ³n de ayuda",
            importAndExport: "ImportaciÃ³n y exportaciÃ³n",
            importAndExportData: "ImportaciÃ³n y exportaciÃ³n de datos",
            importCustomData: "Importar datos personalizados",
            initialFormulaTab: "PestaÃ±a de fÃ³rmula inicial",
            interfaceSettings: "ConfiguraciÃ³n de la interfaz",
            keyboardShortcuts: "Teclas de abreviaciÃ³n",
            language: "Idioma",
            languageSettings: "ConfiguraciÃ³n de idioma",
            layout: "DiseÃ±o",
            license: "Licencia",
            licenseData: "Datos de licencia",
            licenseIdentification: "IdentificaciÃ³n de licencia",
            licenseStatus: "Estado de la licencia",
            licenseSupplier: "Proveedor de licencias",
            licenseVersion: "VersiÃ³n de licencia",
            localData: "Datos locales",
            machine: "InformaciÃ³n sobre la mÃ¡quina",
            machineActions: "Acciones de la mÃ¡quina",
            machineAndDevices: "MÃ¡quina y dispositivos",
            machineManagement: "GestiÃ³n de mÃ¡quinas",
            machineSettings: "ConfiguraciÃ³n de la mÃ¡quina",
            mainSettings: "ConfiguraciÃ³n principal",
            maintenance: "Mantenimiento",
            marginAndDiscount: "Margen y descuento",
            matchingSearchResult: "Resultados de la bÃºsqueda de formulaciÃ³n",
            matchingSettings: "Resultado de la bÃºsqueda",
            navigationItems: "Elementos de navegaciÃ³n",
            newFormulaWindow: "FÃ³rmula",
            orderSearch: "BÃºsqueda de pedidos",
            orderSettings: "ConfiguraciÃ³n de pedidos",
            packageSurcharge: "Recargo por envase",
            popUps: "Pop-Ups",
            posInfo: "InformaciÃ³n POS",
            price: "ConfiguraciÃ³n de precios",
            priceManagement: "GestiÃ³n de precios",
            priceSettings: "ConfiguraciÃ³n de precios",
            pricingOptions: "Opciones de precios",
            printSettings: "ConfiguraciÃ³n de impresiÃ³n",
            productPricing: "Precios del producto",
            qualityControlSettings: "Ajustes de control de calidad",
            quickTint: "ConfiguraciÃ³n de dosificaciÃ³n rÃ¡pida",
            rccConfig: "ConfiguraciÃ³n de RCC",
            rccConnection: "ConexiÃ³n RCC",
            rccSettings: "ConfiguraciÃ³n de RCC",
            refillSettings: "Ajustes de relleno",
            refillingLogic: "Relleno lÃ³gico",
            registration: "Registro",
            searchSettings: "ConfiguraciÃ³n de bÃºsqueda",
            serverPlugins: "Plugins de servidor",
            serviceActions: "Acciones de servicio",
            settings: "Ajustes",
            simplifiers: "Simplificadores",
            singleActions: "Acciones Ãºnicas",
            smartPurgeRules: "Reglas de purga inteligente",
            softwareOptions: "Opciones de software",
            spectroSettings: "Adjustes del espectrofotÃ³metro",
            statistics: "EstadÃ­sticas",
            switchToFrontdesk: "Cambiar a Frontdesk",
            switchToFullRedlike: "Cambiar a %{name}",
            switchToLight: "Cambiar a %{name}",
            switchToMachine: "Cambiar a MÃ¡quina",
            tabs: "PestaÃ±as y Pop-Ups",
            testBarcodes: "Prueba de cÃ³digo de barras",
            updateOptions: "Opciones de actualizaciÃ³n",
            userManagemenet: "GestiÃ³n de usuarios",
            visibleUnits: "Unidades visibles"
        },
        navBar: {
            barcode: "CÃ³digo de barras",
            help: "Ayuda",
            hideItems: "Ocultos productos / cartas de colores"
        },
        notificationPanel: {
            noNotifications: "Sin nuevas notificaciones"
        },
        tabBar: {
            closeActive: "Cerrar los activos",
            closeAll: "Cerrar todo",
            closeAllExceptActive: "Cerrar todos excepto los activos",
            customFormula: "Formula personal",
            dispensingHistory: "Historial de dosificaciÃ³n",
            favorites: "Favoritos",
            formulaSearch: "BÃºsqueda fÃ³rmula",
            rewriteSettings: "Reescribir parÃ¡metros locales"
        }
    },
    ordering: {
        assign: "Asignar",
        assignment: "AsignaciÃ³n",
        createdDate: "Fecha de creaciÃ³n",
        finishDispensing: "Acabar la dosificaciÃ³n",
        foundInOrders: "Encontrado en pedidos",
        inactiveDatabase: "La fÃ³rmula es de una base de datos inactiva o desconocida %{0}",
        inactiveUnknownDatabase: "La fÃ³rmula es de una base de datos inactiva o desconocida",
        newOrderReceived: "Â¡Ha recibido un nuevo pedido!",
        noOrderSelected: "NingÃºn pedido seleccionado",
        release: "Lanzamiento",
        status: {
            accepted: "aceptado",
            canceled: "cancelado",
            created: "creado",
            done: "hecho",
            partlyDone: "parcialmente hecho",
            preparing: "preparando",
            unknown: "desconocido"
        }
    },
    partialUpdates: {
        applying: "Aplicando actualizaciones parciales",
        cantBeUsedForYourDbVersion:
            "Las actualizaciones no se pueden utilizar para esta base de datos. Por favor, actualice a travÃ©s de Helper.",
        newVersionWillBeInstalled:
            "InstalarÃ¡ la nueva versiÃ³n incluyendo todas las actualizaciones parciales disponibles.",
        noPartialUpdatesAvailable: "No hay actualizaciones parciales",
        outOfDate: "caducado!",
        partialUpdates: "Actualizaciones parciales",
        partialUpdatesArePreparing: "Preparando actualizaciones parciales",
        partialUpdatesAvailable: "Actualizaciones parciales disponibles!",
        preparedUpdatesMessage: "Las siguientes actualizaciones parciales estÃ¡n listas para aplicarse",
        remindMeLater: "RecordÃ¡rmelo mÃ¡s tarde (despuÃ©s de %{time} minutos)",
        swOutOfDate: "La versiÃ³n actual del programa es",
        updateAutomatically: "Si no responde, la actualizaciÃ³n se iniciarÃ¡ automÃ¡ticamente en: %{time} s",
        updateToNewVersion: "Actualizar a la versiÃ³n mÃ¡s reciente",
        updateWillTakeMoreTime: "La actualizaciÃ³n llevarÃ¡ mÃ¡s tiempo.",
        updatesApplied: "La actualizaciones parciales han sido aplicadas",
        updating: "ActualizaciÃ³n de"
    },
    posInfo: {
        address: "DirecciÃ³n",
        contactName: "Nombre de contacto",
        contactPerson: "Persona de contacto",
        identification: "IdentificaciÃ³n",
        machineInformation: "InformaciÃ³n de la mÃ¡quina",
        pos: "Punto de venta",
        secondAddress: "Segunda direcciÃ³n",
        shopIdentification: "IdentificaciÃ³n de la tienda",
        shopName: "Nombre de tienda",
        url: "Url",
        zipCode: "CÃ³digo postal"
    },
    priceTypeList: {
        priceBasePurchase: "Precio de coste de la base",
        priceBaseSell: "Precio de venta por base",
        priceBaseSellFull: "Vender precio completo por la base",
        priceCntPurchase: "Precio de coste de los colorantes",
        priceCntPurchaseByColorantName: "Precio de coste del %{0} colorante",
        priceCntPurchaseByName: "Precio de coste de los colorantes por nombre",
        priceCntSell: "Precio de venta de colorantes",
        priceCntSellByColorantName: "Precio de venta de %{0} colorante",
        priceCntSellByName: "Precio de venta de colorantes por nombre",
        priceCntSellFull: "Vender precio completo por colorantes",
        priceCntSellFullByColorantName: "Vender precio completo por %{0} colorante",
        priceCntSellFullByName: "Vender precio completo por colorantes por su nombre",
        priceGroupBarcode: "CÃ³digo de barras de grupo de precios",
        priceMarginAll: "Margen por todos los envases",
        priceMarginPerPkg: "Margen por un envase",
        priceSellPriceAll: "Precio de venta por todos los envases",
        priceSellPricePerKg: "Precio de venta por kilogramo",
        priceSellPricePerL: "Precio de venta por litro",
        priceSellPricePerPkg: "Precio de venta por envase",
        priceSurchargeAll: "Recargo por todos los envases",
        priceSurchargePerPkg: "Recargo por envase",
        priceTintPurchaseAll: "Precio de coste de colorante para todos los envases",
        priceTintPurchasePerPkg: "Precio de coste de colorante por envase",
        priceTintSellFullAll: "Precio total de venta de colorante para todos los envases",
        priceTintSellFullAllPerPackage: "Precio total de venta de colorante por envase",
        priceTotalPurchaseAll: "Precio de coste total por todos los envases",
        priceTotalPurchasePerKg: "Precio de coste total por kilogramo",
        priceTotalPurchasePerL: "Precio de coste total por litro",
        priceTotalPurchasePerPkg: "Precio de coste total por envase",
        priceTotalSellFullAll: "Precio total de venta por todos los envases",
        priceTotalSellFullPerKg: "Precio total de venta por kilogramo",
        priceTotalSellFullPerLiter: "Precio total de venta por litro",
        priceTotalSellFullPerPackage: "Precio total de venta por envase"
    },
    pricing: {
        allBases: "Todas las bases",
        allPackages: "Todos los envases",
        backup: "Backup",
        basesOfProduct: "Bases de %{productName}",
        colorantPricing: "Precios de colorantes",
        export: "Exportar",
        import: "ImportaciÃ³n",
        packagePricing: "Precio del envase",
        packageSurcharge: "Recargo por envase",
        packages: "envases",
        packagesOfProduct: "envases de %{productName}",
        posCoeficient: "Coeficiente POS",
        priceGroupPricePerLiter: "Grupo de precios precio por litro",
        priceGroups: "Grupos de precios",
        pricePerLiter: "Precio por litro",
        productPricing: "Precios del producto",
        purchasePrice: "Precio de compra",
        purchasePricePerLiter: "Precio de compra por litro",
        sellPrice: "Precio de venta",
        surcharge: "Recargo"
    },
    print: {
        adminRightsRequired: "Se requieren derechos de administrador para editar o crear una nueva plantilla.",
        allowAutomaticPrint: "ImpresiÃ³n automÃ¡tica",
        allowPrintAfterDispensing: "Permitir imprimir despuÃ©s de dispensar",
        allowPrintBeforeDispensing: "Permitir la impresiÃ³n antes de dispensar",
        automaticPrint: "Imprimir automÃ¡ticamente",
        choosePrinter: "Impresora",
        chooseSettings: "Editar configuraciÃ³n",
        chooseTemplate: "Modelo",
        copies: "Copias",
        createTemplate: "Crear plantilla",
        createTemplateHint: "Cree una nueva plantilla desde cero. GuÃ¡rdelo en la carpeta de plantillas y reinicie RCC.",
        defaultPrinter: "Impresora predeterminada",
        defaultSettings: "ConfiguraciÃ³n predeterminada",
        defaultTemplate: "Plantilla predeterminada",
        editTemplate: "Editar plantilla",
        editTemplateHint: "Edite %{name}. Los cambios serÃ¡n visibles despuÃ©s del reinicio del RCC.",
        noEditTemplate: "Sin plantilla para editar",
        noPrinterSelected: "No se ha seleccionado ninguna impresora",
        noPrintersAvailable: "No hay impresoras disponibles",
        noTemplateSelected: "No se ha seleccionado ninguna plantilla",
        noTemplatesAvailable: "No hay modelos disponibles",
        numberOfCopies: "NÃºmero de copias",
        openTemplateEditor: "Editor de plantillas abierto",
        printAfterDispensing: "Imprimir despuÃ©s de dispensar",
        printAsImage: "Imprimir como imagen",
        printBeforeDispensing: "Imprimir antes de dispensar",
        printOnRequest: "Imprimir por peticiÃ³n",
        printOptions: "Opciones de impresiÃ³n",
        printPagesAfterDispensing: "NÃºmero de copias de etiquetas",
        printPagesBeforeDispensing: "NÃºmero de copias de etiquetas",
        printPreview: "Vista previa de impresiÃ³n",
        printSettings: "ConfiguraciÃ³n de impresiÃ³n",
        printTaskLinkVariable: "Enlazar con una variable",
        printVariable: "Variable de impresiÃ³n",
        printerName: "Nombre de la impresora",
        printerOptions: "Opciones de impresora",
        printerSettings: "ConfiguraciÃ³n de la impresora",
        quickTintTemplate: "Plantilla de tintado rÃ¡pido",
        setDefaultPrinter: "Establecer impresora predeterminada",
        setDefaultTemplate: "Establecer plantilla predeterminada",
        setQuickTintTemplate: "Establecer plantilla de tintado rÃ¡pido",
        showPreviewDialogBeforePrint: "Mostrar cuadro de diÃ¡logo de vista previa antes de imprimir",
        template: "Modelo",
        templateName: "Nombre de la plantilla",
        templateSettings: "ConfiguraciÃ³n de plantilla"
    },
    printTemplate: {
        baseCode: "CÃ³digo de base",
        baseName: "Nombre de base",
        bfs: "BFS",
        colorantType: "Tipo de colorante",
        customerCity: "Ciudad del cliente",
        customerEmail: "Correo electrÃ³nico del cliente",
        customerName: "Nombre del cliente",
        customerPhone: "TelÃ©fono del cliente",
        customerStreet: "Calle del cliente",
        customerZipCode: "CÃ³digo postal del cliente",
        destinationOfUse: "Destino de uso",
        infoBfsGrade: "Grado BFS",
        orderQrCode: "CÃ³digo QR",
        packageOrderCount: "Recuento de pedidos de envases",
        posAddress: "DirecciÃ³n POS",
        posAddressSecond: "DirecciÃ³n POS 2",
        posCity: "POS ciudad",
        posContact: "Contacto POS",
        posEmail: "Correo electrÃ³nico POS",
        posPhone: "POS telÃ©fono",
        posUrl: "URL de punto de venta",
        posZipCode: "POS cÃ³digo postal",
        priceBasePurchaseWithTax: "Precio de coste por base con IVA",
        priceBaseSellWithTax: "Precio de venta por base con IVA",
        priceCntPurchaseWithTax: "Precio de coste de los colorantes con IVA",
        priceCntTotalSellWithTax: "Precio de venta de colorantes con IVA",
        priceMarginAllWithTax: "Margen por todos los envases con IVA",
        priceMarginPerPkgWithTax: "Margen por envase con IVA",
        priceSellPriceAllWithTax: "Precio de venta para todos los envases con IVA",
        priceSellPricePerKgWithTax: "Precio de venta por kilogramo con IVA",
        priceSellPricePerLWithTax: "Precio de venta por litro con IVA",
        priceSellPricePerPkgWithTax: "Precio de venta por envase con IVA",
        priceSurchargeAllWithTax: "Recargo para todos los envases con IVA",
        priceSurchargePerPkgWithTax: "Recargo por envase con IVA",
        priceTintPurchaseAllWithTax: "Precio de coste de colorante para todos los envases con IVA",
        priceTintPurchasePerPkgWithTax: "Precio de coste de colorante por envase con IVA",
        priceTotalPurchaseAllWithTax: "Precio de coste total para todos los envases con IVA",
        priceTotalPurchasePerKgWithTax: "Precio de coste total por kilogramo con IVA",
        priceTotalPurchasePerLWithTax: "Precio de coste total por litro con IVA",
        priceTotalPurchasePerPkgWithTax: "Precio de coste total por envase con IVA",
        productAltName: "Producto",
        recipeInline: "FÃ³rmula"
    },
    products: {
        bases: "Bases",
        numberOfProducts: "NÃºmero de productos",
        packagesFor: "Envases por",
        sizeOfPackage: "TamaÃ±o del envase"
    },
    purgeModal: {
        purgeAll: "Purgar todo",
        purgeAllChannels: "Purgar todos los canales",
        purgeVolume: "Volumen de purga",
        startPurge: "Empezar a purgar"
    },
    qualityControl: {
        darker: "MÃ¡s oscuro",
        dispensedMeasuredFormula: "FÃ³rmula dosificada (medida)",
        lighter: "MÃ¡s claro",
        measureDispensedFormula: "Medir la fÃ³rmula dispensada para calcular delta E",
        moreBlue: "MÃ¡s azul",
        moreGreen: "MÃ¡s verde",
        moreRed: "MÃ¡s rojo",
        moreYellow: "MÃ¡s amarillo",
        pleaseContinueToFormulaCorrection: "Por favor, continÃºe con la correcciÃ³n de la fÃ³rmula",
        qualityControlFailed: "El control de calidad ha fallado!",
        qualityControlPassed: "Control de calidad aprobado"
    },
    quickTint: {
        dispensingInProgress: "DosificaciÃ³n en curso",
        dispensingIsNotAvailable: "La dosificaciÃ³n no estÃ¡ disponible",
        machineNotConnected: "La mÃ¡quina no estÃ¡ conectada",
        noColorantsSelected: "No se han seleccionado colorantes",
        noPrinterAvailable: "La impresiÃ³n no se puede llevar a cabo, ya que no hay impresora disponible.",
        noTemplateAvailable: "La impresiÃ³n no se puede llevar a cabo, ya que no hay ninguna plantilla disponible.",
        overMaxCanisterSize: "Una o mÃ¡s cantidades de colorante no son vÃ¡lidas"
    },
    quickTintSettings: {
        alphabetically: "AlfabÃ©ticamente",
        byCanister: "Por depÃ³sito",
        closeAfterDispensing: "Cerrar despuÃ©s de dispensar",
        closeBeforeDispensing: "Cerrar antes de dispensar",
        quickTintSettings: "ConfiguraciÃ³n de dosificaciÃ³n rÃ¡pida",
        sorting: "ClasificaciÃ³n",
        windowClosingRules: "Reglas de cierre de ventanas"
    },
    rccButtons: {
        abort: "cancelar",
        all: "todo",
        cancel: "cancelar",
        continue: "seguir",
        help: "ayuda",
        ignore: "ignorar",
        no: "no",
        noToAll: "no a todos",
        ok: "OK",
        postpone: "posponer",
        resume: "reanudar",
        retry: "reintentar",
        skip: "saltar",
        yes: "sÃ­",
        yesToAll: "sÃ­ a todo"
    },
    rccDialog: {
        98: "Verifique la base %{0} con el cÃ³digo de barras.",
        99: "Inserte la base %{0} y confirme (haga clic en OK).",
        100: "El dispensador estÃ¡ en estado de error, Â¿reiniciar errores?",
        101: "El dispensador estÃ¡ en estado de error, no puede continuar",
        102: "Restablecimiento fallido, no puede continuar",
        103: "La fÃ³rmula contiene un colorante no vÃ¡lido: %{0}",
        104: "La fÃ³rmula contiene colorantes no vÃ¡lidos: %{0}",
        105: "Colorante: %{0} estÃ¡ por debajo del nivel de advertencia",
        106: "Colorantes: %{0} estÃ¡n por debajo del nivel de advertencia",
        107: "Colorante: %{0} estÃ¡ por debajo del nivel crÃ­tico",
        108: "Colorantes: %{0} estÃ¡n por debajo del nivel crÃ­tico",
        109: "Colocar envase",
        110: "Colocar el envase de base: %{0} para la fÃ³rmula: %{1}",
        111: "Quitar envase",
        112: "Â¿Perforar el envase?",
        113: "Reiniciando los errores, espere, por favor",
        114: "Estante en movimiento, por favor, espere",
        115: "Perforando el envase, por favor, espere",
        116: "FÃ³rmula de dosificaciÃ³n %{0}, espere, por favor |Envases: %{1} of %{2}|Producto: %{3}|Base: %{4}| TamaÃ±o de envase: %{5}",
        117: "FÃ³rmula de dosificaciÃ³n %{0}, espere, por favor |Envases: %{1} of %{2}|Producto: %{3}|Base: %{4}| TamaÃ±o de envase: %{5}",
        118: "Dispensando, espere, por favor|Package: %{0} of %{1}",
        119: "Dispensando, espere, por favor|Package: %{0} of %{1}",
        120: "Cancelando la dosificaciÃ³n, espere, por favor",
        121: "Validar el cÃ³digo de barras de el envase",
        122: "Validar cÃ³digo de barras de envase base|Producto: %{0}|Base: %{1}|TamaÃ±o de envase: %{2}",
        123: "El proceso de dosificaciÃ³n se ha cancelado, Â¿desea reanudar la dosificaciÃ³n?",
        124: "Se produjo un error en el dispensador %{0} : %{1}. Â¿Quiere reanudar la dosificaciÃ³n?",
        125: "AsegÃºrese de que el envase utilizada anteriormente estÃ© colocada",
        126: "AsegÃºrese de usar un envase nuevo, ya que el proceso de dosificaciÃ³n comenzarÃ¡ desde cero.",
        127: "Colorante: %{0} estÃ¡ por debajo de la cantidad de dosificaciÃ³n mÃ­nima. Â¿Quiere continuar a pesar de esta advertencia?",
        128: "Colorantes: %{0} estÃ¡n por debajo de la cantidad de dosificaciÃ³n mÃ­nima. Â¿Quiere continuar a pesar de esta advertencia?",
        129: "La fÃ³rmula seleccionada rompe la regla de sobrellenado, cantidad total de colorantes: %{0} %{1}, cantidades mÃ¡ximas permitidas de colorantes: %{2} %{3}. Â¿Quiere continuar a pesar de esta advertencia?",
        130: "El dispensador estÃ¡ en estado de error, Â¿reiniciar errores?",
        131: "El dispensador estÃ¡ en estado de error, no puede continuar",
        132: "Restablecimiento fallido, no puede continuar",
        133: "La fÃ³rmula de purga estÃ¡ vacÃ­a, no puede continuar",
        134: "La fÃ³rmula de purga contiene elementos que no se pueden purgar, Â¿desea continuar?",
        135: "Coloque el envase para purgar",
        136: "Retire el envase para purgar",
        137: "Reiniciando los errores, espere, por favor",
        138: "Estante en movimiento, por favor, espere",
        139: "Purgando, por favor, espere",
        140: "Purgando, por favor, espere",
        141: "Cancelando la purga, por favor, espere",
        142: "Falta el envase para purgar, compruebe que el envase estÃ© colocada correctamente",
        143: "La fÃ³rmula de purga contiene elementos que no se pueden purgar, Â¿desea continuar?",
        144: "Coloque el envase para purgar",
        145: "Preparando, por favor, espere",
        146: "Terminando, por favor, espere",
        150: "Limpieza, por favor, espere",
        151: "Limpieza, por favor, espere",
        152: "Cancelando la limpieza, por favor, espere",
        160: "Recirculando, por favor, espere",
        161: "Recirculando, por favor, espere",
        162: "Cancelando la recirculaciÃ³n, por favor, espere",
        170: "Removiendo, por favor, espere",
        171: "Removiendo, por favor, espere",
        172: "Cancelando la remociÃ³n, por favor, espere",
        180: "Inicializando la conexiÃ³n al dispensador, espere, por favor",
        181: "No se puede establecer la conexiÃ³n con el dispensador %{0}: %{1}",
        182: "No se puede establecer la conexiÃ³n con el dispensador. Consulte los archivos de registro para obtener mÃ¡s informaciÃ³n.",
        183: "Al dispensador le falta colorante: %{0} que se define en la base de datos",
        184: "Al dispensador le faltan colorantes: %{0} que se definen en la base de datos",
        185: "Cerrando la conexiÃ³n con el dispensador, espere, por favor",
        190: "Cierre la ventana de servicio para continuar.",
        200: "Restableciendo, espere",
        201: "Restablecimiento completo, espere, por favor",
        202: "Inicializando, espere",
        203: "Reiniciando los errores, espere, por favor",
        205: "Apertura de la tapa automÃ¡tica, espere, por favor",
        206: "Cierre de la tapa automÃ¡tica, espere, por favor",
        207: "La tapa automÃ¡tica estÃ¡ en movimiento, espere, por favor",
        210: "Perforando, por favor, espere",
        211: "Conectando, por favor, espere",
        215: "Moviendo el estante hacia arriba, por favor, espere",
        216: "Moviendo el estante hacia abajo, por favor, espere",
        217: "Estante en movimiento, por favor, espere",
        220: "Moviendo la mesa a la posiciÃ³n de relleno: %{0}, espere, por favor",
        221: "Moviendo la mesa a la posiciÃ³n original, por favor, espere",
        222: "Moviendo la mesa, por favor, espere",
        230: "Dispensador ocupado, espere, por favor",
        240: "Vuelva a llenar el recipiente %{0}",
        241: "Vuelva a llenar el recipiente %{0}",
        242: "Posicionando el depÃ³sito: %{0} (%{1}) a la posiciÃ³n de relleno",
        243: "Por favor, rellene el depÃ³sito %{0} usando cÃ³digo de barras",
        244: "Por favor, rellene el depÃ³sito %{0} usando cÃ³digo de barras",
        250: "Retire el recipiente del cepillo, lÃ­mpielo y llÃ©nelo con agua segÃºn las instrucciones.",
        251: "Vuelva a colocar el recipiente del cepillo",
        254: "Abriendo la tapa automÃ¡tica",
        255: "Limpiar la tapa automÃ¡tica de acuerdo con las instrucciones.",
        256: "Confirme cuando la limpieza haya terminado y la tapa automÃ¡tica vuelva a estar en su lugar",
        257: "Cerrando la tapa automÃ¡tica",
        260: "Retire la placa del interruptor y lÃ­mpiela",
        261: "Vuelva a colocar la placa del interruptor",
        265: "Limpie la mÃ¡quina con un paÃ±o y elimine todo el colorante u otro lÃ­quido derramado",
        266: "Confirmar cuando termine",
        270: "Vuelva a llenar el recipiente de agua del humidificador y confirme cuando haya terminado.",
        271: "Vuelva a llenar el recipiente de agua del humidificador y confirme cuando haya terminado.",
        272: "El nivel de agua sigue bajo, revÃ­selo de nuevo.",
        273: "El nivel de agua sigue bajo, revÃ­selo de nuevo.",
        274: "Verifique el nivel de agua en el recipiente del humidificador y vuelva a llenar si es necesario",
        275: "Por favor, espere",
        280: "Reiniciando el ordenador",
        281: "Apagando el ordenador",
        300: "Falta la base, compruebe que el envase estÃ© colocada correctamente",
        301: "Preparando, por favor, espere",
        302: "Terminando, por favor, espere",
        303: "La fÃ³rmula no se puede dispensar ya que contiene colorante: %{0} que es mÃ¡s de la cantidad mÃ¡xima de dosificaciÃ³n definida para el depÃ³sito",
        304: "La fÃ³rmula no se puede dispensar ya que contiene colorantes: %{0} que son cantidades de dosificaciÃ³n superiores al mÃ¡ximo definidas para los depÃ³sitos",
        305: "Colorante: %{0} no se puede dispensar a la vez, Â¿desea dividir la fÃ³rmula?",
        306: "Colorantes: %{0} no se pueden dispensar a la vez, Â¿desea dividir la fÃ³rmula?",
        307: "Colorante: %{0} no serÃ¡ dispensado por el dispensador, Â¿desea continuar y agregarlo manualmente?",
        308: "Colorantes: %{0} no serÃ¡n dosificados por el dispensador, Â¿desea continuar y agregarlos manualmente?",
        309: "La fÃ³rmula seleccionada estÃ¡ vacÃ­a, utilice el envase de base tal como estÃ¡",
        310: "No se dispensarÃ¡ el colorante, prepare el envase de base para la adiciÃ³n manual de colorantes",
        311: "Retire el envase de base y prepÃ¡rese para la adiciÃ³n manual de colorantes",
        312: "Agregue manualmente %{0} %{1} de colorante: %{2}, confirme cuando haya terminado",
        313: "Dispensar manualmente la fÃ³rmula",
        314: "La fÃ³rmula seleccionada rompe la regla de sobrellenado, cantidad total de colorantes: %{0} %{1}, cantidades mÃ¡ximas permitidas de colorantes: %{2} %{3}. Â¿Quiere continuar a pesar de esta advertencia?",
        315: "Escanear o escribir cÃ³digo UFI de el envase de base",
        316: "Escanear o escribir cÃ³digo UFI de el envase de base|Producto: %{0}|Base: %{1}|TamaÃ±o de el envase: %{2}",
        317: "Prepare colorante: %{0} para adicciÃ³n manual, confirme cuando estÃ© hecho",
        318: "Prepare colorantes: %{0} para adicciÃ³n manual, confirme cuando estÃ© hecho",
        319: "AÃ±ade colorante manualmente: %{0}, confirme cuando estÃ© hecho",
        320: "AÃ±ade colorantes manualmente: %{0}, confirme cuando estÃ© hecho",
        400: "Se iniciarÃ¡ la tarea de purga automÃ¡tica",
        401: "Se iniciarÃ¡ la tarea de purga automÃ¡tica",
        405: "El contenedor de cepillos necesita mantenimiento",
        406: "El contenedor de cepillos necesita mantenimiento",
        410: "Se iniciarÃ¡ el mantenimiento de la tapa automÃ¡tica",
        411: "Se iniciarÃ¡ el mantenimiento de la tapa automÃ¡tica",
        415: "La placa del interruptor debe limpiarse",
        416: "La placa del interruptor debe limpiarse",
        420: "El dispensador debe limpiarse",
        421: "El dispensador debe limpiarse",
        425: "Se iniciarÃ¡ el relleno de los depÃ³sitos",
        426: "Se iniciarÃ¡ el relleno de los depÃ³sitos",
        430: "Se ha programado el reinicio del equipo",
        431: "Se ha programado el reinicio del equipo",
        435: "Se ha programado el apagado del ordenador",
        436: "Se ha programado el apagado del ordenador",
        440: "Se ha programado la limpieza del dispensador",
        441: "Se ha programado la limpieza del dispensador",
        445: "Se ha programado la recirculaciÃ³n del dispensador",
        446: "Se ha programado la recirculaciÃ³n del dispensador",
        450: "Se ha programado la remociÃ³n del dispensador",
        451: "Se ha programado la remociÃ³n del dispensador",
        990: "Se produjo un error en el dispensador %{0} : %{1}. Â¿Quiere reintentar la tarea?",
        991: "OcurriÃ³ un error interno: %{0}",
        200000001: "Colocar envase",
        200000002: "Quitar envase",
        200000003:
            "Cantidad para '%{0}' por debajo de la cantidad de dosificaciÃ³n mÃ­nima, Â¿continuar bajo su propio riesgo?",
        200000004: "Rellenar '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "Ruta de la base de datos",
        dispenser: "Dispensador",
        dispenserConfigurationFile: "Archivo de configuraciÃ³n del dispensador",
        driverPath: "Ruta del driver",
        extensionPath: "Ruta de extensiÃ³n",
        folder: "Carpeta",
        formulaPath: "Ruta de la fÃ³rmula",
        host: "Host",
        iddPath: "Archivo de configuraciÃ³n IDD",
        italtintoPath: "Ruta de configuraciÃ³n de Italtinto",
        lldPath: "Directorio raÃ­z HLD",
        machineType: "Tipo de mÃ¡quina",
        noMachineAvailable: "No hay mÃ¡quina disponible",
        protocolVersion: "VersiÃ³n del protocolo",
        rccDriverSettings: "ConfiguraciÃ³n del controlador",
        resultPath: "Ruta de resultado",
        save: "Guardar ajustes",
        saveSettingsWarning:
            "Â¡Advertencia! Los cambios en esta secciÃ³n podrÃ­an causar un mal funcionamiento del dispensador.",
        serviceSwPath: "Ruta del software de servicio",
        simulationPath: "Ruta de simulaciÃ³n"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Permitir la adiciÃ³n manual de colorante",
        ask: "Pedir",
        canHandlingOptions: "Opciones de manejo de envases",
        checkCanBeforeDispense: "Revise el envase antes de dispensar",
        checkOverfill: "Compruebe el sobrellenado",
        colorantBatchNumbers: "NÃºmeros de lote de colorante",
        colorantPackageValidation: "Solo validaciÃ³n de envases de colorantes",
        disable: "Desactivar",
        dispenseInvalidColorants: "Dispensar colorantes invÃ¡lidos",
        dispensingOptions: "Opciones de dosificaciÃ³n",
        enable: "Permitir",
        enableUserIdentification: "IdentificaciÃ³n del usuario",
        fullValidation: "ValidaciÃ³n completa",
        machineAccuracyWarning: "Advertencia de precisiÃ³n de la mÃ¡quina",
        machineOptions: "Opciones de mÃ¡quina",
        machineUnit: "Unidad de mÃ¡quina",
        minimalDispenseAmount: "Cantidad de dosificaciÃ³n mÃ­nima",
        placeCanSensor: "Coloque el sensor de envase",
        placeCanSensorDelay: "Coloque el sensor de retraso de envase",
        rccMachineSettings: "Configuraciones de la mÃ¡quina",
        refillBarcodeValidation: "ValidaciÃ³n de relleno por cÃ³digo de barras",
        refillBarcodeValidationCanisterAndColorant: "Validar Canister y envase del Colorante",
        refillBarcodeValidationColorant: "Validar solo el envase del Colorante",
        refillSettings: "ParÃ¡metros de relleno",
        removeCanSensor: "Retire el sensor de envase",
        removeCanSensorDelay: "Retire el sensor de retraso de envase",
        save: "Guardar ajustes",
        sec: "seg.",
        skipPlaceCanDialog: "Omitir el diÃ¡logo de colocaciÃ³n de envase",
        skipRemoveCanDialog: "Omitir el diÃ¡logo de retirada de envase",
        splitFormula: "FÃ³rmula dividida",
        tmcEnabled: "Habilitar TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "ValidaciÃ³n del cÃ³digo de barras de el envase de base",
        validateBarcodeRefill: "ValidaciÃ³n de cÃ³digos de barras de relleno",
        validateColorantsDuringInit: "Validar colorantes durante la inicializaciÃ³n"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Hay acciones ejecutÃ¡ndose en la mÃ¡quina",
        addLevel: "AÃADIR NIVEL",
        addManually: "AÃ±adir manualmente",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) no tiene ningÃºn cÃ³digo de barras asignado.",
        cancel: "CANCELAR",
        dispenseFormula: "Dispensar fÃ³rmula",
        dispenserIdle: "La mÃ¡quina estÃ¡ inactiva",
        dispenserIsBusy: "La mÃ¡quina estÃ¡ ocupada",
        dispenserIsIdle: "La mÃ¡quina estÃ¡ inactiva",
        dispenserIsReady: "La mÃ¡quina estÃ¡ lista para mÃ¡s tareas",
        dispensingFormula: "Dispensando la fÃ³rmula",
        errorCode: "CÃ³digo de error",
        explanation: "ExplicaciÃ³n",
        fillToMax: "Llenar al mÃ¡ximo",
        finished: "Terminado",
        inProgress: "En curso",
        machineIsReady: "La mÃ¡quina estÃ¡ lista",
        moveToFill: "Mover para llenar",
        noMachineDialog: "No hay ninguna mÃ¡quina conectada",
        of: "de",
        packageSize: "TamaÃ±o del envase",
        placeBaseCan: "Coloque el envase de base",
        pleaseCheckYourMachineConnection: "Compruebe la conexiÃ³n de su mÃ¡quina.",
        pleaseRefill: "Rellene, por favor",
        solution: "SoluciÃ³n",
        subErrors: "Sub errores",
        timeToEnd: "Tiempo para terminar",
        tintingFormula: "FÃ³rmula de tintado",
        tintingPleaseWait: "Tintando, por favor, espere",
        validateBaseCan: "Validar el envase de base",
        waiting: "Esperando"
    },
    rccSettigns: {
        rccSettigns: "ConexiÃ³n RCC",
        rccUrl: "RCC Url"
    },
    rccSpectroDialog: {
        100: "Conectando a su dispositivo a travÃ©s de Bluetooth. AsegÃºrese de tener Bluetooth habilitado y de que su instrumento estÃ© encendido.",
        101: "El instrumento no se ha detectado. Â¿Quiere volver a intentarlo?",
        110: "AsegÃºrese de que Nano estÃ© conectado y presione el botÃ³n del instrumento para iniciar la inicializaciÃ³n",
        111: "Nano no se ha detectado. Â¿Quiere volver a intentarlo?",
        112: "Desconecte Nano, espere 10 segundos, vuelva a conectarlo y continÃºe",
        120: "Conectando a su dispositivo, espere",
        121: "El instrumento no se ha detectado. Â¿Quiere volver a intentarlo?",
        200: "Coloque el instrumento sobre la placa negra y continÃºe o presione el botÃ³n del instrumento",
        201: "Coloque el instrumento sobre la placa negra y continÃºe",
        202: "Coloque el instrumento sobre la placa negra y presione el botÃ³n del instrumento",
        205: "Coloque el instrumento en la placa blanca y continÃºe o presione el botÃ³n del instrumento",
        206: "Coloque el instrumento en la placa blanca y continÃºe",
        207: "Coloque el instrumento en la placa blanca y presione el botÃ³n del instrumento",
        210: "Coloque el instrumento en la placa de diagnÃ³stico y continÃºe o presione el botÃ³n del instrumento",
        211: "Coloque el instrumento en la placa de diagnÃ³stico y continÃºe",
        212: "Coloque el instrumento en la placa de diagnÃ³stico y presione el botÃ³n del instrumento",
        215: "Cierre la tapa del instrumento y continÃºe o presione el botÃ³n del instrumento",
        216: "Cierre la tapa del instrumento y continÃºe",
        217: "Cierre la tapa del instrumento y presione el botÃ³n del instrumento",
        220: "Coloque el instrumento en la placa cero y continÃºe o presione el botÃ³n del instrumento",
        221: "Coloque el instrumento en la placa cero y continÃºe",
        222: "Coloque el instrumento en la placa cero y presione el botÃ³n del instrumento",
        224: "Coloque el instrumento en la almohadilla de calibraciÃ³n y continÃºe o pulse el botÃ³n del instrumento",
        225: "Coloque el instrumento en la almohadilla de calibraciÃ³n y continÃºe",
        226: "Coloque el instrumento en la almohadilla de calibraciÃ³n y pulse el botÃ³n del instrumento",
        227: "Coloque el instrumento en la almohadilla de calibraciÃ³n y pulse el botÃ³n del instrumento",
        295: "Finalice la calibraciÃ³n en la ventana del controlador",
        296: "El instrumento no estÃ¡ conectado, Â¿desea abrir la conexiÃ³n con Ã©l?",
        297: "PreparÃ¡ndose para el paso de calibraciÃ³n, espere",
        298: "Calibrando, espere",
        299: "Finalizando el paso de calibraciÃ³n, espere",
        300: "Coloque el instrumento en la muestra y continÃºe o presione el botÃ³n del instrumento",
        301: "Coloque el instrumento en la muestra y continÃºe",
        302: "Coloque el instrumento sobre la muestra y presione el botÃ³n del instrumento",
        303: "El instrumento no estÃ¡ calibrado, Â¿desea proceder a la calibraciÃ³n?",
        304: "El instrumento no estÃ¡ conectado, Â¿desea abrir la conexiÃ³n con Ã©l?",
        390: "Seleccionar modo de medida",
        395: "Termine de medir en la ventana del conductor",
        397: "PreparÃ¡ndose para medir, espere",
        398: "Midiendo, por favor, espere",
        399: "Terminando de medir, espere",
        498: "Descargando la mediciÃ³n, espere",
        499: "Descargando todas las medidas, espere",
        900: "Se produjo un error de instrumento %{0} : %{1}. Â¿Quiere reintentar la tarea?",
        901: "OcurriÃ³ un error interno: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "El ordenador tiene que tener conexiÃ³n Bluetooth. El espectrofotÃ³metro tiene que ser vinculado con el ordenador. Se requiere Windows 10 con actualizaciÃ³n automÃ¡tica de 2018.",
        DatacolorSilent:
            "Cuando se utiliza el modo silencioso, las ventanas Datacolor se muestran directamente en %{name}. En estas ventanas, los parÃ¡metros de espectrofotÃ³metro no se pueden cambiar.",
        DatacolorUseDiagnosticTile: "El uso de placas de diagnÃ³stico mejora la calidad de mediciÃ³n.",
        comPort: "Puerto COM",
        diagnosticTile: "Datacolor usa placa de diagnÃ³stico",
        measureModes: "Modos de medida",
        measureModesOrder: "Orden de modos de medida",
        model: "Modelo",
        noSpectroAvailable: "No hay espectrofotÃ³metro disponible",
        rccSpectroSettings: "Ajustes del espectrofotÃ³metro",
        save: "Guardar ajustes",
        silent: "Datacolor Silent",
        simulationPath: "Ruta de simulaciÃ³n",
        spectroType: "Tipo de espectrofotÃ³metro",
        useProfiledValues: "Usar valores de perfil"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recircular todos los canales",
        recirculateChannels: "Canales de recirculaciÃ³n",
        recirculatingSpeed: "Velocidad de recirculaciÃ³n",
        recirculatingTime: "Tiempo de recirculaciÃ³n",
        startRecirculating: "Empezar a recircular"
    },
    redlikeLight: {
        finishPreviousSteps: "Finalice los pasos anteriores",
        searchBySpectro: "Buscar por espectrofotÃ³metro",
        searchFormula: "FÃ³rmula de bÃºsqueda",
        selectBase: "Seleccionar base",
        selectColor: "Seleccionar el color",
        selectCustomer: "Seleccionar cliente",
        selectFandeck: "Seleccionar carta de colores",
        selectPackage: "Seleccionar envase",
        selectProduct: "Seleccionar producto",
        startSelectFandeck: "Comience seleccionando carta de colores",
        startSelectProduct: "Empiece por seleccionar el producto",
        stepByStepProgress: "Puede progresar paso a paso",
        typeHereToSearch: "Escriba aquÃ­ para buscar",
        typeToFilter: "Escriba para filtrar"
    },
    restartModal: {
        computerNeedsRestart: "Â¡El ordenador necesita reiniciarse!",
        notCompletelyTranslated:
            "El cambio de idioma requiere reiniciar el software. Es posible que algunas partes del software no se traduzcan por completo en este momento.",
        restartIsRequired: "Una vez realizados los cambios, es necesario reiniciar el software.",
        softwareNeedsRestart: "Â¡%{name} necesita reiniciarse!"
    },
    searchPanel: {
        basePlaceholder: "o escriba un nombre base",
        baseStartPlaceholder: "Comience escribiendo el nombre de base",
        colorCodeNamePlaceholder: "o escriba un cÃ³digo/nombre de fÃ³rmula",
        colorCodeNameStartPlaceholder: "Comience escribiendo un cÃ³digo/nombre de fÃ³rmula",
        colorCodePlaceholder: "o escriba un cÃ³digo de fÃ³rmula",
        colorCodeStartPlaceholder: "Comience escribiendo un cÃ³digo de fÃ³rmula",
        colorNameCodePlaceholder: "o escriba un nombre/cÃ³digo de fÃ³rmula",
        colorNameCodeStartPlaceholder: "Comience escribiendo un nombre/cÃ³digo de fÃ³rmula",
        colorNamePlaceholder: "o escriba un nombre de fÃ³rmula",
        colorNameStartPlaceholder: "Comience escribiendo un nombre de fÃ³rmula",
        colorPreviewIsNotAvailable:
            "La vista previa del color no estÃ¡ disponible. Seleccione una Carta de Color para ver una vista previa del color relevante.",
        fandeckPlaceholder: "o escribe un nombre de carta de colores",
        fandeckStartPlaceholder: "Comience escribiendo un nombre de carta de colores",
        formulaByColor: "FÃ³rmula por color",
        noResultsFound: "No se han encontrado resultados",
        packagePlaceholder: "o escriba un nombre de envase",
        packageStartPlaceholder: "Comience escribiendo un nombre de envase",
        productPlaceholder: "o escriba el nombre de un producto",
        productStartPlaceholder: "Comience escribiendo el nombre de un producto",
        standard: "Estandar",
        typeFandeckToFilter: "Escriba aquÃ­ para filtrar por nombre de la carta de colores",
        typeProductToFilter: "Escriba aquÃ­ para filtrar por nombre de producto"
    },
    sendOrderModal: {
        customNote: "Nota personalizada",
        noCompatibleServers: "No hay servidores compatibles disponibles en su red",
        orderOverview: "Resumen de pedidos",
        selectTargetMachine: "Seleccione la mÃ¡quina de destino",
        sendOrder: "Enviar pedido",
        sendOrderTo: "Su pedido se enviarÃ¡ a %{serverName}",
        targetMachine: "MÃ¡quina de destino"
    },
    server: {
        computerId: "ID de ordenador",
        ip: "IP",
        selectServer: "Seleccione uno de los servidores disponibles",
        server: "Servidor"
    },
    serverDialog: {
        1: "Hay un error en la definiciÃ³n de marca de su licencia. CompruÃ©belo con su proveedor.",
        2: "No se han podido procesar los datos de %{0}: %{1}",
        3: "Ruta de red no vÃ¡lida.",
        4: "Tipo de ruta no vÃ¡lido (sÃ³lo se admiten los tipos %{0} y %{1})",
        5: "Error al escribir el archivo de tintado.",
        6: "El archivo de tintado se ha creado correctamente.",
        7: "No se pudo encontrar el colorante con el nombre: '%{0}' en la fila '%{1}'",
        8: "No se pudo encontrar el paquete con el nombre: '%{0}' en la fila '%{1}'",
        9: "No se pudo encontrar la base en el producto con nombre de producto: '%{0}' y nombre de base: '%{1}' en la fila '%{2}'.",
        10: "No se pudo encontrar la base en el paquete de productos con nombre de producto: '%{0}', nombre de base: '%{1}' y nombre de envase: '%{2}' en la fila '%{3}'.'",
        11: "No se ha podido analizar el valor del precio: '%{0}' en la fila '%{1}' de la hoja '%{2}'.",
        12: "Preparando datos de bases, por favor espere",
        13: "Preparando bases en datos de productos, por favor espere",
        14: "Preparando datos de envases base, por favor espere",
        15: "Preparando datos de colores, por favor espere",
        16: "Preparando colores en los datos de cartas de colores, por favor espere",
        17: "Preparando datos de cartas de colores, por favor espere",
        18: "Preparando datos para la bÃºsqueda global, por favor espere",
        19: "Preparando datos de productos, por favor espere",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Las actualiaciones parciales no pueden ser aplicadas en la base de datos '%{0}'. Las versiones de la base de datos no coinciden. PÃ³ngase en contacto con su soporte tÃ©cnico.",
        32: "Las actualiaciones parciales no pueden ser aplicadas en la base de datos '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. Las versiones de la base de datos no coinciden. PÃ³ngase en contacto con el servicio tÃ©cnico.",
        34: "Error desconocido durante la actualizaciÃ³n parcial. Si el error se reite contacte con el servicio tÃ©cnico.",
        35: "Actualizaciones parciales no disponibles. Compruebe su conexiÃ³n o contacte con el servicio interno.",
        36: "Preparadas actualizaciones parciales para la base de datos '%{0}' para la versiÃ³n mÃ¡s nueva de Redlike. Actualice su Redlike a la Ãºltima tversiÃ³n. La versiÃ³n mÃ­nima requerida es '%{1}'.",
        37: "No se pueden preparar las actualizaciones parciales. No hay suficiente espacio en el disco. El espacio mÃ­nimo requerido es 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Plugins de servidor activos",
        currentlyActive: "Los plugins actualmente activos",
        plugin: "Plugin",
        pluginName: "Nombre del plugin",
        statusActive: "Activo",
        statusInactive: "Inactivo"
    },
    serviceActionsSettings: {
        canisterLevel: "Niveles de depÃ³sito",
        capClose: "Cerca",
        capMiddle: "Medio",
        capOpen: "Abierto",
        cleanAllChannels: "Limpiar todo",
        cleanChannels: "Limpiar canales",
        computer: "Ordenador",
        computerReboot: "Reinicio del equipo",
        computerShutdown: "Apagado del ordenador",
        connectMachine: "Conectar la mÃ¡quina",
        general: "General",
        initialize: "Inicializar",
        noMachineIsConnected: "No hay ninguna mÃ¡quina conectada",
        plug: "Enchufe",
        plugger: "Plugger",
        punch: "Perforar",
        puncher: "Perforadora",
        purgeChannels: "Canales de purga",
        recirculate: "Recircular",
        recirculateAllChannels: "Recircular todo",
        recirculateChannels: "Recircular canales",
        serviceActions: "Acciones de mantenimiento",
        setCanisterLevel: "Establecer niveles de recipiente",
        shelfDown: "Estante abajo",
        shelfUp: "Estante arriba",
        showServiceWindow: "Mostrar ventana de mantenimiento",
        smartPurgeAllChannels: "Purga inteligente de todos los canales",
        smartPurgeChannels: "Purga inteligente de canales",
        startErrorReset: "Iniciar restablecimiento de errores",
        startHardReset: "Iniciar restablecimiento completo",
        startReset: "Iniciar reinicio",
        stirAllCanisters: "AgitaciÃ³n de todos los depÃ³sitos",
        stirCanisters: "AgitaciÃ³n depÃ³sito",
        stirCanistersMore: "AgitaciÃ³n depÃ³sitos"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Plano",
        gloss: "Brillo",
        matt: "Mate",
        matte: "Mate",
        pearl: "Perlado",
        satin: "Satinado",
        selectGlossLevel: "Compare la muestra de color con la escala de brillo y seleccione el nivel de brillo",
        semiGloss: "Semi-Brillo"
    },
    spectroTab: {
        bestMatch: "La mejor coincidencia",
        calibrate: "Calibrar",
        calibrateInstrument: "Instrumento calibrado",
        connectDevice: "Conectar dispositivo",
        connectedTo: "Conectado a",
        connectingDevice: "Conectando su dispositivo",
        deselectAll: "Deseleccionar todo",
        deviceCalibrated: "Su dispositivo ha sido calibrado y puede empezar a medir",
        deviceIsNotCalibrated: "Su dispositivo no estÃ¡ calibrado",
        eraseResult: "Borrar el resultado",
        filter: "Filtrar",
        foundInFormulas: "Encontrado en fÃ³rmulas",
        inactiveSpectro: "La funciÃ³n Espetro no estÃ¡ disponible para la marca seleccionada.",
        instrumentCalibration: "Su instrumento necesita ser calibrado.",
        manualInput: "Entrada manual",
        measure: "Medir",
        measurementResult: "Resultado de medida",
        noFilters: "No hay filtros disponibles",
        noFormulas: "No se encontraron fÃ³rmulas",
        noSelectedSpectro: "NingÃºn espectrofotÃ³metro seleccionado",
        notSelected: "No seleccionado",
        pressConnectButton: "AsegÃºrese de que su dispositivo estÃ© conectado y presione el botÃ³n de conexiÃ³n",
        searchFormulas: "Buscar fÃ³rmulas",
        selectSpectro: "Seleccionar espectrofotÃ³metro",
        showDetails: "Mostrar detalles",
        skipCalibration: "Omitir la calibraciÃ³n",
        spectroIsConnected: "espectrofotÃ³metro estÃ¡ conectado",
        spectroIsReady: "El espectrofotÃ³metro estÃ¡ listo",
        spectroReady: "El dispositivo estÃ¡ listo para mÃ¡s tareas",
        startCalibrateNow: "Comience a calibrar ahora",
        startMeasureText: "Su dispositivo ha sido calibrado y puede comenzar a medir",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Tolerancia Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Personalizado %{1} %{2}",
        deleteSelectedRecords: "Eliminar registros seleccionados",
        exportHistory: "Exportar el historial",
        finishFormula: "Finalizar fÃ³rmula",
        foundInFormulas: "Encontrado en fÃ³rmulas",
        hideHiddenRecords: "No mostrar registros ocultos",
        hideSelectedRecord: "Ocultar el registro seleccionado",
        historicalFormula: "FÃ³rmula histÃ³rica",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Restaurar el registro seleccionado",
        showAllRecords: "Mostrar todos los registros",
        standardFormula: "FÃ³rmula estandar",
        unknownFormula: "FÃ³rmula desconocida"
    },
    stirCanisters: {
        selectCanisters: "Seleccionar depÃ³sitos",
        startStirring: "Iniciar la agitaciÃ³n",
        stirAllCanisters: "Agitar todos los depÃ³sitos",
        stirCanisters: "Agitarlos depÃ³sitos",
        stirringSpeed: "Velocidad de agitaciÃ³n",
        stirringTime: "Tiempo de agitaciÃ³n"
    },
    stock: {
        addColorant: "AÃ±adir colorante...",
        addColorantPackagesToStock: "AÃ±adir envases de colorante a las existencias",
        addPackagesToStock: "AÃ±adir envases a las existencias",
        addedToStock: "AÃ±adido al stock",
        allDatabases: "Todas las bases de datos",
        checkStockPackageInventory:
            "Si ha utilizado un envase de stock, compruebe si su inventario de stock es vÃ¡lido..",
        clearAllItems: "Borrar todos los artÃ­culos",
        colorantInventory: "Inventario de colorantes",
        colorantsStockInventory: "Inventario de colorantes",
        confirmSendingOrder: "Confirmar el envÃ­o del pedido",
        consumptionPrediction: "PrevisiÃ³n de consumo para las prÃ³ximas %{weeks} semanas",
        createOrder: "Crear pedido (%{sum})",
        expirationDate: "Fecha de caducidad",
        inDelivery: "En entrega",
        manualOrder: "Pedido manual",
        manualOrderProgress: "Paso %{step}/%{total}",
        noPackagesFoundInStockForColorant: "No hay envases en stock para este colorante.",
        onStock: "En stock",
        orderSummary: "Resumen del pedido",
        prediction: "previsiÃ³n",
        removePackageFromStock: "Retirar envase %{colorantName} del almacÃ©n",
        removePackageNameFromStock: "Â¿Desea retirar un envase %{packageName} del stock?",
        scanBarcodeOrSelectColorant: "Escanee el cÃ³digo de barras del envase o seleccione el colorante",
        selectPackageToRemove: "Seleccione el envase que desea eliminar",
        sendConfirmed: "EnvÃ­o confirmado",
        setAmountsByPrediction: "Fijar importes por predicciÃ³n",
        sortByColorantName: "Ordenar por nombre de colorante",
        sortByOrderNeed: "Ordenar por necesidad de pedido",
        sortByStockLevel: "Ordenar por nivel de stock",
        toOrder: "Para hacer un pedido"
    },
    testBarcode: {
        noItemAssigned: "No se ha asignado ningÃºn artÃ­culo al cÃ³digo de barras %{code}",
        pleaseScanBarcode: "Escanee el cÃ³digo de barras de la base, producto, envase u otros artÃ­culos",
        testBarcodes: "Probar cÃ³digos de barras"
    },
    ticketing: {
        answer: "Respuesta",
        answered: "Respuesta",
        chooseType: "Seleccione el tipo",
        closeRequest: "Cerrar solicitud",
        comment: "Comentario",
        create: "Crear",
        createNewTicket: "Crear un nuevo ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "ReclamaciÃ³n de fÃ³rmula",
        formulaRequest: "Solicitud de fÃ³rmula",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "InformaciÃ³n del POS (nombre, ciudad) no encontrada",
        noTicketSelected: "No hay ticket seleccionado",
        openTicket: "Abrir ticket",
        posName: "POS nombre",
        posted: "Publicado en",
        request: "Solicitar",
        requestDate: "Fecha de solicitud",
        requestId: "Solicitar ID",
        resolvedBy: "Resuelto por",
        responseDate: "Fecha de respuesta",
        saveToCustomFormula: "Guardar en fÃ³rmula personal",
        sending: "EnvÃ­o de",
        service: "Service",
        successfulCreation: "Ticket creado con Ã©xito. Enviando...",
        ticketAnswered: "Se ha contestado a un ticket",
        ticketDelivered: "Se ha entregado un ticket.",
        ticketId: "Ticket ID",
        ticketType: "Tipo de ticket",
        waitingForAnswer: "Esperando respuesta"
    },
    tutorial: {
        last: "Ãltimo",
        next: "PrÃ³ximo"
    },
    ufiCodeModal: {
        currentStatus: "Estado actual",
        detailedInfoForColorant: "InformaciÃ³n detallada del colorante %{colorantName}",
        userSetUfiCode: "CÃ³digo UFI establecido por el usuario, valor actual"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "ValidaciÃ³n de cÃ³digo UFI de base",
        confirmColorantRefilling: "Confirmar el relleno del colorante",
        enableUfiCodes: "Habilitar cÃ³digos UFI",
        printUfiCode: "Imprimir si la cantidad de colorante se ha acabado",
        printUfiCodePercentage: "Porcentaje de impresiÃ³n si la cantidad de colorante se ha acabado",
        scanOrTypeUfiCode: "Escanear o escribir cÃ³digo UFI",
        scanOrTypeUfiCodeOfBase: "Escanear o escribir cÃ³digo UFI de el envase de base",
        ufiCodesByPercentage: "Usar cÃ³digos UFI por porcentaje",
        ufiCodesFromDatabase: "Usar cÃ³digos UFI de la base de datos",
        ufiCodesFromLastFilling: "Usar cÃ³digos UFI del Ãºltimo relleno"
    },
    userSettings: {
        addUser: "AÃ±adir usuario",
        assignedUserGroups: "Grupos de usuarios asignados",
        availableUserGroups: "Grupos de usuarios disponibles",
        barcode: "CÃ³digo de barras",
        confirmNewPassword: "Confirmar contraseÃ±a",
        editPassword: "Editar contraseÃ±a",
        editUser: "Editar usuario",
        enableAutoLogin: "Habilitar el inicio de sesiÃ³n automÃ¡tico",
        newPassword: "Nueva contraseÃ±a",
        noChange: "No hay ningÃºn cambio que guardar",
        oldPassword: "ContraseÃ±a antigua",
        password: "ContraseÃ±a",
        passwordsDoNotMatch: "Las contraseÃ±as no coinciden",
        restoreUser: "Este usuario ha sido eliminado. Â¿Quiere restaurarlo?",
        userGroup: "User Group",
        userGroups: "Grupos de usuarios",
        userManagement: "GestiÃ³n de usuarios",
        userSettings: "Ajustes de usuario",
        username: "Nombre de usuario",
        usernameIsMissing: "Falta nombre de usuario."
    },
    warningMissingDataModal: {
        continue: "Faltan los mismos datos, Â¿quiere continuar?",
        notFoundBase:
            "Esta base de producto no estÃ¡ disponible. Confirme y tenga cuidado de obtener la base de producto compatible de la estanterÃ­a o cancele este pedido.",
        notFoundProduct:
            "Este producto no estÃ¡ disponible. Confirme y tenga cuidado de obtener el producto compatible de la estanterÃ­a o cancele este pedido."
    },
    weekdays: {
        friday: "Viernes",
        monday: "Lunes",
        saturday: "SÃ¡bado",
        sunday: "Domingo",
        thursday: "Jueves",
        tuesday: "Martes",
        wednesday: "MiÃ©rcoles"
    },
    welcome: {
        availableDatabase:
            "El servidor no se puede conectar a la base de datos. Compruebe la configuraciÃ³n de su base de datos.",
        availableDatabaseLocalError:
            "Error durante la conexiÃ³n a la base de datos local (archivo incorrecto, contraseÃ±a no vÃ¡lida)",
        availableDatabaseLocalMissing: "Falta el archivo de base de datos local",
        availableDatabaseLocalUpdate: "La base de datos local debe actualizarse a la versiÃ³n mÃ¡s reciente.",
        availableDatabaseMainAndLocalError:
            "Error durante la conexiÃ³n a las bases de datos principal y local (archivo incorrecto, contraseÃ±a no vÃ¡lida)",
        availableDatabaseMainAndLocalMissing: "Faltan archivos de base de datos principal y local",
        availableDatabaseMainAndLocalUpdate:
            "Tanto las bases de datos principales como las locales deben actualizarse a la versiÃ³n mÃ¡s reciente.",
        availableDatabaseMainError:
            "Error durante la conexiÃ³n a la base de datos principal (archivo incorrecto, contraseÃ±a no vÃ¡lida)",
        availableDatabaseMainMissing: "Falta el archivo de base de datos principal",
        availableDatabaseMainPartialUpdate:
            "La base de datos principal debe actualizarse a la versiÃ³n mÃ¡s reciente mediante una actualizaciÃ³n parcial.",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "La base de datos principal debe actualizarse a la versiÃ³n mÃ¡s reciente mediante una actualizaciÃ³n parcial y la base de datos local debe actualizarse a la versiÃ³n mÃ¡s reciente.",
        availableDatabaseMainUpdate: "La base de datos principal debe actualizarse a la versiÃ³n mÃ¡s reciente.",
        closing: "El software se estÃ¡ cerrando",
        compatibility:
            "Compruebe la versiÃ³n de su servidor. Su cliente solo es compatible con el servidor %{0} o superior.",
        compatibilityCheck: "La verificaciÃ³n de compatibilidad estÃ¡ en curso",
        compatibilityDatabase:
            "Su base de datos no es compatible con el servidor. Compruebe la configuraciÃ³n de su base de datos.",
        connectingServer: "Conectando al servidor en %{ip}",
        databaseCompatibility: "Su base de datos no es compatible con el software actual",
        databasesCompatibility: "Sus bases de datos no son compatibles con el software actual",
        licenseVerification: "La verificaciÃ³n de la licencia estÃ¡ en curso",
        loading: "Cargando",
        lostConnection: "Se perdiÃ³ la conexiÃ³n con el servidor.",
        moduleMessage:
            "Preste atenciÃ³n a la selecciÃ³n del mÃ³dulo porque los cambios futuros del mÃ³dulo estarÃ¡n disponibles solo para usuarios seleccionados.",
        refresh: "Actualizar",
        restoring: "RestauraciÃ³n de la conexiÃ³n",
        selectModule: "Seleccione uno de los mÃ³dulos disponibles.",
        stopUpdate: "Detener actualizaciÃ³n",
        updateDatabase: "Actualizar base de datos",
        updatingDatabase: "La base de datos se estÃ¡ actualizando",
        updatingDatabases: "Las bases de datos se estÃ¡n actualizando",
        updatingWarning: "La estructura de la base de datos se estÃ¡ actualizando a la versiÃ³n mÃ¡s reciente, espere.",
        updatingWarningInfo:
            "No cierre esta ventana, ya que darÃ­a lugar a la necesidad de realizar la actualizaciÃ³n desde cero."
    }
};
